webpackJsonp([2,0],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _defineProperties = __webpack_require__(253);
	
	var _defineProperties2 = _interopRequireDefault(_defineProperties);
	
	var _assign = __webpack_require__(252);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _vue = __webpack_require__(12);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vuex = __webpack_require__(217);
	
	var _vuex2 = _interopRequireDefault(_vuex);
	
	var _App = __webpack_require__(383);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _vueResource = __webpack_require__(431);
	
	var _vueResource2 = _interopRequireDefault(_vueResource);
	
	var _vueMaterial = __webpack_require__(430);
	
	var _vueMaterial2 = _interopRequireDefault(_vueMaterial);
	
	var _vueAnalytics = __webpack_require__(379);
	
	var _vueAnalytics2 = _interopRequireDefault(_vueAnalytics);
	
	var _vueCookie = __webpack_require__(380);
	
	var _vueCookie2 = _interopRequireDefault(_vueCookie);
	
	var _router = __webpack_require__(222);
	
	var _router2 = _interopRequireDefault(_router);
	
	var _store = __webpack_require__(223);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _generated = __webpack_require__(6);
	
	var _generated2 = _interopRequireDefault(_generated);
	
	var _vueI18n = __webpack_require__(382);
	
	var _vueI18n2 = _interopRequireDefault(_vueI18n);
	
	var _en = __webpack_require__(224);
	
	var _en2 = _interopRequireDefault(_en);
	
	var _hu = __webpack_require__(227);
	
	var _hu2 = _interopRequireDefault(_hu);
	
	var _generated_en = __webpack_require__(225);
	
	var _generated_en2 = _interopRequireDefault(_generated_en);
	
	var _generated_hu = __webpack_require__(226);
	
	var _generated_hu2 = _interopRequireDefault(_generated_hu);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _vueLocalstorage = __webpack_require__(429);
	
	var _vueLocalstorage2 = _interopRequireDefault(_vueLocalstorage);
	
	__webpack_require__(297);
	
	var _vueEventCalendar = __webpack_require__(381);
	
	var _vueEventCalendar2 = _interopRequireDefault(_vueEventCalendar);
	
	__webpack_require__(322);
	
	__webpack_require__(323);
	
	__webpack_require__(324);
	
	__webpack_require__(296);
	
	__webpack_require__(325);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var define = false;
	
	_vue2.default.use(_vueResource2.default);
	_vue2.default.use(_vueMaterial2.default);
	_vue2.default.use(_vuex2.default);
	_vue2.default.use(_vueI18n2.default);
	_vue2.default.use(_vueCookie2.default);
	_vue2.default.use(_vueLocalstorage2.default);
	_vue2.default.use(_vueEventCalendar2.default, { locale: 'en' });
	
	var storedLang = _vueCookie2.default.get('lang');
	
	var messages = {
		"en": (0, _assign2.default)(_en2.default, _generated_en2.default),
		"hu": (0, _assign2.default)(_hu2.default, _generated_hu2.default)
	};
	
	var i18n = new _vueI18n2.default({
		locale: storedLang ? storedLang : navigator.language.split("-", 1)[0] || 'en',
		fallbackLocale: 'en',
		silentTranslationWarn: true,
		messages: messages
	});
	
	_vue2.default.material.registerTheme('default', {
		primary: 'deep-purple',
		accent: 'blue'
	});
	
	_generated2.default.ApiClient.instance = new _generated2.default.DefaultApi();
	_generated2.default.ApiClient.instance.apiClient.enableCookies = true;
	
	console.log(("production"));
	
	if (false) {
		_generated2.default.ApiClient.instance.apiClient.basePath = "http://localhost:3000/api";
	} else if (true) {
		_generated2.default.ApiClient.instance.apiClient.basePath = "https://pulmoment.com/api";
	
		_vue2.default.use(_vueAnalytics2.default, {
			id: 'UA-65390488-3',
			router: _router2.default
		});
	} else {
		_generated2.default.ApiClient.instance.apiClient.basePath = "http://symbidev.cloudapp.net/api";
	}
	
	_generated2.default.ApiClient.instance.apiClient.defaultHeaders["languageId"] = i18n.locale;
	
	var EventBus = new _vue2.default();
	
	(0, _defineProperties2.default)(_vue2.default.prototype, {
		$bus: {
			get: function get() {
				return EventBus;
			}
		}
	});
	
	_vue2.default.filter('formatDate', function (value) {
		if (value) {
			return (0, _moment2.default)(String(value)).format('YYYY.MM.DD. hh:mm');
		}
	});
	
	var app = new _vue2.default({
		i18n: i18n,
		router: _router2.default,
		store: _store2.default,
		render: function render(h) {
			return h(_App2.default);
		}
	}).$mount('#app');

/***/ }),
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer, module) {'use strict';
	
	var _keys = __webpack_require__(254);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _typeof2 = __webpack_require__(3);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var define = false;
	
	(function (root, factory) {
	  if (typeof define === 'function' && define.amd) {
	    define(['superagent', 'querystring'], factory);
	  } else if (( false ? 'undefined' : (0, _typeof3.default)(module)) === 'object' && module.exports) {
	    module.exports = factory(__webpack_require__(335), __webpack_require__(332));
	  } else {
	    if (!root.SymbimedApi) {
	      root.SymbimedApi = {};
	    }
	    root.SymbimedApi.ApiClient = factory(root.superagent, root.querystring);
	  }
	})(undefined, function (superagent, querystring) {
	  'use strict';
	
	  var exports = function exports() {
	    this.basePath = 'http://localhost:3000/api'.replace(/\/+$/, '');
	
	    this.authentications = {
	      'isDoctor': { type: 'basic' },
	      'isLoggedIn': { type: 'basic' },
	      'isValidated': { type: 'basic' }
	    };
	
	    this.defaultHeaders = {};
	
	    this.timeout = 60000;
	
	    this.cache = true;
	
	    this.enableCookies = false;
	
	    if (typeof window === 'undefined') {
	      this.agent = new superagent.agent();
	    }
	  };
	
	  exports.prototype.paramToString = function (param) {
	    if (param == undefined || param == null) {
	      return '';
	    }
	    if (param instanceof Date) {
	      return param.toJSON();
	    }
	    return param.toString();
	  };
	
	  exports.prototype.buildUrl = function (path, pathParams) {
	    if (!path.match(/^\//)) {
	      path = '/' + path;
	    }
	    var url = this.basePath + path;
	    var _this = this;
	    url = url.replace(/\{([\w-]+)\}/g, function (fullMatch, key) {
	      var value;
	      if (pathParams.hasOwnProperty(key)) {
	        value = _this.paramToString(pathParams[key]);
	      } else {
	        value = fullMatch;
	      }
	      return encodeURIComponent(value);
	    });
	    return url;
	  };
	
	  exports.prototype.isJsonMime = function (contentType) {
	    return Boolean(contentType != null && contentType.match(/^application\/json(;.*)?$/i));
	  };
	
	  exports.prototype.jsonPreferredMime = function (contentTypes) {
	    for (var i = 0; i < contentTypes.length; i++) {
	      if (this.isJsonMime(contentTypes[i])) {
	        return contentTypes[i];
	      }
	    }
	    return contentTypes[0];
	  };
	
	  exports.prototype.isFileParam = function (param) {
	    if (true) {
	      var fs;
	      try {
	        fs = __webpack_require__(437);
	      } catch (err) {}
	      if (fs && fs.ReadStream && param instanceof fs.ReadStream) {
	        return true;
	      }
	    }
	
	    if (typeof Buffer === 'function' && param instanceof Buffer) {
	      return true;
	    }
	
	    if (typeof Blob === 'function' && param instanceof Blob) {
	      return true;
	    }
	
	    if (typeof File === 'function' && param instanceof File) {
	      return true;
	    }
	    return false;
	  };
	
	  exports.prototype.normalizeParams = function (params) {
	    var newParams = {};
	    for (var key in params) {
	      if (params.hasOwnProperty(key) && params[key] != undefined && params[key] != null) {
	        var value = params[key];
	        if (this.isFileParam(value) || Array.isArray(value)) {
	          newParams[key] = value;
	        } else {
	          newParams[key] = this.paramToString(value);
	        }
	      }
	    }
	    return newParams;
	  };
	
	  exports.CollectionFormatEnum = {
	    CSV: ',',
	
	    SSV: ' ',
	
	    TSV: '\t',
	
	    PIPES: '|',
	
	    MULTI: 'multi'
	  };
	
	  exports.prototype.buildCollectionParam = function buildCollectionParam(param, collectionFormat) {
	    if (param == null) {
	      return null;
	    }
	    switch (collectionFormat) {
	      case 'csv':
	        return param.map(this.paramToString).join(',');
	      case 'ssv':
	        return param.map(this.paramToString).join(' ');
	      case 'tsv':
	        return param.map(this.paramToString).join('\t');
	      case 'pipes':
	        return param.map(this.paramToString).join('|');
	      case 'multi':
	        return param.map(this.paramToString);
	      default:
	        throw new Error('Unknown collection format: ' + collectionFormat);
	    }
	  };
	
	  exports.prototype.applyAuthToRequest = function (request, authNames) {
	    var _this = this;
	    authNames.forEach(function (authName) {
	      var auth = _this.authentications[authName];
	      switch (auth.type) {
	        case 'basic':
	          if (auth.username || auth.password) {
	            request.auth(auth.username || '', auth.password || '');
	          }
	          break;
	        case 'apiKey':
	          if (auth.apiKey) {
	            var data = {};
	            if (auth.apiKeyPrefix) {
	              data[auth.name] = auth.apiKeyPrefix + ' ' + auth.apiKey;
	            } else {
	              data[auth.name] = auth.apiKey;
	            }
	            if (auth['in'] === 'header') {
	              request.set(data);
	            } else {
	              request.query(data);
	            }
	          }
	          break;
	        case 'oauth2':
	          if (auth.accessToken) {
	            request.set({ 'Authorization': 'Bearer ' + auth.accessToken });
	          }
	          break;
	        default:
	          throw new Error('Unknown authentication type: ' + auth.type);
	      }
	    });
	  };
	
	  exports.prototype.deserialize = function deserialize(response, returnType) {
	    if (response == null || returnType == null || response.status == 204) {
	      return null;
	    }
	
	    var data = response.body;
	    if (data == null || (typeof data === 'undefined' ? 'undefined' : (0, _typeof3.default)(data)) === 'object' && typeof data.length === 'undefined' && !(0, _keys2.default)(data).length) {
	      data = response.text;
	    }
	    return exports.convertToType(data, returnType);
	  };
	
	  exports.prototype.callApi = function callApi(path, httpMethod, pathParams, queryParams, headerParams, formParams, bodyParam, authNames, contentTypes, accepts, returnType, callback) {
	
	    var _this = this;
	    var url = this.buildUrl(path, pathParams);
	    var request = superagent(httpMethod, url);
	
	    this.applyAuthToRequest(request, authNames);
	
	    if (httpMethod.toUpperCase() === 'GET' && this.cache === false) {
	      queryParams['_'] = new Date().getTime();
	    }
	    request.query(this.normalizeParams(queryParams));
	
	    request.set(this.defaultHeaders).set(this.normalizeParams(headerParams));
	
	    request.timeout(this.timeout);
	
	    var contentType = this.jsonPreferredMime(contentTypes);
	    if (contentType) {
	      if (contentType != 'multipart/form-data') {
	        request.type(contentType);
	      }
	    } else if (!request.header['Content-Type']) {
	      request.type('application/json');
	    }
	
	    if (contentType === 'application/x-www-form-urlencoded') {
	      request.send(querystring.stringify(this.normalizeParams(formParams)));
	    } else if (contentType == 'multipart/form-data') {
	      var _formParams = this.normalizeParams(formParams);
	      for (var key in _formParams) {
	        if (_formParams.hasOwnProperty(key)) {
	          if (this.isFileParam(_formParams[key])) {
	            request.attach(key, _formParams[key]);
	          } else {
	            request.field(key, _formParams[key]);
	          }
	        }
	      }
	    } else if (bodyParam) {
	      request.send(bodyParam);
	    }
	
	    var accept = this.jsonPreferredMime(accepts);
	    if (accept) {
	      request.accept(accept);
	    }
	
	    if (returnType === 'Blob') {
	      request.responseType('blob');
	    } else if (returnType === 'String') {
	      request.responseType('string');
	    }
	
	    if (this.enableCookies) {
	      if (typeof window === 'undefined') {
	        this.agent.attachCookies(request);
	      } else {
	        request.withCredentials();
	      }
	    }
	
	    request.end(function (error, response) {
	      if (callback) {
	        var data = null;
	        if (!error) {
	          try {
	            data = _this.deserialize(response, returnType);
	            if (_this.enableCookies && typeof window === 'undefined') {
	              _this.agent.saveCookies(response);
	            }
	          } catch (err) {
	            error = err;
	          }
	        }
	        callback(error, data, response);
	      }
	    });
	
	    return request;
	  };
	
	  exports.parseDate = function (str) {
	    return new Date(str);
	  };
	
	  exports.convertToType = function (data, type) {
	    if (data === null || data === undefined) return data;
	
	    switch (type) {
	      case 'Boolean':
	        return Boolean(data);
	      case 'Integer':
	        return parseInt(data, 10);
	      case 'Number':
	        return parseFloat(data);
	      case 'String':
	        return String(data);
	      case 'Date':
	        return this.parseDate(String(data));
	      case 'Blob':
	        return data;
	      default:
	        if (type === Object) {
	          return data;
	        } else if (typeof type === 'function') {
	          return type.constructFromObject(data);
	        } else if (Array.isArray(type)) {
	          var itemType = type[0];
	          return data.map(function (item) {
	            return exports.convertToType(item, itemType);
	          });
	        } else if ((typeof type === 'undefined' ? 'undefined' : (0, _typeof3.default)(type)) === 'object') {
	          var keyType, valueType;
	          for (var k in type) {
	            if (type.hasOwnProperty(k)) {
	              keyType = k;
	              valueType = type[k];
	              break;
	            }
	          }
	          var result = {};
	          for (var k in data) {
	            if (data.hasOwnProperty(k)) {
	              var key = exports.convertToType(k, keyType);
	              var value = exports.convertToType(data[k], valueType);
	              result[key] = value;
	            }
	          }
	          return result;
	        } else {
	          return data;
	        }
	    }
	  };
	
	  exports.constructFromObject = function (data, obj, itemType) {
	    if (Array.isArray(data)) {
	      for (var i = 0; i < data.length; i++) {
	        if (data.hasOwnProperty(i)) obj[i] = exports.convertToType(data[i], itemType);
	      }
	    } else {
	      for (var k in data) {
	        if (data.hasOwnProperty(k)) obj[k] = exports.convertToType(data[k], itemType);
	      }
	    }
	  };
	
	  exports.instance = new exports();
	
	  return exports;
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(258).Buffer, __webpack_require__(2)(module)))

/***/ }),
/* 5 */,
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	var _typeof2 = __webpack_require__(3);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var define = false;
	
	(function (factory) {
	  if (typeof define === 'function' && define.amd) {
	    define(['ApiClient', 'model/Activity', 'model/ArrayResponse', 'model/ConsultingConfig', 'model/DataResponse', 'model/Day', 'model/ErrorResponse', 'model/Factor', 'model/FactorTendency', 'model/Feedback', 'model/Graph', 'model/GraphData', 'model/InlineResponse200', 'model/InlineResponse2001', 'model/Measurement', 'model/Medication', 'model/MessageResponse', 'model/Params', 'model/Params1', 'model/Params2', 'model/Params3', 'model/Params4', 'model/Params5', 'model/Report', 'model/Reward', 'model/Status', 'model/SurveyQuestion', 'model/User', 'model/UserClients', 'model/UserDoctorData', 'model/UserDoctorDataContact', 'model/UserPatientData', 'api/DefaultApi'], factory);
	  } else if (( false ? 'undefined' : (0, _typeof3.default)(module)) === 'object' && module.exports) {
	    module.exports = factory(__webpack_require__(4), __webpack_require__(46), __webpack_require__(47), __webpack_require__(48), __webpack_require__(49), __webpack_require__(50), __webpack_require__(51), __webpack_require__(30), __webpack_require__(52), __webpack_require__(220), __webpack_require__(53), __webpack_require__(54), __webpack_require__(55), __webpack_require__(56), __webpack_require__(57), __webpack_require__(58), __webpack_require__(59), __webpack_require__(60), __webpack_require__(61), __webpack_require__(62), __webpack_require__(63), __webpack_require__(64), __webpack_require__(65), __webpack_require__(66), __webpack_require__(67), __webpack_require__(68), __webpack_require__(221), __webpack_require__(19), __webpack_require__(69), __webpack_require__(70), __webpack_require__(71), __webpack_require__(72), __webpack_require__(219));
	  }
	})(function (ApiClient, Activity, ArrayResponse, ConsultingConfig, DataResponse, Day, ErrorResponse, Factor, FactorTendency, Feedback, Graph, GraphData, InlineResponse200, InlineResponse2001, Measurement, Medication, MessageResponse, Params, Params1, Params2, Params3, Params4, Params5, Report, Reward, Status, SurveyQuestion, User, UserClients, UserDoctorData, UserDoctorDataContact, UserPatientData, DefaultApi) {
	  'use strict';
	
	  var exports = {
	    ApiClient: ApiClient,
	
	    Activity: Activity,
	
	    ArrayResponse: ArrayResponse,
	
	    ConsultingConfig: ConsultingConfig,
	
	    DataResponse: DataResponse,
	
	    Day: Day,
	
	    ErrorResponse: ErrorResponse,
	
	    Factor: Factor,
	
	    FactorTendency: FactorTendency,
	
	    Feedback: Feedback,
	
	    Graph: Graph,
	
	    GraphData: GraphData,
	
	    InlineResponse200: InlineResponse200,
	
	    InlineResponse2001: InlineResponse2001,
	
	    Measurement: Measurement,
	
	    Medication: Medication,
	
	    MessageResponse: MessageResponse,
	
	    Params: Params,
	
	    Params1: Params1,
	
	    Params2: Params2,
	
	    Params3: Params3,
	
	    Params4: Params4,
	
	    Params5: Params5,
	
	    Report: Report,
	
	    Reward: Reward,
	
	    Status: Status,
	
	    SurveyQuestion: SurveyQuestion,
	
	    User: User,
	
	    UserClients: UserClients,
	
	    UserDoctorData: UserDoctorData,
	
	    UserDoctorDataContact: UserDoctorDataContact,
	
	    UserPatientData: UserPatientData,
	
	    DefaultApi: DefaultApi
	  };
	
	  return exports;
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)(module)))

/***/ }),
/* 7 */,
/* 8 */,
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(300)
	
	var Component = __webpack_require__(5)(
	  /* script */
	  __webpack_require__(247),
	  /* template */
	  __webpack_require__(407),
	  /* scopeId */
	  "data-v-05ec0a75",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	var _typeof2 = __webpack_require__(3);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var define = false;
	
	(function (root, factory) {
	  if (typeof define === 'function' && define.amd) {
	    define(['ApiClient', 'model/Activity', 'model/Factor', 'model/Reward', 'model/UserClients', 'model/UserDoctorData', 'model/UserPatientData'], factory);
	  } else if (( false ? 'undefined' : (0, _typeof3.default)(module)) === 'object' && module.exports) {
	    module.exports = factory(__webpack_require__(4), __webpack_require__(46), __webpack_require__(30), __webpack_require__(67), __webpack_require__(69), __webpack_require__(70), __webpack_require__(72));
	  } else {
	    if (!root.SymbimedApi) {
	      root.SymbimedApi = {};
	    }
	    root.SymbimedApi.User = factory(root.SymbimedApi.ApiClient, root.SymbimedApi.Activity, root.SymbimedApi.Factor, root.SymbimedApi.Reward, root.SymbimedApi.UserClients, root.SymbimedApi.UserDoctorData, root.SymbimedApi.UserPatientData);
	  }
	})(undefined, function (ApiClient, Activity, Factor, Reward, UserClients, UserDoctorData, UserPatientData) {
	  'use strict';
	
	  var exports = function exports() {
	    var _this = this;
	  };
	
	  exports.constructFromObject = function (data, obj) {
	    if (data) {
	      obj = obj || new exports();
	
	      if (data.hasOwnProperty('_id')) {
	        obj['_id'] = ApiClient.convertToType(data['_id'], 'String');
	      }
	      if (data.hasOwnProperty('updatedAt')) {
	        obj['updatedAt'] = ApiClient.convertToType(data['updatedAt'], 'Date');
	      }
	      if (data.hasOwnProperty('simpleName')) {
	        obj['simpleName'] = ApiClient.convertToType(data['simpleName'], 'String');
	      }
	      if (data.hasOwnProperty('name')) {
	        obj['name'] = ApiClient.convertToType(data['name'], 'String');
	      }
	      if (data.hasOwnProperty('avatar')) {
	        obj['avatar'] = ApiClient.convertToType(data['avatar'], 'String');
	      }
	      if (data.hasOwnProperty('email')) {
	        obj['email'] = ApiClient.convertToType(data['email'], 'String');
	      }
	      if (data.hasOwnProperty('gender')) {
	        obj['gender'] = ApiClient.convertToType(data['gender'], 'String');
	      }
	      if (data.hasOwnProperty('address')) {
	        obj['address'] = ApiClient.convertToType(data['address'], 'String');
	      }
	      if (data.hasOwnProperty('legal')) {
	        obj['legal'] = ApiClient.convertToType(data['legal'], 'String');
	      }
	      if (data.hasOwnProperty('telephone')) {
	        obj['telephone'] = ApiClient.convertToType(data['telephone'], 'String');
	      }
	      if (data.hasOwnProperty('clients')) {
	        obj['clients'] = UserClients.constructFromObject(data['clients']);
	      }
	      if (data.hasOwnProperty('hidden')) {
	        obj['hidden'] = ApiClient.convertToType(data['hidden'], 'Boolean');
	      }
	      if (data.hasOwnProperty('hiddenPatients')) {
	        obj['hiddenPatients'] = ApiClient.convertToType(data['hiddenPatients'], ['String']);
	      }
	      if (data.hasOwnProperty('fcmTokens')) {
	        obj['fcmTokens'] = ApiClient.convertToType(data['fcmTokens'], ['String']);
	      }
	      if (data.hasOwnProperty('symptomCount')) {
	        obj['symptomCount'] = ApiClient.convertToType(data['symptomCount'], 'Number');
	      }
	      if (data.hasOwnProperty('patientCount')) {
	        obj['patientCount'] = ApiClient.convertToType(data['patientCount'], 'Number');
	      }
	      if (data.hasOwnProperty('additionalFactors')) {
	        obj['additionalFactors'] = ApiClient.convertToType(data['additionalFactors'], { 'String': Factor });
	      }
	      if (data.hasOwnProperty('rewards')) {
	        obj['rewards'] = ApiClient.convertToType(data['rewards'], [Reward]);
	      }
	      if (data.hasOwnProperty('activity')) {
	        obj['activity'] = ApiClient.convertToType(data['activity'], [Activity]);
	      }
	      if (data.hasOwnProperty('doctorData')) {
	        obj['doctorData'] = UserDoctorData.constructFromObject(data['doctorData']);
	      }
	      if (data.hasOwnProperty('patientData')) {
	        obj['patientData'] = UserPatientData.constructFromObject(data['patientData']);
	      }
	      if (data.hasOwnProperty('doctors')) {
	        obj['doctors'] = ApiClient.convertToType(data['doctors'], ['String']);
	      }
	      if (data.hasOwnProperty('group')) {
	        obj['group'] = ApiClient.convertToType(data['group'], 'String');
	      }
	      if (data.hasOwnProperty('registrationDate')) {
	        obj['registrationDate'] = ApiClient.convertToType(data['registrationDate'], 'Date');
	      }
	      if (data.hasOwnProperty('__v')) {
	        obj['__v'] = ApiClient.convertToType(data['__v'], 'Number');
	      }
	    }
	    return obj;
	  };
	
	  exports.prototype['_id'] = undefined;
	
	  exports.prototype['updatedAt'] = undefined;
	
	  exports.prototype['simpleName'] = undefined;
	
	  exports.prototype['name'] = undefined;
	
	  exports.prototype['avatar'] = undefined;
	
	  exports.prototype['email'] = undefined;
	
	  exports.prototype['gender'] = undefined;
	
	  exports.prototype['address'] = undefined;
	
	  exports.prototype['legal'] = undefined;
	
	  exports.prototype['telephone'] = undefined;
	
	  exports.prototype['clients'] = undefined;
	
	  exports.prototype['hidden'] = undefined;
	
	  exports.prototype['hiddenPatients'] = undefined;
	
	  exports.prototype['fcmTokens'] = undefined;
	
	  exports.prototype['symptomCount'] = undefined;
	
	  exports.prototype['patientCount'] = undefined;
	
	  exports.prototype['additionalFactors'] = undefined;
	
	  exports.prototype['rewards'] = undefined;
	
	  exports.prototype['activity'] = undefined;
	
	  exports.prototype['doctorData'] = undefined;
	
	  exports.prototype['patientData'] = undefined;
	
	  exports.prototype['doctors'] = undefined;
	
	  exports.prototype['group'] = undefined;
	
	  exports.prototype['registrationDate'] = undefined;
	
	  exports.prototype['__v'] = undefined;
	
	  return exports;
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)(module)))

/***/ }),
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	var _typeof2 = __webpack_require__(3);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var define = false;
	
	(function (root, factory) {
	  if (typeof define === 'function' && define.amd) {
	    define(['ApiClient', 'model/FactorTendency'], factory);
	  } else if (( false ? 'undefined' : (0, _typeof3.default)(module)) === 'object' && module.exports) {
	    module.exports = factory(__webpack_require__(4), __webpack_require__(52));
	  } else {
	    if (!root.SymbimedApi) {
	      root.SymbimedApi = {};
	    }
	    root.SymbimedApi.Factor = factory(root.SymbimedApi.ApiClient, root.SymbimedApi.FactorTendency);
	  }
	})(undefined, function (ApiClient, FactorTendency) {
	  'use strict';
	
	  var exports = function exports() {
	    var _this = this;
	  };
	
	  exports.constructFromObject = function (data, obj) {
	    if (data) {
	      obj = obj || new exports();
	
	      if (data.hasOwnProperty('title')) {
	        obj['title'] = ApiClient.convertToType(data['title'], 'String');
	      }
	      if (data.hasOwnProperty('unit')) {
	        obj['unit'] = ApiClient.convertToType(data['unit'], 'String');
	      }
	      if (data.hasOwnProperty('value')) {
	        obj['value'] = ApiClient.convertToType(data['value'], 'String');
	      }
	      if (data.hasOwnProperty('type')) {
	        obj['type'] = ApiClient.convertToType(data['type'], 'String');
	      }
	      if (data.hasOwnProperty('tendency')) {
	        obj['tendency'] = FactorTendency.constructFromObject(data['tendency']);
	      }
	    }
	    return obj;
	  };
	
	  exports.prototype['title'] = undefined;
	
	  exports.prototype['unit'] = undefined;
	
	  exports.prototype['value'] = undefined;
	
	  exports.prototype['type'] = undefined;
	
	  exports.prototype['tendency'] = undefined;
	
	  return exports;
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)(module)))

/***/ }),
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABGdBTUEAAK/INwWK6QAAAAZiS0dEAP8A/wD/oL2nkwAAAAlwSFlzAAAASAAAAEgARslrPgAAAAl2cEFnAAAAEAAAABAAXMatwwAAAyxJREFUOMul0V1QTGEYB/Bzjytfre987JnC7Gg3CstMaMZHmWRXpSiUFG4yMUYmYZTUakSxI8agpFSb8rGhUGmks6e27G6lOnXastsimc5uNX/nHDPcuDGemd+87zzzf97n4iUAEIJ/rd9zUzwS3MiN56Xy7Zek3kGZpE+whix+8p40p2WR9coA3jbSdDad1OmbSN+dGtI7KIOUB6ZLpRvOLZnsmTCd2Jt4t0oZdat/qSq3T7brep9XqJYtrzGxVs0N1rh+h4hNy2af1VpY+W4tK2SE7Gp+RnUkr5DoG7Ax9a1WHEqvAhmSB0lADkpq2mFPuwqTzF9kS9Ggsu4TZgdehzT0NqJTKvA0uwR1MYkGwpKZw7g6uuDkXKil+xB/UY/nDd2wXbiCj8v8RJ+TM/CqsQexyTpUZj9C5+EkdAfHgI4/QRFtSamMo6AMY7YhCOUcm8Aoz3ruMlo916PVYx3YU6kYdY7hm6ENDu092PMK4GRYDNrtFNFx8x7jKNTB8bAcX4oreI/Fe2d4HOiF3qDdFehQHYCjsAyOB6UY4s8hPm8vKIUp9xZFvJYsZ5rdV6FlyWq0SH3RvHjVr8G/cfeGYYEChrleoGbJ8GKGB0VUz/Bk6DkrQM/zgkEw/xdh859Bxe++Yd4KULNlaHJbhhfTSIpo8AtizJvDYAmIQPv2PSJLYARaFf7iRoFRvlHsibaFw7x1N8xbwlDvF0QRn5leZnx4GKOWLvz40AJXZzcmhr+j92Qq6EVrRD0JKWIPIyMY509n/wBGmozo0tdQRH+jkRnMLcKnPSfRdSYH+od1MPV8Qf8FLWjZDhF75iosvV/xmraCc03wj43Anl+B95HHKaIx5DTTfuwaKrUvEX2xFtIoHYrfMBjMKkKz8qjImp6P8vpeSCPLsD+zAdUtNv5bxzHQ2WMg7l6rNMZmvHUujqngpoU84tzCSrg7ejNn0pRyb/yTRW1pRVzBSwsnCS/hpu4q5hbu03EHs9657j+jagj3TbHKSYpo1VTfg6qZaw+p3JRx6oj4U+rj6jj1YblKlBgcq448kqSWrItTCxkhO8nrwE6Jz96VxP/WT80URoSbcR39AAAAJXRFWHRkYXRlOmNyZWF0ZQAyMDA5LTA5LTEzVDE1OjUxOjUwKzAyOjAwwxBGQQAAACV0RVh0ZGF0ZTptb2RpZnkAMjAwOS0wOS0xM1QxNTo1MTo1MCswMjowMLJN/v0AAAAZdEVYdFNvZnR3YXJlAEFkb2JlIEltYWdlUmVhZHlxyWU8AAAAAElFTkSuQmCC"

/***/ }),
/* 45 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAABIAAAASABGyWs+AAAACXZwQWcAAAAQAAAAEABcxq3DAAABvklEQVQ4y6XTzUuiQRzA8bmXpY8F3cKgWLBXq7U1IlkFe1+fWqtHLWrBjV62rf6ZqENQEZhR0KO3DkFLwfR6WSt9ktC1cOygl63Ng79mem7VptTAh4H5fWdug9B710ZxWZHvQ5XGp9VpvFpdiUh5tbUvkme6Etb6yio168WlarSrM/zyd9kiZ3x/+KxboOwZCOFTXgj/buuObJfXrSBcYyCSsRWkz+0gmTqoTpDM/8FmrKFtsLkFdirqMcKVehJoNEOgyfJ4GKSPvYo2rD03mGBHW4vRkamdhL70QYgXINTjkH1lnPLeY5dnfL/MKrvo6oU9owWjuP+UpKJXkIpeQ+rquXs6u/8TfUI+ixyfYJRIJgm8YaWpGCEYJROJNz0A6TSQWAwj6TpM4rdJYG6y9Nj/TYD/MohR9cIIqXf/BP3qNHzyzGTUQOlXp6DOPQlV8659lDNnI4pFB+QvOUG5PACq5cFXsYa1uYt2yJ21HSDVmivOiWOgFsehwDsBhRmwhrXc5ihwHtch4jwjAW5z4q5A/HFbKE5mhbX0zj+1+/sWUggNjflDTVbVcLOV+2bks6GkbR69o+j9WP3u3/wAyKY5zfZP16AAAAAldEVYdGRhdGU6Y3JlYXRlADIwMDktMDktMTNUMTU6NDk6NDIrMDI6MDBKfMjCAAAAJXRFWHRkYXRlOm1vZGlmeQAyMDA5LTA5LTEzVDE1OjQ5OjQyKzAyOjAwOyFwfgAAAABJRU5ErkJggg=="

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	var _typeof2 = __webpack_require__(3);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var define = false;
	
	(function (root, factory) {
	  if (typeof define === 'function' && define.amd) {
	    define(['ApiClient'], factory);
	  } else if (( false ? 'undefined' : (0, _typeof3.default)(module)) === 'object' && module.exports) {
	    module.exports = factory(__webpack_require__(4));
	  } else {
	    if (!root.SymbimedApi) {
	      root.SymbimedApi = {};
	    }
	    root.SymbimedApi.Activity = factory(root.SymbimedApi.ApiClient);
	  }
	})(undefined, function (ApiClient) {
	  'use strict';
	
	  var exports = function exports() {
	    var _this = this;
	  };
	
	  exports.constructFromObject = function (data, obj) {
	    if (data) {
	      obj = obj || new exports();
	
	      if (data.hasOwnProperty('userId')) {
	        obj['userId'] = ApiClient.convertToType(data['userId'], 'String');
	      }
	      if (data.hasOwnProperty('type')) {
	        obj['type'] = ApiClient.convertToType(data['type'], 'String');
	      }
	      if (data.hasOwnProperty('subType')) {
	        obj['subType'] = ApiClient.convertToType(data['subType'], 'String');
	      }
	      if (data.hasOwnProperty('events')) {
	        obj['events'] = ApiClient.convertToType(data['events'], ['Date']);
	      }
	      if (data.hasOwnProperty('comment')) {
	        obj['comment'] = ApiClient.convertToType(data['comment'], 'String');
	      }
	      if (data.hasOwnProperty('updatedAt')) {
	        obj['updatedAt'] = ApiClient.convertToType(data['updatedAt'], 'Date');
	      }
	    }
	    return obj;
	  };
	
	  exports.prototype['userId'] = undefined;
	
	  exports.prototype['type'] = undefined;
	
	  exports.prototype['subType'] = undefined;
	
	  exports.prototype['events'] = undefined;
	
	  exports.prototype['comment'] = undefined;
	
	  exports.prototype['updatedAt'] = undefined;
	
	  return exports;
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)(module)))

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	var _typeof2 = __webpack_require__(3);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var define = false;
	
	(function (root, factory) {
	  if (typeof define === 'function' && define.amd) {
	    define(['ApiClient'], factory);
	  } else if (( false ? 'undefined' : (0, _typeof3.default)(module)) === 'object' && module.exports) {
	    module.exports = factory(__webpack_require__(4));
	  } else {
	    if (!root.SymbimedApi) {
	      root.SymbimedApi = {};
	    }
	    root.SymbimedApi.ArrayResponse = factory(root.SymbimedApi.ApiClient);
	  }
	})(undefined, function (ApiClient) {
	  'use strict';
	
	  var exports = function exports(data) {
	    var _this = this;
	
	    _this['data'] = data;
	  };
	
	  exports.constructFromObject = function (data, obj) {
	    if (data) {
	      obj = obj || new exports();
	
	      if (data.hasOwnProperty('data')) {
	        obj['data'] = ApiClient.convertToType(data['data'], [Object]);
	      }
	    }
	    return obj;
	  };
	
	  exports.prototype['data'] = undefined;
	
	  return exports;
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)(module)))

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	var _typeof2 = __webpack_require__(3);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var define = false;
	
	(function (root, factory) {
	  if (typeof define === 'function' && define.amd) {
	    define(['ApiClient', 'model/Day'], factory);
	  } else if (( false ? 'undefined' : (0, _typeof3.default)(module)) === 'object' && module.exports) {
	    module.exports = factory(__webpack_require__(4), __webpack_require__(50));
	  } else {
	    if (!root.SymbimedApi) {
	      root.SymbimedApi = {};
	    }
	    root.SymbimedApi.ConsultingConfig = factory(root.SymbimedApi.ApiClient, root.SymbimedApi.Day);
	  }
	})(undefined, function (ApiClient, Day) {
	  'use strict';
	
	  var exports = function exports() {
	    var _this = this;
	  };
	
	  exports.constructFromObject = function (data, obj) {
	    if (data) {
	      obj = obj || new exports();
	
	      if (data.hasOwnProperty('days')) {
	        obj['days'] = ApiClient.convertToType(data['days'], [Day]);
	      }
	    }
	    return obj;
	  };
	
	  exports.prototype['days'] = undefined;
	
	  return exports;
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)(module)))

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	var _typeof2 = __webpack_require__(3);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var define = false;
	
	(function (root, factory) {
	  if (typeof define === 'function' && define.amd) {
	    define(['ApiClient'], factory);
	  } else if (( false ? 'undefined' : (0, _typeof3.default)(module)) === 'object' && module.exports) {
	    module.exports = factory(__webpack_require__(4));
	  } else {
	    if (!root.SymbimedApi) {
	      root.SymbimedApi = {};
	    }
	    root.SymbimedApi.DataResponse = factory(root.SymbimedApi.ApiClient);
	  }
	})(undefined, function (ApiClient) {
	  'use strict';
	
	  var exports = function exports(data) {
	    var _this = this;
	
	    _this['data'] = data;
	  };
	
	  exports.constructFromObject = function (data, obj) {
	    if (data) {
	      obj = obj || new exports();
	
	      if (data.hasOwnProperty('data')) {
	        obj['data'] = ApiClient.convertToType(data['data'], Object);
	      }
	    }
	    return obj;
	  };
	
	  exports.prototype['data'] = undefined;
	
	  return exports;
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)(module)))

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	var _typeof2 = __webpack_require__(3);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var define = false;
	
	(function (root, factory) {
	  if (typeof define === 'function' && define.amd) {
	    define(['ApiClient'], factory);
	  } else if (( false ? 'undefined' : (0, _typeof3.default)(module)) === 'object' && module.exports) {
	    module.exports = factory(__webpack_require__(4));
	  } else {
	    if (!root.SymbimedApi) {
	      root.SymbimedApi = {};
	    }
	    root.SymbimedApi.Day = factory(root.SymbimedApi.ApiClient);
	  }
	})(undefined, function (ApiClient) {
	  'use strict';
	
	  var exports = function exports() {
	    var _this = this;
	  };
	
	  exports.constructFromObject = function (data, obj) {
	    if (data) {
	      obj = obj || new exports();
	
	      if (data.hasOwnProperty('dayName')) {
	        obj['dayName'] = ApiClient.convertToType(data['dayName'], 'String');
	      }
	      if (data.hasOwnProperty('location')) {
	        obj['location'] = ApiClient.convertToType(data['location'], 'String');
	      }
	      if (data.hasOwnProperty('comment')) {
	        obj['comment'] = ApiClient.convertToType(data['comment'], 'String');
	      }
	      if (data.hasOwnProperty('fromTime')) {
	        obj['fromTime'] = ApiClient.convertToType(data['fromTime'], 'Number');
	      }
	      if (data.hasOwnProperty('toTime')) {
	        obj['toTime'] = ApiClient.convertToType(data['toTime'], 'Number');
	      }
	    }
	    return obj;
	  };
	
	  exports.prototype['dayName'] = undefined;
	
	  exports.prototype['location'] = undefined;
	
	  exports.prototype['comment'] = undefined;
	
	  exports.prototype['fromTime'] = undefined;
	
	  exports.prototype['toTime'] = undefined;
	
	  return exports;
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)(module)))

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	var _typeof2 = __webpack_require__(3);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var define = false;
	
	(function (root, factory) {
	  if (typeof define === 'function' && define.amd) {
	    define(['ApiClient'], factory);
	  } else if (( false ? 'undefined' : (0, _typeof3.default)(module)) === 'object' && module.exports) {
	    module.exports = factory(__webpack_require__(4));
	  } else {
	    if (!root.SymbimedApi) {
	      root.SymbimedApi = {};
	    }
	    root.SymbimedApi.ErrorResponse = factory(root.SymbimedApi.ApiClient);
	  }
	})(undefined, function (ApiClient) {
	  'use strict';
	
	  var exports = function exports(message) {
	    var _this = this;
	
	    _this['message'] = message;
	  };
	
	  exports.constructFromObject = function (data, obj) {
	    if (data) {
	      obj = obj || new exports();
	
	      if (data.hasOwnProperty('message')) {
	        obj['message'] = ApiClient.convertToType(data['message'], 'String');
	      }
	    }
	    return obj;
	  };
	
	  exports.prototype['message'] = undefined;
	
	  return exports;
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)(module)))

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	var _typeof2 = __webpack_require__(3);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var define = false;
	
	(function (root, factory) {
	  if (typeof define === 'function' && define.amd) {
	    define(['ApiClient'], factory);
	  } else if (( false ? 'undefined' : (0, _typeof3.default)(module)) === 'object' && module.exports) {
	    module.exports = factory(__webpack_require__(4));
	  } else {
	    if (!root.SymbimedApi) {
	      root.SymbimedApi = {};
	    }
	    root.SymbimedApi.FactorTendency = factory(root.SymbimedApi.ApiClient);
	  }
	})(undefined, function (ApiClient) {
	  'use strict';
	
	  var exports = function exports() {
	    var _this = this;
	  };
	
	  exports.constructFromObject = function (data, obj) {
	    if (data) {
	      obj = obj || new exports();
	
	      if (data.hasOwnProperty('type')) {
	        obj['type'] = ApiClient.convertToType(data['type'], 'String');
	      }
	      if (data.hasOwnProperty('value')) {
	        obj['value'] = ApiClient.convertToType(data['value'], 'String');
	      }
	    }
	    return obj;
	  };
	
	  exports.prototype['type'] = undefined;
	
	  exports.prototype['value'] = undefined;
	
	  return exports;
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)(module)))

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	var _typeof2 = __webpack_require__(3);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var define = false;
	
	(function (root, factory) {
	  if (typeof define === 'function' && define.amd) {
	    define(['ApiClient', 'model/GraphData'], factory);
	  } else if (( false ? 'undefined' : (0, _typeof3.default)(module)) === 'object' && module.exports) {
	    module.exports = factory(__webpack_require__(4), __webpack_require__(54));
	  } else {
	    if (!root.SymbimedApi) {
	      root.SymbimedApi = {};
	    }
	    root.SymbimedApi.Graph = factory(root.SymbimedApi.ApiClient, root.SymbimedApi.GraphData);
	  }
	})(undefined, function (ApiClient, GraphData) {
	  'use strict';
	
	  var exports = function exports() {
	    var _this = this;
	  };
	
	  exports.constructFromObject = function (data, obj) {
	    if (data) {
	      obj = obj || new exports();
	
	      if (data.hasOwnProperty('weeks')) {
	        obj['weeks'] = ApiClient.convertToType(data['weeks'], ['Date']);
	      }
	      if (data.hasOwnProperty('data')) {
	        obj['data'] = ApiClient.convertToType(data['data'], [GraphData]);
	      }
	    }
	    return obj;
	  };
	
	  exports.prototype['weeks'] = undefined;
	
	  exports.prototype['data'] = undefined;
	
	  return exports;
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)(module)))

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	var _typeof2 = __webpack_require__(3);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var define = false;
	
	(function (root, factory) {
	  if (typeof define === 'function' && define.amd) {
	    define(['ApiClient'], factory);
	  } else if (( false ? 'undefined' : (0, _typeof3.default)(module)) === 'object' && module.exports) {
	    module.exports = factory(__webpack_require__(4));
	  } else {
	    if (!root.SymbimedApi) {
	      root.SymbimedApi = {};
	    }
	    root.SymbimedApi.GraphData = factory(root.SymbimedApi.ApiClient);
	  }
	})(undefined, function (ApiClient) {
	  'use strict';
	
	  var exports = function exports() {
	    var _this = this;
	  };
	
	  exports.constructFromObject = function (data, obj) {
	    if (data) {
	      obj = obj || new exports();
	
	      if (data.hasOwnProperty('name')) {
	        obj['name'] = ApiClient.convertToType(data['name'], 'String');
	      }
	      if (data.hasOwnProperty('values')) {
	        obj['values'] = ApiClient.convertToType(data['values'], ['Number']);
	      }
	    }
	    return obj;
	  };
	
	  exports.prototype['name'] = undefined;
	
	  exports.prototype['values'] = undefined;
	
	  return exports;
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)(module)))

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	var _typeof2 = __webpack_require__(3);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var define = false;
	
	(function (root, factory) {
	  if (typeof define === 'function' && define.amd) {
	    define(['ApiClient', 'model/User'], factory);
	  } else if (( false ? 'undefined' : (0, _typeof3.default)(module)) === 'object' && module.exports) {
	    module.exports = factory(__webpack_require__(4), __webpack_require__(19));
	  } else {
	    if (!root.SymbimedApi) {
	      root.SymbimedApi = {};
	    }
	    root.SymbimedApi.InlineResponse200 = factory(root.SymbimedApi.ApiClient, root.SymbimedApi.User);
	  }
	})(undefined, function (ApiClient, User) {
	  'use strict';
	
	  var exports = function exports() {
	    var _this = this;
	  };
	
	  exports.constructFromObject = function (data, obj) {
	    if (data) {
	      obj = obj || new exports();
	
	      if (data.hasOwnProperty('data')) {
	        obj['data'] = User.constructFromObject(data['data']);
	      }
	    }
	    return obj;
	  };
	
	  exports.prototype['data'] = undefined;
	
	  return exports;
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)(module)))

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	var _typeof2 = __webpack_require__(3);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var define = false;
	
	(function (root, factory) {
	  if (typeof define === 'function' && define.amd) {
	    define(['ApiClient'], factory);
	  } else if (( false ? 'undefined' : (0, _typeof3.default)(module)) === 'object' && module.exports) {
	    module.exports = factory(__webpack_require__(4));
	  } else {
	    if (!root.SymbimedApi) {
	      root.SymbimedApi = {};
	    }
	    root.SymbimedApi.InlineResponse2001 = factory(root.SymbimedApi.ApiClient);
	  }
	})(undefined, function (ApiClient) {
	  'use strict';
	
	  var exports = function exports() {
	    var _this = this;
	  };
	
	  exports.constructFromObject = function (data, obj) {
	    if (data) {
	      obj = obj || new exports();
	
	      if (data.hasOwnProperty('filePaths')) {
	        obj['filePaths'] = ApiClient.convertToType(data['filePaths'], ['String']);
	      }
	    }
	    return obj;
	  };
	
	  exports.prototype['filePaths'] = undefined;
	
	  return exports;
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)(module)))

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	var _typeof2 = __webpack_require__(3);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var define = false;
	
	(function (root, factory) {
	  if (typeof define === 'function' && define.amd) {
	    define(['ApiClient'], factory);
	  } else if (( false ? 'undefined' : (0, _typeof3.default)(module)) === 'object' && module.exports) {
	    module.exports = factory(__webpack_require__(4));
	  } else {
	    if (!root.SymbimedApi) {
	      root.SymbimedApi = {};
	    }
	    root.SymbimedApi.Measurement = factory(root.SymbimedApi.ApiClient);
	  }
	})(undefined, function (ApiClient) {
	  'use strict';
	
	  var exports = function exports(patient, type, value, period) {
	    var _this = this;
	
	    _this['patient'] = patient;
	    _this['type'] = type;
	
	    _this['value'] = value;
	
	    _this['period'] = period;
	  };
	
	  exports.constructFromObject = function (data, obj) {
	    if (data) {
	      obj = obj || new exports();
	
	      if (data.hasOwnProperty('patient')) {
	        obj['patient'] = ApiClient.convertToType(data['patient'], 'String');
	      }
	      if (data.hasOwnProperty('type')) {
	        obj['type'] = ApiClient.convertToType(data['type'], 'String');
	      }
	      if (data.hasOwnProperty('subType')) {
	        obj['subType'] = ApiClient.convertToType(data['subType'], 'String');
	      }
	      if (data.hasOwnProperty('value')) {
	        obj['value'] = ApiClient.convertToType(data['value'], 'String');
	      }
	      if (data.hasOwnProperty('params')) {
	        obj['params'] = ApiClient.convertToType(data['params'], ['String']);
	      }
	      if (data.hasOwnProperty('unit')) {
	        obj['unit'] = ApiClient.convertToType(data['unit'], 'String');
	      }
	      if (data.hasOwnProperty('period')) {
	        obj['period'] = ApiClient.convertToType(data['period'], 'String');
	      }
	      if (data.hasOwnProperty('comment')) {
	        obj['comment'] = ApiClient.convertToType(data['comment'], 'String');
	      }
	      if (data.hasOwnProperty('updatedAt')) {
	        obj['updatedAt'] = ApiClient.convertToType(data['updatedAt'], 'Date');
	      }
	    }
	    return obj;
	  };
	
	  exports.prototype['patient'] = undefined;
	
	  exports.prototype['type'] = undefined;
	
	  exports.prototype['subType'] = undefined;
	
	  exports.prototype['value'] = undefined;
	
	  exports.prototype['params'] = undefined;
	
	  exports.prototype['unit'] = undefined;
	
	  exports.prototype['period'] = undefined;
	
	  exports.prototype['comment'] = undefined;
	
	  exports.prototype['updatedAt'] = undefined;
	
	  return exports;
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)(module)))

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	var _typeof2 = __webpack_require__(3);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var define = false;
	
	(function (root, factory) {
	  if (typeof define === 'function' && define.amd) {
	    define(['ApiClient'], factory);
	  } else if (( false ? 'undefined' : (0, _typeof3.default)(module)) === 'object' && module.exports) {
	    module.exports = factory(__webpack_require__(4));
	  } else {
	    if (!root.SymbimedApi) {
	      root.SymbimedApi = {};
	    }
	    root.SymbimedApi.Medication = factory(root.SymbimedApi.ApiClient);
	  }
	})(undefined, function (ApiClient) {
	  'use strict';
	
	  var exports = function exports(name, frequencyVal, frequencyUnit, form, category) {
	    var _this = this;
	
	    _this['name'] = name;
	
	    _this['frequencyVal'] = frequencyVal;
	    _this['frequencyUnit'] = frequencyUnit;
	    _this['form'] = form;
	    _this['category'] = category;
	  };
	
	  exports.constructFromObject = function (data, obj) {
	    if (data) {
	      obj = obj || new exports();
	
	      if (data.hasOwnProperty('_id')) {
	        obj['_id'] = ApiClient.convertToType(data['_id'], 'String');
	      }
	      if (data.hasOwnProperty('name')) {
	        obj['name'] = ApiClient.convertToType(data['name'], 'String');
	      }
	      if (data.hasOwnProperty('doseVal')) {
	        obj['doseVal'] = ApiClient.convertToType(data['doseVal'], 'String');
	      }
	      if (data.hasOwnProperty('doseUnit')) {
	        obj['doseUnit'] = ApiClient.convertToType(data['doseUnit'], 'String');
	      }
	      if (data.hasOwnProperty('frequencyVal')) {
	        obj['frequencyVal'] = ApiClient.convertToType(data['frequencyVal'], 'String');
	      }
	      if (data.hasOwnProperty('frequencyUnit')) {
	        obj['frequencyUnit'] = ApiClient.convertToType(data['frequencyUnit'], 'String');
	      }
	      if (data.hasOwnProperty('form')) {
	        obj['form'] = ApiClient.convertToType(data['form'], 'String');
	      }
	      if (data.hasOwnProperty('category')) {
	        obj['category'] = ApiClient.convertToType(data['category'], 'String');
	      }
	      if (data.hasOwnProperty('route')) {
	        obj['route'] = ApiClient.convertToType(data['route'], 'String');
	      }
	      if (data.hasOwnProperty('durationVal')) {
	        obj['durationVal'] = ApiClient.convertToType(data['durationVal'], 'String');
	      }
	      if (data.hasOwnProperty('durationUnit')) {
	        obj['durationUnit'] = ApiClient.convertToType(data['durationUnit'], 'String');
	      }
	      if (data.hasOwnProperty('commencement')) {
	        obj['commencement'] = ApiClient.convertToType(data['commencement'], 'String');
	      }
	      if (data.hasOwnProperty('pharmacyComments')) {
	        obj['pharmacyComments'] = ApiClient.convertToType(data['pharmacyComments'], 'String');
	      }
	      if (data.hasOwnProperty('instructions')) {
	        obj['instructions'] = ApiClient.convertToType(data['instructions'], 'String');
	      }
	    }
	    return obj;
	  };
	
	  exports.prototype['_id'] = undefined;
	
	  exports.prototype['name'] = undefined;
	
	  exports.prototype['doseVal'] = undefined;
	
	  exports.prototype['doseUnit'] = undefined;
	
	  exports.prototype['frequencyVal'] = undefined;
	
	  exports.prototype['frequencyUnit'] = undefined;
	
	  exports.prototype['form'] = undefined;
	
	  exports.prototype['category'] = undefined;
	
	  exports.prototype['route'] = undefined;
	
	  exports.prototype['durationVal'] = undefined;
	
	  exports.prototype['durationUnit'] = undefined;
	
	  exports.prototype['commencement'] = undefined;
	
	  exports.prototype['pharmacyComments'] = undefined;
	
	  exports.prototype['instructions'] = undefined;
	
	  return exports;
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)(module)))

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	var _typeof2 = __webpack_require__(3);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var define = false;
	
	(function (root, factory) {
	  if (typeof define === 'function' && define.amd) {
	    define(['ApiClient'], factory);
	  } else if (( false ? 'undefined' : (0, _typeof3.default)(module)) === 'object' && module.exports) {
	    module.exports = factory(__webpack_require__(4));
	  } else {
	    if (!root.SymbimedApi) {
	      root.SymbimedApi = {};
	    }
	    root.SymbimedApi.MessageResponse = factory(root.SymbimedApi.ApiClient);
	  }
	})(undefined, function (ApiClient) {
	  'use strict';
	
	  var exports = function exports(message) {
	    var _this = this;
	
	    _this['message'] = message;
	  };
	
	  exports.constructFromObject = function (data, obj) {
	    if (data) {
	      obj = obj || new exports();
	
	      if (data.hasOwnProperty('message')) {
	        obj['message'] = ApiClient.convertToType(data['message'], 'String');
	      }
	    }
	    return obj;
	  };
	
	  exports.prototype['message'] = undefined;
	
	  return exports;
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)(module)))

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	var _typeof2 = __webpack_require__(3);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var define = false;
	
	(function (root, factory) {
	  if (typeof define === 'function' && define.amd) {
	    define(['ApiClient'], factory);
	  } else if (( false ? 'undefined' : (0, _typeof3.default)(module)) === 'object' && module.exports) {
	    module.exports = factory(__webpack_require__(4));
	  } else {
	    if (!root.SymbimedApi) {
	      root.SymbimedApi = {};
	    }
	    root.SymbimedApi.Params = factory(root.SymbimedApi.ApiClient);
	  }
	})(undefined, function (ApiClient) {
	  'use strict';
	
	  var exports = function exports(email, password) {
	    var _this = this;
	
	    _this['email'] = email;
	    _this['password'] = password;
	  };
	
	  exports.constructFromObject = function (data, obj) {
	    if (data) {
	      obj = obj || new exports();
	
	      if (data.hasOwnProperty('email')) {
	        obj['email'] = ApiClient.convertToType(data['email'], 'String');
	      }
	      if (data.hasOwnProperty('password')) {
	        obj['password'] = ApiClient.convertToType(data['password'], 'String');
	      }
	    }
	    return obj;
	  };
	
	  exports.prototype['email'] = undefined;
	
	  exports.prototype['password'] = undefined;
	
	  return exports;
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)(module)))

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	var _typeof2 = __webpack_require__(3);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var define = false;
	
	(function (root, factory) {
	  if (typeof define === 'function' && define.amd) {
	    define(['ApiClient'], factory);
	  } else if (( false ? 'undefined' : (0, _typeof3.default)(module)) === 'object' && module.exports) {
	    module.exports = factory(__webpack_require__(4));
	  } else {
	    if (!root.SymbimedApi) {
	      root.SymbimedApi = {};
	    }
	    root.SymbimedApi.Params1 = factory(root.SymbimedApi.ApiClient);
	  }
	})(undefined, function (ApiClient) {
	  'use strict';
	
	  var exports = function exports(email) {
	    var _this = this;
	
	    _this['email'] = email;
	  };
	
	  exports.constructFromObject = function (data, obj) {
	    if (data) {
	      obj = obj || new exports();
	
	      if (data.hasOwnProperty('email')) {
	        obj['email'] = ApiClient.convertToType(data['email'], 'String');
	      }
	    }
	    return obj;
	  };
	
	  exports.prototype['email'] = undefined;
	
	  return exports;
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)(module)))

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	var _typeof2 = __webpack_require__(3);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var define = false;
	
	(function (root, factory) {
	  if (typeof define === 'function' && define.amd) {
	    define(['ApiClient'], factory);
	  } else if (( false ? 'undefined' : (0, _typeof3.default)(module)) === 'object' && module.exports) {
	    module.exports = factory(__webpack_require__(4));
	  } else {
	    if (!root.SymbimedApi) {
	      root.SymbimedApi = {};
	    }
	    root.SymbimedApi.Params2 = factory(root.SymbimedApi.ApiClient);
	  }
	})(undefined, function (ApiClient) {
	  'use strict';
	
	  var exports = function exports(token, password) {
	    var _this = this;
	
	    _this['token'] = token;
	    _this['password'] = password;
	  };
	
	  exports.constructFromObject = function (data, obj) {
	    if (data) {
	      obj = obj || new exports();
	
	      if (data.hasOwnProperty('token')) {
	        obj['token'] = ApiClient.convertToType(data['token'], 'String');
	      }
	      if (data.hasOwnProperty('password')) {
	        obj['password'] = ApiClient.convertToType(data['password'], 'String');
	      }
	    }
	    return obj;
	  };
	
	  exports.prototype['token'] = undefined;
	
	  exports.prototype['password'] = undefined;
	
	  return exports;
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)(module)))

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	var _typeof2 = __webpack_require__(3);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var define = false;
	
	(function (root, factory) {
	  if (typeof define === 'function' && define.amd) {
	    define(['ApiClient'], factory);
	  } else if (( false ? 'undefined' : (0, _typeof3.default)(module)) === 'object' && module.exports) {
	    module.exports = factory(__webpack_require__(4));
	  } else {
	    if (!root.SymbimedApi) {
	      root.SymbimedApi = {};
	    }
	    root.SymbimedApi.Params3 = factory(root.SymbimedApi.ApiClient);
	  }
	})(undefined, function (ApiClient) {
	  'use strict';
	
	  var exports = function exports(email) {
	    var _this = this;
	
	    _this['email'] = email;
	  };
	
	  exports.constructFromObject = function (data, obj) {
	    if (data) {
	      obj = obj || new exports();
	
	      if (data.hasOwnProperty('type')) {
	        obj['type'] = ApiClient.convertToType(data['type'], 'String');
	      }
	      if (data.hasOwnProperty('email')) {
	        obj['email'] = ApiClient.convertToType(data['email'], 'String');
	      }
	      if (data.hasOwnProperty('name')) {
	        obj['name'] = ApiClient.convertToType(data['name'], 'String');
	      }
	      if (data.hasOwnProperty('phone')) {
	        obj['phone'] = ApiClient.convertToType(data['phone'], 'String');
	      }
	      if (data.hasOwnProperty('message')) {
	        obj['message'] = ApiClient.convertToType(data['message'], 'String');
	      }
	    }
	    return obj;
	  };
	
	  exports.prototype['type'] = undefined;
	
	  exports.prototype['email'] = undefined;
	
	  exports.prototype['name'] = undefined;
	
	  exports.prototype['phone'] = undefined;
	
	  exports.prototype['message'] = undefined;
	
	  return exports;
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)(module)))

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	var _typeof2 = __webpack_require__(3);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var define = false;
	
	(function (root, factory) {
	  if (typeof define === 'function' && define.amd) {
	    define(['ApiClient'], factory);
	  } else if (( false ? 'undefined' : (0, _typeof3.default)(module)) === 'object' && module.exports) {
	    module.exports = factory(__webpack_require__(4));
	  } else {
	    if (!root.SymbimedApi) {
	      root.SymbimedApi = {};
	    }
	    root.SymbimedApi.Params4 = factory(root.SymbimedApi.ApiClient);
	  }
	})(undefined, function (ApiClient) {
	  'use strict';
	
	  var exports = function exports(patientId, notificationType) {
	    var _this = this;
	
	    _this['patientId'] = patientId;
	    _this['notificationType'] = notificationType;
	  };
	
	  exports.constructFromObject = function (data, obj) {
	    if (data) {
	      obj = obj || new exports();
	
	      if (data.hasOwnProperty('patientId')) {
	        obj['patientId'] = ApiClient.convertToType(data['patientId'], 'String');
	      }
	      if (data.hasOwnProperty('notificationType')) {
	        obj['notificationType'] = ApiClient.convertToType(data['notificationType'], 'String');
	      }
	    }
	    return obj;
	  };
	
	  exports.prototype['patientId'] = undefined;
	
	  exports.prototype['notificationType'] = undefined;
	
	  return exports;
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)(module)))

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	var _typeof2 = __webpack_require__(3);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var define = false;
	
	(function (root, factory) {
	  if (typeof define === 'function' && define.amd) {
	    define(['ApiClient'], factory);
	  } else if (( false ? 'undefined' : (0, _typeof3.default)(module)) === 'object' && module.exports) {
	    module.exports = factory(__webpack_require__(4));
	  } else {
	    if (!root.SymbimedApi) {
	      root.SymbimedApi = {};
	    }
	    root.SymbimedApi.Params5 = factory(root.SymbimedApi.ApiClient);
	  }
	})(undefined, function (ApiClient) {
	  'use strict';
	
	  var exports = function exports(type) {
	    var _this = this;
	
	    _this['type'] = type;
	  };
	
	  exports.constructFromObject = function (data, obj) {
	    if (data) {
	      obj = obj || new exports();
	
	      if (data.hasOwnProperty('title')) {
	        obj['title'] = ApiClient.convertToType(data['title'], 'String');
	      }
	      if (data.hasOwnProperty('text')) {
	        obj['text'] = ApiClient.convertToType(data['text'], 'String');
	      }
	      if (data.hasOwnProperty('language')) {
	        obj['language'] = ApiClient.convertToType(data['language'], 'String');
	      }
	      if (data.hasOwnProperty('published')) {
	        obj['published'] = ApiClient.convertToType(data['published'], 'Boolean');
	      }
	      if (data.hasOwnProperty('type')) {
	        obj['type'] = ApiClient.convertToType(data['type'], 'String');
	      }
	    }
	    return obj;
	  };
	
	  exports.prototype['title'] = undefined;
	
	  exports.prototype['text'] = undefined;
	
	  exports.prototype['language'] = undefined;
	
	  exports.prototype['published'] = undefined;
	
	  exports.prototype['type'] = undefined;
	
	  return exports;
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)(module)))

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	var _typeof2 = __webpack_require__(3);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var define = false;
	
	(function (root, factory) {
	  if (typeof define === 'function' && define.amd) {
	    define(['ApiClient', 'model/Factor', 'model/Graph', 'model/Measurement', 'model/User'], factory);
	  } else if (( false ? 'undefined' : (0, _typeof3.default)(module)) === 'object' && module.exports) {
	    module.exports = factory(__webpack_require__(4), __webpack_require__(30), __webpack_require__(53), __webpack_require__(57), __webpack_require__(19));
	  } else {
	    if (!root.SymbimedApi) {
	      root.SymbimedApi = {};
	    }
	    root.SymbimedApi.Report = factory(root.SymbimedApi.ApiClient, root.SymbimedApi.Factor, root.SymbimedApi.Graph, root.SymbimedApi.Measurement, root.SymbimedApi.User);
	  }
	})(undefined, function (ApiClient, Factor, Graph, Measurement, User) {
	  'use strict';
	
	  var exports = function exports() {
	    var _this = this;
	  };
	
	  exports.constructFromObject = function (data, obj) {
	    if (data) {
	      obj = obj || new exports();
	
	      if (data.hasOwnProperty('profile')) {
	        obj['profile'] = User.constructFromObject(data['profile']);
	      }
	      if (data.hasOwnProperty('symptomGraph')) {
	        obj['symptomGraph'] = Graph.constructFromObject(data['symptomGraph']);
	      }
	      if (data.hasOwnProperty('medicationGraph')) {
	        obj['medicationGraph'] = Graph.constructFromObject(data['medicationGraph']);
	      }
	      if (data.hasOwnProperty('weeklyInputs')) {
	        obj['weeklyInputs'] = ApiClient.convertToType(data['weeklyInputs'], { 'String': 'Number' });
	      }
	      if (data.hasOwnProperty('factors')) {
	        obj['factors'] = ApiClient.convertToType(data['factors'], [Factor]);
	      }
	      if (data.hasOwnProperty('since')) {
	        obj['since'] = ApiClient.convertToType(data['since'], 'Date');
	      }
	      if (data.hasOwnProperty('to')) {
	        obj['to'] = ApiClient.convertToType(data['to'], 'Date');
	      }
	      if (data.hasOwnProperty('comments')) {
	        obj['comments'] = ApiClient.convertToType(data['comments'], [Measurement]);
	      }
	      if (data.hasOwnProperty('measurements')) {
	        obj['measurements'] = ApiClient.convertToType(data['measurements'], [Measurement]);
	      }
	    }
	    return obj;
	  };
	
	  exports.prototype['profile'] = undefined;
	
	  exports.prototype['symptomGraph'] = undefined;
	
	  exports.prototype['medicationGraph'] = undefined;
	
	  exports.prototype['weeklyInputs'] = undefined;
	
	  exports.prototype['factors'] = undefined;
	
	  exports.prototype['since'] = undefined;
	
	  exports.prototype['to'] = undefined;
	
	  exports.prototype['comments'] = undefined;
	
	  exports.prototype['measurements'] = undefined;
	
	  return exports;
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)(module)))

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	var _typeof2 = __webpack_require__(3);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var define = false;
	
	(function (root, factory) {
	  if (typeof define === 'function' && define.amd) {
	    define(['ApiClient'], factory);
	  } else if (( false ? 'undefined' : (0, _typeof3.default)(module)) === 'object' && module.exports) {
	    module.exports = factory(__webpack_require__(4));
	  } else {
	    if (!root.SymbimedApi) {
	      root.SymbimedApi = {};
	    }
	    root.SymbimedApi.Reward = factory(root.SymbimedApi.ApiClient);
	  }
	})(undefined, function (ApiClient) {
	  'use strict';
	
	  var exports = function exports() {
	    var _this = this;
	  };
	
	  exports.constructFromObject = function (data, obj) {
	    if (data) {
	      obj = obj || new exports();
	
	      if (data.hasOwnProperty('rewardId')) {
	        obj['rewardId'] = ApiClient.convertToType(data['rewardId'], 'String');
	      }
	      if (data.hasOwnProperty('rating')) {
	        obj['rating'] = ApiClient.convertToType(data['rating'], 'String');
	      }
	      if (data.hasOwnProperty('unlockDate')) {
	        obj['unlockDate'] = ApiClient.convertToType(data['unlockDate'], 'Date');
	      }
	      if (data.hasOwnProperty('type')) {
	        obj['type'] = ApiClient.convertToType(data['type'], 'String');
	      }
	      if (data.hasOwnProperty('visited')) {
	        obj['visited'] = ApiClient.convertToType(data['visited'], 'Boolean');
	      }
	      if (data.hasOwnProperty('title')) {
	        obj['title'] = ApiClient.convertToType(data['title'], { 'String': 'String' });
	      }
	      if (data.hasOwnProperty('value')) {
	        obj['value'] = ApiClient.convertToType(data['value'], { 'String': 'String' });
	      }
	    }
	    return obj;
	  };
	
	  exports.prototype['rewardId'] = undefined;
	
	  exports.prototype['rating'] = undefined;
	
	  exports.prototype['unlockDate'] = undefined;
	
	  exports.prototype['type'] = undefined;
	
	  exports.prototype['visited'] = undefined;
	
	  exports.prototype['title'] = undefined;
	
	  exports.prototype['value'] = undefined;
	
	  return exports;
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)(module)))

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	var _typeof2 = __webpack_require__(3);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var define = false;
	
	(function (root, factory) {
	  if (typeof define === 'function' && define.amd) {
	    define(['ApiClient', 'model/User'], factory);
	  } else if (( false ? 'undefined' : (0, _typeof3.default)(module)) === 'object' && module.exports) {
	    module.exports = factory(__webpack_require__(4), __webpack_require__(19));
	  } else {
	    if (!root.SymbimedApi) {
	      root.SymbimedApi = {};
	    }
	    root.SymbimedApi.Status = factory(root.SymbimedApi.ApiClient, root.SymbimedApi.User);
	  }
	})(undefined, function (ApiClient, User) {
	  'use strict';
	
	  var exports = function exports() {
	    var _this = this;
	  };
	
	  exports.constructFromObject = function (data, obj) {
	    if (data) {
	      obj = obj || new exports();
	
	      if (data.hasOwnProperty('_id')) {
	        obj['_id'] = ApiClient.convertToType(data['_id'], 'String');
	      }
	      if (data.hasOwnProperty('creator')) {
	        obj['creator'] = User.constructFromObject(data['creator']);
	      }
	      if (data.hasOwnProperty('published')) {
	        obj['published'] = ApiClient.convertToType(data['published'], 'Boolean');
	      }
	      if (data.hasOwnProperty('title')) {
	        obj['title'] = ApiClient.convertToType(data['title'], 'String');
	      }
	      if (data.hasOwnProperty('language')) {
	        obj['language'] = ApiClient.convertToType(data['language'], 'String');
	      }
	      if (data.hasOwnProperty('text')) {
	        obj['text'] = ApiClient.convertToType(data['text'], 'String');
	      }
	      if (data.hasOwnProperty('facebookId')) {
	        obj['facebookId'] = ApiClient.convertToType(data['facebookId'], 'String');
	      }
	      if (data.hasOwnProperty('origin')) {
	        obj['origin'] = ApiClient.convertToType(data['origin'], 'String');
	      }
	      if (data.hasOwnProperty('type')) {
	        obj['type'] = ApiClient.convertToType(data['type'], 'String');
	      }
	      if (data.hasOwnProperty('image')) {
	        obj['image'] = ApiClient.convertToType(data['image'], 'String');
	      }
	      if (data.hasOwnProperty('createdAt')) {
	        obj['createdAt'] = ApiClient.convertToType(data['createdAt'], 'Date');
	      }
	      if (data.hasOwnProperty('updatedAt')) {
	        obj['updatedAt'] = ApiClient.convertToType(data['updatedAt'], 'Date');
	      }
	    }
	    return obj;
	  };
	
	  exports.prototype['_id'] = undefined;
	
	  exports.prototype['creator'] = undefined;
	
	  exports.prototype['published'] = undefined;
	
	  exports.prototype['title'] = undefined;
	
	  exports.prototype['language'] = undefined;
	
	  exports.prototype['text'] = undefined;
	
	  exports.prototype['facebookId'] = undefined;
	
	  exports.prototype['origin'] = undefined;
	
	  exports.prototype['type'] = undefined;
	
	  exports.prototype['image'] = undefined;
	
	  exports.prototype['createdAt'] = undefined;
	
	  exports.prototype['updatedAt'] = undefined;
	
	  return exports;
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)(module)))

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	var _typeof2 = __webpack_require__(3);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var define = false;
	
	(function (root, factory) {
	  if (typeof define === 'function' && define.amd) {
	    define(['ApiClient'], factory);
	  } else if (( false ? 'undefined' : (0, _typeof3.default)(module)) === 'object' && module.exports) {
	    module.exports = factory(__webpack_require__(4));
	  } else {
	    if (!root.SymbimedApi) {
	      root.SymbimedApi = {};
	    }
	    root.SymbimedApi.UserClients = factory(root.SymbimedApi.ApiClient);
	  }
	})(undefined, function (ApiClient) {
	  'use strict';
	
	  var exports = function exports() {
	    var _this = this;
	  };
	
	  exports.constructFromObject = function (data, obj) {
	    if (data) {
	      obj = obj || new exports();
	
	      if (data.hasOwnProperty('droidVersion')) {
	        obj['droidVersion'] = ApiClient.convertToType(data['droidVersion'], 'String');
	      }
	      if (data.hasOwnProperty('droidLang')) {
	        obj['droidLang'] = ApiClient.convertToType(data['droidLang'], 'String');
	      }
	      if (data.hasOwnProperty('iosVersion')) {
	        obj['iosVersion'] = ApiClient.convertToType(data['iosVersion'], 'String');
	      }
	      if (data.hasOwnProperty('iosLang')) {
	        obj['iosLang'] = ApiClient.convertToType(data['iosLang'], 'String');
	      }
	    }
	    return obj;
	  };
	
	  exports.prototype['droidVersion'] = undefined;
	
	  exports.prototype['droidLang'] = undefined;
	
	  exports.prototype['iosVersion'] = undefined;
	
	  exports.prototype['iosLang'] = undefined;
	
	  return exports;
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)(module)))

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	var _typeof2 = __webpack_require__(3);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var define = false;
	
	(function (root, factory) {
	  if (typeof define === 'function' && define.amd) {
	    define(['ApiClient', 'model/ConsultingConfig', 'model/UserDoctorDataContact'], factory);
	  } else if (( false ? 'undefined' : (0, _typeof3.default)(module)) === 'object' && module.exports) {
	    module.exports = factory(__webpack_require__(4), __webpack_require__(48), __webpack_require__(71));
	  } else {
	    if (!root.SymbimedApi) {
	      root.SymbimedApi = {};
	    }
	    root.SymbimedApi.UserDoctorData = factory(root.SymbimedApi.ApiClient, root.SymbimedApi.ConsultingConfig, root.SymbimedApi.UserDoctorDataContact);
	  }
	})(undefined, function (ApiClient, ConsultingConfig, UserDoctorDataContact) {
	  'use strict';
	
	  var exports = function exports() {
	    var _this = this;
	  };
	
	  exports.constructFromObject = function (data, obj) {
	    if (data) {
	      obj = obj || new exports();
	
	      if (data.hasOwnProperty('_id')) {
	        obj['_id'] = ApiClient.convertToType(data['_id'], 'String');
	      }
	      if (data.hasOwnProperty('speciality')) {
	        obj['speciality'] = ApiClient.convertToType(data['speciality'], 'String');
	      }
	      if (data.hasOwnProperty('region')) {
	        obj['region'] = ApiClient.convertToType(data['region'], 'String');
	      }
	      if (data.hasOwnProperty('specification')) {
	        obj['specification'] = ApiClient.convertToType(data['specification'], 'String');
	      }
	      if (data.hasOwnProperty('facebookPageUrl')) {
	        obj['facebookPageUrl'] = ApiClient.convertToType(data['facebookPageUrl'], 'String');
	      }
	      if (data.hasOwnProperty('introduction')) {
	        obj['introduction'] = ApiClient.convertToType(data['introduction'], 'String');
	      }
	      if (data.hasOwnProperty('phone')) {
	        obj['phone'] = ApiClient.convertToType(data['phone'], 'String');
	      }
	      if (data.hasOwnProperty('website')) {
	        obj['website'] = ApiClient.convertToType(data['website'], 'String');
	      }
	      if (data.hasOwnProperty('healthcareId')) {
	        obj['healthcareId'] = ApiClient.convertToType(data['healthcareId'], 'String');
	      }
	      if (data.hasOwnProperty('consultingConfig')) {
	        obj['consultingConfig'] = ConsultingConfig.constructFromObject(data['consultingConfig']);
	      }
	      if (data.hasOwnProperty('contact')) {
	        obj['contact'] = ApiClient.convertToType(data['contact'], [UserDoctorDataContact]);
	      }
	    }
	    return obj;
	  };
	
	  exports.prototype['_id'] = undefined;
	
	  exports.prototype['speciality'] = undefined;
	
	  exports.prototype['region'] = undefined;
	
	  exports.prototype['specification'] = undefined;
	
	  exports.prototype['facebookPageUrl'] = undefined;
	
	  exports.prototype['introduction'] = undefined;
	
	  exports.prototype['phone'] = undefined;
	
	  exports.prototype['website'] = undefined;
	
	  exports.prototype['healthcareId'] = undefined;
	
	  exports.prototype['consultingConfig'] = undefined;
	
	  exports.prototype['contact'] = undefined;
	
	  return exports;
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)(module)))

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	var _typeof2 = __webpack_require__(3);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var define = false;
	
	(function (root, factory) {
	  if (typeof define === 'function' && define.amd) {
	    define(['ApiClient'], factory);
	  } else if (( false ? 'undefined' : (0, _typeof3.default)(module)) === 'object' && module.exports) {
	    module.exports = factory(__webpack_require__(4));
	  } else {
	    if (!root.SymbimedApi) {
	      root.SymbimedApi = {};
	    }
	    root.SymbimedApi.UserDoctorDataContact = factory(root.SymbimedApi.ApiClient);
	  }
	})(undefined, function (ApiClient) {
	  'use strict';
	
	  var exports = function exports() {
	    var _this = this;
	  };
	
	  exports.constructFromObject = function (data, obj) {
	    if (data) {
	      obj = obj || new exports();
	
	      if (data.hasOwnProperty('name')) {
	        obj['name'] = ApiClient.convertToType(data['name'], 'String');
	      }
	      if (data.hasOwnProperty('type')) {
	        obj['type'] = ApiClient.convertToType(data['type'], 'String');
	      }
	      if (data.hasOwnProperty('value')) {
	        obj['value'] = ApiClient.convertToType(data['value'], 'String');
	      }
	      if (data.hasOwnProperty('_id')) {
	        obj['_id'] = ApiClient.convertToType(data['_id'], 'String');
	      }
	    }
	    return obj;
	  };
	
	  exports.prototype['name'] = undefined;
	
	  exports.prototype['type'] = undefined;
	
	  exports.prototype['value'] = undefined;
	
	  exports.prototype['_id'] = undefined;
	
	  return exports;
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)(module)))

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	var _typeof2 = __webpack_require__(3);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var define = false;
	
	(function (root, factory) {
	  if (typeof define === 'function' && define.amd) {
	    define(['ApiClient', 'model/Medication'], factory);
	  } else if (( false ? 'undefined' : (0, _typeof3.default)(module)) === 'object' && module.exports) {
	    module.exports = factory(__webpack_require__(4), __webpack_require__(58));
	  } else {
	    if (!root.SymbimedApi) {
	      root.SymbimedApi = {};
	    }
	    root.SymbimedApi.UserPatientData = factory(root.SymbimedApi.ApiClient, root.SymbimedApi.Medication);
	  }
	})(undefined, function (ApiClient, Medication) {
	  'use strict';
	
	  var exports = function exports() {
	    var _this = this;
	  };
	
	  exports.constructFromObject = function (data, obj) {
	    if (data) {
	      obj = obj || new exports();
	
	      if (data.hasOwnProperty('_id')) {
	        obj['_id'] = ApiClient.convertToType(data['_id'], 'String');
	      }
	      if (data.hasOwnProperty('birthPlace')) {
	        obj['birthPlace'] = ApiClient.convertToType(data['birthPlace'], 'String');
	      }
	      if (data.hasOwnProperty('birthDate')) {
	        obj['birthDate'] = ApiClient.convertToType(data['birthDate'], 'Date');
	      }
	      if (data.hasOwnProperty('disease')) {
	        obj['disease'] = ApiClient.convertToType(data['disease'], 'String');
	      }
	      if (data.hasOwnProperty('socialSecurity')) {
	        obj['socialSecurity'] = ApiClient.convertToType(data['socialSecurity'], 'String');
	      }
	      if (data.hasOwnProperty('mothersName')) {
	        obj['mothersName'] = ApiClient.convertToType(data['mothersName'], 'String');
	      }
	      if (data.hasOwnProperty('nextConsulting')) {
	        obj['nextConsulting'] = ApiClient.convertToType(data['nextConsulting'], 'Date');
	      }
	      if (data.hasOwnProperty('previousConsultations')) {
	        obj['previousConsultations'] = ApiClient.convertToType(data['previousConsultations'], ['Date']);
	      }
	      if (data.hasOwnProperty('medication')) {
	        obj['medication'] = ApiClient.convertToType(data['medication'], [Medication]);
	      }
	    }
	    return obj;
	  };
	
	  exports.prototype['_id'] = undefined;
	
	  exports.prototype['birthPlace'] = undefined;
	
	  exports.prototype['birthDate'] = undefined;
	
	  exports.prototype['disease'] = undefined;
	
	  exports.prototype['socialSecurity'] = undefined;
	
	  exports.prototype['mothersName'] = undefined;
	
	  exports.prototype['nextConsulting'] = undefined;
	
	  exports.prototype['previousConsultations'] = undefined;
	
	  exports.prototype['medication'] = undefined;
	
	  return exports;
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)(module)))

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _vue = __webpack_require__(12);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var define = false;
	
	exports.default = {
		getPosts: function getPosts(callback) {
			_vue2.default.http.get('https://blog.pulmoment.com//wp-json/wp/v2/posts').then(function (response) {
				callback(null, response.body);
			}, function (err) {
				if (err) {
					console.log(err);
				}
				callback(err.status);
			});
		}
	};

/***/ }),
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/phone_en_0.3d736ea.jpg";

/***/ }),
/* 215 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAbYAAABACAYAAAB2tVLAAAAACXBIWXMAAAsTAAALEwEAmpwYAAAKT2lDQ1BQaG90b3Nob3AgSUNDIHByb2ZpbGUAAHjanVNnVFPpFj333vRCS4iAlEtvUhUIIFJCi4AUkSYqIQkQSoghodkVUcERRUUEG8igiAOOjoCMFVEsDIoK2AfkIaKOg6OIisr74Xuja9a89+bN/rXXPues852zzwfACAyWSDNRNYAMqUIeEeCDx8TG4eQuQIEKJHAAEAizZCFz/SMBAPh+PDwrIsAHvgABeNMLCADATZvAMByH/w/qQplcAYCEAcB0kThLCIAUAEB6jkKmAEBGAYCdmCZTAKAEAGDLY2LjAFAtAGAnf+bTAICd+Jl7AQBblCEVAaCRACATZYhEAGg7AKzPVopFAFgwABRmS8Q5ANgtADBJV2ZIALC3AMDOEAuyAAgMADBRiIUpAAR7AGDIIyN4AISZABRG8lc88SuuEOcqAAB4mbI8uSQ5RYFbCC1xB1dXLh4ozkkXKxQ2YQJhmkAuwnmZGTKBNA/g88wAAKCRFRHgg/P9eM4Ors7ONo62Dl8t6r8G/yJiYuP+5c+rcEAAAOF0ftH+LC+zGoA7BoBt/qIl7gRoXgugdfeLZrIPQLUAoOnaV/Nw+H48PEWhkLnZ2eXk5NhKxEJbYcpXff5nwl/AV/1s+X48/Pf14L7iJIEyXYFHBPjgwsz0TKUcz5IJhGLc5o9H/LcL//wd0yLESWK5WCoU41EScY5EmozzMqUiiUKSKcUl0v9k4t8s+wM+3zUAsGo+AXuRLahdYwP2SycQWHTA4vcAAPK7b8HUKAgDgGiD4c93/+8//UegJQCAZkmScQAAXkQkLlTKsz/HCAAARKCBKrBBG/TBGCzABhzBBdzBC/xgNoRCJMTCQhBCCmSAHHJgKayCQiiGzbAdKmAv1EAdNMBRaIaTcA4uwlW4Dj1wD/phCJ7BKLyBCQRByAgTYSHaiAFiilgjjggXmYX4IcFIBBKLJCDJiBRRIkuRNUgxUopUIFVIHfI9cgI5h1xGupE7yAAygvyGvEcxlIGyUT3UDLVDuag3GoRGogvQZHQxmo8WoJvQcrQaPYw2oefQq2gP2o8+Q8cwwOgYBzPEbDAuxsNCsTgsCZNjy7EirAyrxhqwVqwDu4n1Y8+xdwQSgUXACTYEd0IgYR5BSFhMWE7YSKggHCQ0EdoJNwkDhFHCJyKTqEu0JroR+cQYYjIxh1hILCPWEo8TLxB7iEPENyQSiUMyJ7mQAkmxpFTSEtJG0m5SI+ksqZs0SBojk8naZGuyBzmULCAryIXkneTD5DPkG+Qh8lsKnWJAcaT4U+IoUspqShnlEOU05QZlmDJBVaOaUt2ooVQRNY9aQq2htlKvUYeoEzR1mjnNgxZJS6WtopXTGmgXaPdpr+h0uhHdlR5Ol9BX0svpR+iX6AP0dwwNhhWDx4hnKBmbGAcYZxl3GK+YTKYZ04sZx1QwNzHrmOeZD5lvVVgqtip8FZHKCpVKlSaVGyovVKmqpqreqgtV81XLVI+pXlN9rkZVM1PjqQnUlqtVqp1Q61MbU2epO6iHqmeob1Q/pH5Z/YkGWcNMw09DpFGgsV/jvMYgC2MZs3gsIWsNq4Z1gTXEJrHN2Xx2KruY/R27iz2qqaE5QzNKM1ezUvOUZj8H45hx+Jx0TgnnKKeX836K3hTvKeIpG6Y0TLkxZVxrqpaXllirSKtRq0frvTau7aedpr1Fu1n7gQ5Bx0onXCdHZ4/OBZ3nU9lT3acKpxZNPTr1ri6qa6UbobtEd79up+6Ynr5egJ5Mb6feeb3n+hx9L/1U/W36p/VHDFgGswwkBtsMzhg8xTVxbzwdL8fb8VFDXcNAQ6VhlWGX4YSRudE8o9VGjUYPjGnGXOMk423GbcajJgYmISZLTepN7ppSTbmmKaY7TDtMx83MzaLN1pk1mz0x1zLnm+eb15vft2BaeFostqi2uGVJsuRaplnutrxuhVo5WaVYVVpds0atna0l1rutu6cRp7lOk06rntZnw7Dxtsm2qbcZsOXYBtuutm22fWFnYhdnt8Wuw+6TvZN9un2N/T0HDYfZDqsdWh1+c7RyFDpWOt6azpzuP33F9JbpL2dYzxDP2DPjthPLKcRpnVOb00dnF2e5c4PziIuJS4LLLpc+Lpsbxt3IveRKdPVxXeF60vWdm7Obwu2o26/uNu5p7ofcn8w0nymeWTNz0MPIQ+BR5dE/C5+VMGvfrH5PQ0+BZ7XnIy9jL5FXrdewt6V3qvdh7xc+9j5yn+M+4zw33jLeWV/MN8C3yLfLT8Nvnl+F30N/I/9k/3r/0QCngCUBZwOJgUGBWwL7+Hp8Ib+OPzrbZfay2e1BjKC5QRVBj4KtguXBrSFoyOyQrSH355jOkc5pDoVQfujW0Adh5mGLw34MJ4WHhVeGP45wiFga0TGXNXfR3ENz30T6RJZE3ptnMU85ry1KNSo+qi5qPNo3ujS6P8YuZlnM1VidWElsSxw5LiquNm5svt/87fOH4p3iC+N7F5gvyF1weaHOwvSFpxapLhIsOpZATIhOOJTwQRAqqBaMJfITdyWOCnnCHcJnIi/RNtGI2ENcKh5O8kgqTXqS7JG8NXkkxTOlLOW5hCepkLxMDUzdmzqeFpp2IG0yPTq9MYOSkZBxQqohTZO2Z+pn5mZ2y6xlhbL+xW6Lty8elQfJa7OQrAVZLQq2QqboVFoo1yoHsmdlV2a/zYnKOZarnivN7cyzytuQN5zvn//tEsIS4ZK2pYZLVy0dWOa9rGo5sjxxedsK4xUFK4ZWBqw8uIq2Km3VT6vtV5eufr0mek1rgV7ByoLBtQFr6wtVCuWFfevc1+1dT1gvWd+1YfqGnRs+FYmKrhTbF5cVf9go3HjlG4dvyr+Z3JS0qavEuWTPZtJm6ebeLZ5bDpaql+aXDm4N2dq0Dd9WtO319kXbL5fNKNu7g7ZDuaO/PLi8ZafJzs07P1SkVPRU+lQ27tLdtWHX+G7R7ht7vPY07NXbW7z3/T7JvttVAVVN1WbVZftJ+7P3P66Jqun4lvttXa1ObXHtxwPSA/0HIw6217nU1R3SPVRSj9Yr60cOxx++/p3vdy0NNg1VjZzG4iNwRHnk6fcJ3/ceDTradox7rOEH0x92HWcdL2pCmvKaRptTmvtbYlu6T8w+0dbq3nr8R9sfD5w0PFl5SvNUyWna6YLTk2fyz4ydlZ19fi753GDborZ752PO32oPb++6EHTh0kX/i+c7vDvOXPK4dPKy2+UTV7hXmq86X23qdOo8/pPTT8e7nLuarrlca7nuer21e2b36RueN87d9L158Rb/1tWeOT3dvfN6b/fF9/XfFt1+cif9zsu72Xcn7q28T7xf9EDtQdlD3YfVP1v+3Njv3H9qwHeg89HcR/cGhYPP/pH1jw9DBY+Zj8uGDYbrnjg+OTniP3L96fynQ89kzyaeF/6i/suuFxYvfvjV69fO0ZjRoZfyl5O/bXyl/erA6xmv28bCxh6+yXgzMV70VvvtwXfcdx3vo98PT+R8IH8o/2j5sfVT0Kf7kxmTk/8EA5jz/GMzLdsAAAAgY0hSTQAAeiUAAICDAAD5/wAAgOkAAHUwAADqYAAAOpgAABdvkl/FRgAAF9RJREFUeNrsnXm8lmP6wL+n7UghKhQSkbIvhcGMNaPfMERGMllGY/cb29i3sTVj8LM2VIYkZcuaBoUsY40SU4hIKqKVttPp/P64rjO9Pee+n/fZ3vc973F9P5/zoed932e5n/u+r/ta74qamhoMwzAMo6HQyJrAMAzDMMFmGIZhGCbYDMMwDMMEm2EYhmGYYDMMwzBMsBmGYRhGg6BJ2If7XG0NZBSEK4DjgO+A84D3rEkMw4jD61cXRmM7C7gf2M+a2IjBpcA1wDbAL4HngN2sWQzDKIrGFsJwoK/+f1/9eyzk+02Bg4FqYGGBn6lC/1YAc4CvMzrv2kBXfYaahPe1EqgCFgDz9R5/TnQGrg8cawtcDBxtw9EwjFIJthFAn4DQehQYq5PUKF2R51IN7AlcXuTn+wGYAtwH/DPFeXoCdwIdVaitSijYqlW4Lda/b4DJwNvAOBXEDV2wuehkQ9EwjFIItsbAAwGhlstB+t+dgHbA6TmfrUL8KquAK4v4fK2BffSvD3ByAg1uC2AksG6gLZK2dyXQAtgY2Box5Z4NzEXMcv8EXm2g/c2n6a60oWgYRlbE8bGNZLX5MR+nAbc7jl8FXFCiZ+0BjFFhF4cDA0KtULQFTgDGq1a8SQPsb6tiHjcMwyiIYGuC+M96xzz32cBgx/GbgQtL9LzbAQ/G/E3jEtxnHyRS8HDrooZhGNkKtgNVezgq4fn7A3c4jv8dOL9Ez3yIPldUSmUm2xh4EgmLNwzDMCKSz8d2HRL0kYazgOYq5HK5JUeDKzanIcEaaZgMDEP8ZVFNus0Qs2Z7oAOwLeJzC+NBxP/2gnVXwzAaIN2B7YGHgOXFEGxTMxBsIEEb1cCpDuFWDdxa5IbsqgIlTSO+qZpnUpqqYDsY6AfsEPLdYYgZ9XsbA4ZhNCD2A54AWgEtcVv4YpNP0/gTcGxGD3AKEnYf5Da9TjHZQP/SsE7K31cBk1Q47gKcqcdcbAjcaGPAMIwGxG+B51WoAXTJ6sT5BNsiJBqyT0bXOxGpVhLkdsRkWSwakTw5vRBUAwN19eLTyn6PpB4YhmGUO0cCDyPumVp+LJZgq+Vh4IyMrnmCR7jdVUThVkOy6iGF5t/4o0+bEj3dwjAMo77yO+BxYK1Cai5R+QfwRobCbbhHuJ2W57fPIMnfhwBHINVMPmxAL308cK/ns31tTBiGUcachFgBXSzP6iJxzHHrIL6erOgLLAH+GDh+D5KwOyjn2AKV8PcA7wa+/xTwf8A51K1DWK4MAv6AlOHKpSvQhvAgkkqk+suyAgn8xsCuev7JJWyjdZHgm7nA5xEWcNsCOyMRqS1UY5+H+DknkryGaWfEN7AVqxP5fwQ+0/N+VcQ26QBsjlS0aY1EI1fou1qo9zRD/1sIOiGFBqbqmA2jLVIIewe912ZI7dQZwATg4xT9ogsSbLWxagUrkfJ6te/6pyK9j87aJlsB6yFWlyqd975Byv1N039nSUft55/p+MhHS30PO+scX6FCZi7wid5nFoFrJwND8swttXKpwiGrlhZCsBXCfNcfcRwGC+AORooOn4nUoRwCTA85zxLgBmAW7gCVcuNDpPRXh8DxTbXT+jpZN33+7fXfI1RALsvovnZBSn7trP9+UldgC4rcPgfqIqeTPttA3HmRG+nCqZcKYx9fIKHGg4hWcm1DJL/wSGAPnbBcLELSSm5CzMyFYDPEB95Tn3G9PN9fAXyg9/VQCgES5G9IUYbmOlbPRCr9BPmljvuDdPL18Zq+j6gFFbppXzxYBYmPT4BHdDE8vwDvo6Mu2nsCu7OmD8nFFH3We4F3Mrj+eUiFp3V1Prw8ZE7cRYXNwboY8jETKfd3V4rF8tm4q1EF5cEBuhgJCramOs8Mxu3KWoOKmhq/rHLsx7Yv8BLZb1A6DDjes/paFPNczwK/yfOdOUjuxMwUq4wRFNbnNcEzGe8PvOJpqwmOQX0lcG0G99McKdYcTEu4nehRrT11gAR5m+hpJesDn6rmGhwUuSbcs4CLdDEQldk6AB/PM/iuVIESlWrgr2RbBHxdZFeEU0ke4btEhdsNeRaO+TjGYV5arFrT1zkWn1t0oRVn/ngeiaie4fl8Y+AvSGBasxjnnaJt91pG76MSuEz7T6sEv6/SfndpindxEPCi43h31tzzcBOdE44lnp9rKVLzN27u8YW68MmKnsDY16/2F8+IK6DGI76t6own8X66inKteF3sgYTJn+347DoaBtV51HVXm7hWqkdkdD9b4861OzjmhJKWvRxCjYDWPwjJh9k05rnbIeXj/ur4bANkB4vBMYVa7Tu7TDXLLOilZrVLSJe2srYK6kmkCw7r5Ti2ji7CAH6h1+ifYM75tf7W5V/urZ+dkqAPdgVejrAIjsK2qgVfkVCo1WokffR5/pjwHL/1HP+fnP8/Xq9xEvGDN5qr9WFkjN9clrFQq11IbRn2hSSa14s6WS7P+GaPRqIv85mgHlCzzgWqLQQnobcyUulLTdOQlZ2LJjG/HxdfX1lJcVMnfO3yrf73vhQTQy0XsWaEbhvgX8QrxebidF2Rp+EkZGuojhm26TpqZro94e99RaxnqIb9NOlSVVohLonNApPbo6Tz+zdGTJ3bpDjHzmqF6JrhuxiUsJ/4Fr0L9L8XA0OJXwjeJVhui/C94wqkaEwlj88vqUnx2cAqICt+p521VeBF9wNe1xVzv8B9n4/4UnIZUuZCbX2PtlGF3y9QHSJ4smBVyHWLWZ3f95zfIwFEJ3o+X6bf+ZZogSJ3IIEYIAFK3UPuZ76ed36Etrie1T7KuJxKtH0Fa4MlpiFm2+8iLkTPRvYdjMtKT3/prEK4jed3i/Xe5pI/gKItq/1tO+fRGn7Sc84lvyujFeIKScLmyBZTm4d8ZxYSyX0nYvK9WRfwUyP0k1Ni3o9vEfuDLqoGhPx2uX7vOxWE+eIp/lfn4jAqCzD+n1ahOi/sS2lW2i8hZsnHkKiarOiNODWf1hd1qKr6Yc9wVMDM8wTiHG5RpoJtT89k8KX+GXU5XhcEQcZoH52oE91KXSx11MXZaSED8AL93V6Oz97SCeodxDe3TE07myL7/52O32R5I2LCjcP+wN15vjNeF4bv64S6QAXMeogvqjtiNuwRco4ztY/dlMFC6EbqBrPMU6H0LxW8C5FAgdbAjkgq0EGec/5KtYCTPZP6E7oI+TBncm6J+Pp6IUUOXHTXeeexmJaDh/BXIJqC+BSfybEmBCf9g9Uy4OsLdyPBPWnSrGqQjZ+39Hz2uI6RSbrwW6HzZnu1UPwBv0n/Zl24+KJM70Millvp+6nQ7x5H3drBaHvWBg662nsh7viCTAUbiGP3KFXFs9zepRNwbkzzzMDA6n1UhBVFfcW3Z91kXeUadWnjmFjOwV08erZqMi/owH4St6/KVTBgob6f+zza43QkIOF+ndR2c3ynh2odE2No8GFaxWy911EhmtFMJIDgH4gr4VpWR88G+btaRyameB9NHEJtsJqmXIEg36hAehDxVV3jOa8rSvJV1TZ9EXufaNuMQVwZrrnq3JiC7RzPggd9V2cQXkljufaPZ/Teb3VY0CqQgKg0paYqPEJtpC5eJnh+N03bdaAKnAM8WvSJiBnbJ1THO477+t1HUQVXPrKIbnxBB2opJ9xurHZU11Ku5sg/eToRwGiTX5F4VrXeKDsivBaykg/yvva1IeQPoJqtiz6f2TNOmboB+DeefV01jlExzvckEtDxVMh3Bmb8Ts4jPLoxl2tV84zCrUgpuihh6A+p0HSxl2cR4qI1EhnrYrhaD+KUh7oDCfxwmXS3Ue0/KxaoMDo2RKjl8i2yL+Q0z+dJlIf1Yx4viWADiS7qRXaBCkno65iwJpXZhNwf/04H83VCMsIZDRxGvDSRMSq0wvgaiaCbFuO8X4VoAXtTN1fHxea4TW+12uGhqu3E5UfV3F7yfP4LsvOjn4q4BuIwgPz+yoGqacXJr70Lt2kQJLI4Cqfjdr98jN/HG6Xf/jnEgpNF5PE8JFR+aIK+cpXns12IHzhTE/N4yQQbSMLnASXU3I5W1Ti3kQYV8HpZpjzsxGr7ctgqdp7JrVC+QAKQkhCm8fykE8KcBOf1RfpuSbRQ/ZNwuwxWap9fmLLNjsSflH5mBu/kpoTj8IM8C9MXE97fohDLx64Rft8c8Tu5OIN0wVq34k7k3xJ3SkUcvlZrw1spxscsx/FmhG+5VRLSCLYKj1nkcDKs0hyD9ahbweRRClc+J6l22hjJl9pNB8hIJEE5bHug90gWrfZzYolqNknLE4VV4LiU5BU6PsFdCmhd8lcJaYx/9/phRDMl5WMh/gT+/UmXVvBmiBYSte1czCVdSodPYLaN8NvdcKcuvIL4pNJyi+d4zxTn/A4JjkmThL9M36eL9vVtMkgbPNIL+E+gA76MRNO8oqubYnIKa/oG5iJ+hEJUCDkUcfyuHWGBUKPfqdTJrE3EQYRqCUdSWjNvOfAC6RzPM3Hn5M0k3eaH83Sl28mx8s8n2Gp3FnZpa1nuPH8/YmraxHGPPZGAk6QaSBp8Zt+hpKvB+Z3neJSEZV/E5oiM3sWLSPBbMBhqT30fSxOc8xayye39NMWCoGwEW41qZzchdtZcn8Y7OiBGkX5DzzjspB0gV91+oECCra0Kt0IyC/HrfI0RZUWZhh+RUOfgmFiuC5Kk51/u0SIb4082r8Xnu0hTJNhnfRiNO29qx4ytOnFYlLG1JN95o9zvTp7j4zJ6F4uQQu9BDa2TakafJ+yDWfBTigVBUUnrY5uK2H/HUNeZOh4ph7O0yM90UuDfr6ZUwUvFM0ik1kSTWZHIwrlekVAAhVGdYiL2CbZXCtB+vlypLiV8JzVFPm9NhOfp6FkU1Vpj1k/51xJ3Rf4mJDcLZyV4VpXLZNAko4lgLyTv5VDWLHXyHmKnH036Mi5RORyx69euypaqSaNcdp+ehpQ2ugOjmFTUw3vq4DleiG1nfGamTXSeWNmA3knS866Hu4RXJZJiUkV6K1gVdSsp5b6L+jhG6t2mzU0yfNA9VMvYnzXNNm8jORpjKY7Pbb5jhdyc+s1iNT88gkTRLTA5Y4T020UFuNYCVldPCU7aLUgffdkQqMRfFaMYC+f17BUUR7AF2RPJHzuMNUOj/43k7TxPYR2N7yN+glzzZzvS+QnCBOinMdqwQgXuCiSg4FskiXcSUlFkmnVHI4DP5LakANdahvhQ1nJM2k3tVQBilm5cwuvbgrdEgg0kV+JxFW65eVcfIAmhY1i903BWvIRESj1MXUfp0QW4HkituxNUYEU1bayi+EWDjfJlVcgEmzWNPPNBITYYLldK2RYzdc4xSiTYQHxu45HinrMdmts40m03UasxPUB4Pk87/BnzaanCQvCNwrLCc7xlAa7V0nPeFWS3A3u5s9Iz5quQ2qRZb+HUSBcxE5FSYHPtFZRWsIHk34xBfG65W618pNrcaPzbWYQxESmE+gjhYfDtVXMsVLpBuZhnbLVdvvh8aYUw52/s0QQXU7giB+XGMiQCsrVjjB2B5NZlOS9U6LmXW9PXH8EGkvPxCpKLNTPn+DtI4dLXiFb4crkKwiFIAmNYhFZrpIrHldTDxMESUGFNULZM8RzvVqCx6sJ8v6tZiMQOBPdfa4akPU03IVQ/aFSEa+yomlu7wPGPEVPlzJDfzkK20NgbKS00JkSo7Yjspj0BCZX/uQk1nz+meYaD2iguvrD+/cg+0te3O/hUew3/pRp/Tuxh1jw/L8EGYpZ0RUS+h2TYB7PpP0AqaO8CXIjfh9YEqUD+OFJt5CLCd7NtyKzAbXbcIKNJsLsNl6LzLu4IyE3x15BMwuYhgu0tew115iYXvan/aUUm2ArADkgVkK0Dxz9CTCv9kc0FD0GqbN+Nv6ZbO2Rr8jcRE+WR1qn4HneVl/bAVhkItcE2XIrODKT2qosLM7zOJbjdEjNDrv9zxbfNzybE2xzZqMeCLa7/pguyp1gwInIBslPsVarZ+dgJ2W5+InAbhfE1lCvT8W8rsVeK8+6ki4dW1sQlYXjIQvGaDM7/a2S/NBePYDu2B5mA5J26uBTobE2UWG7Um/3YkgQmbIuYWKImTTdDctFeVIH2Z9KnClTQ8IIqluKv4H1WwnMehgT4WBBO6XgU+NLz2RXIbs1J2R0x47tYQfKq/g2ZGvy7i7dAdpnYwpopEZnl96YVbEnzuDoguWy98SebdgDOR/xwj+DfLiLpfTfE3JxnPce3x7/Pk4smSCDO08A6Nt5KykoVYD6GIhHAcTkGSfht4fn8Liwi0scw3NYREH/laGQH8qR0QMzD4xCXTJsG1n6+TZo7ZXWBtOH+X6b4bRtdjU5BzI+fII7yNoj56zCipQIkYTYNczfqUYhfZFPHZ+cide5uQHw3LloDxyGBO10w6gsPIikzfTyf/wWJML4DeA6/+bA5EmF8FlIs3McUJBDLcPOTtqFv1/WuSDGKoUgRibcJzwWsUKvIPvqee+XMfQcAv0QiYRtKgrZvL70jENP486UWbG8gJrA0gRtd8W/PUSjeCFk1lDPLgQG62nZxKmLWHa2r8dlqWmmPBPXs5xGKNTpAD6V4uzQYdd9dN/yBQHvr31QkSOtTnUCqgc2QPKtfIZHGYfyo2pxV1QnnCWQj1XNCvnOC/n2M1LGdjSTdr9Q5c20dT1sgPlOfZratCrdRDaTtfJGlzVTZuQpxq/yEWBU3UgHfCfhGF+ezCynYZiJJ02eXWcPek8E56quPbqBqu4d4Pt8A6BfznP0QM2efArWZJZHnZxESkj+WupHFuXRJqW33wh8c0VDIqr+di0RDHp3ne9vpX9q5tqG05xTExeQK/luH1W6T5SrYgtVc9kfym4f6LpBFuP/VSKX6cuF64iWdNot5vD7we8S0m5YlKtSGqyZX6fhO0xgd27eQilOGyPfdygysF808522UctD7+krcYsYz1FTzegH6zGeq0Y1N8NvKAr2TygK+66zG9DGquRWSa/EHhkVpl6w2Gq3MqN1qEPN5lOs19SwUTg/7YRaCbZ6uWBZR/xkKXB7zNws8x3+ox8/5A5L4/maKc7yrk+iDOULOxVKilxHyOdzjVDX5NkQIp20zl/ltRcpzV+OvlpNkQTgd2Be4iezM6Y8gZszXEv5+cYbPF9RSXcxPeV6fGStJQFmNam798fuukzIW8YVGDQ7y5f1m5ZtblOF7fha4LsW9zCi0YEMHxK5Iyav6yHwkyujEBL99jrqVT+YCd9ZzIT4dscv/LabgmIyYlncPaAbTkZ29g9xC9DDdD3DnZcVZ8b6j7ySXKs+9xWGWCosgA0jvb7rdc+yLhOdbhaS9dAPuI9k+XVVITun+qnWkmfzucgj/lxNqf7k8hBRwyOVrxP2RhveBpxwLkDSa171I0NvFwIcpzrNMFxqHAD2QyOSoDHEsHj/VdsyCYY4+O02fPQlX6FwzJ+a8diJ5kuEramr8OXH7XJ3oZn+DRNZ1Q7bBKMXeY420o36L5OmMxF/jLQptgZuREN6vkDSESZQPnYC+SIWWjtRNtp6NRHGNUKGxNORclyLmyeWInXt4zHtprML2UCRQ4ZqYgxftVzeoVjpbzRrjMmqri/X5qvSdD8vovH2RaiGVSCDOgAzfb0ckKrInkh/ajroBXVU6gXyuq+UXyNaXtp++h3ZIdY4LM7LitFfBuT0ShHEJ/uLQcVgLMfEdrtr65Rn2oebIpss9dXHZEQkMaeJZdM/RRd84HYdp6nN20X7bWS02l2esSW6t43cHXXScgz/KMSqbIhtE99b/D6YY/ajKxQNI0M58gNevLq5gQ1f7u+sEWirBtlJf6PNkYzbsrp31c4fGUA5siJgWd0Ci5FpoOy0C/qMr7DcinGcjJMBgCWKmXJVwcPTQDjoi4fN0RXIbZ2pnz4q2+nzLVGhnGT17vE56o8g+dLtSx1w3JAJyQ71WhT7LPF1tf6wWlkIUtT5c+9b4jIXmvqoNTSbbEl+dVPjMAR4rQHt01PexnQro1og/qkIXGov02l+oFjmR8J1LotJDBdzbRPPNJX0fk/RdZ0F7Xex20THYEvGvrVKt8BWdd//bPokFm2EYhmGUG42sCQzDMAwTbIZhGIZhgs0wDMMwTLAZhmEYhgk2wzAMwwSbYRiGYTQI/n8Axm4ZwTISneUAAAAASUVORK5CYII="

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(311)
	
	var Component = __webpack_require__(5)(
	  /* script */
	  __webpack_require__(238),
	  /* template */
	  __webpack_require__(418),
	  /* scopeId */
	  "data-v-4bc4e308",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 217 */,
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./appstore.png": 342,
		"./flag_gb.png": 44,
		"./flag_hu.png": 45,
		"./home-phone-cropped-1.png": 346,
		"./home_bg_patient.png": 347,
		"./logo_icon_grey.png": 213,
		"./pattern.png": 358,
		"./pattern_fixed_transparent.png": 359,
		"./placeholder.png": 365,
		"./playstore.png": 366,
		"./pulmoment_wide.png": 215
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 218;


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	var _typeof2 = __webpack_require__(3);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var define = false;
	
	(function (root, factory) {
	  if (typeof define === 'function' && define.amd) {
	    define(['ApiClient', 'model/ArrayResponse', 'model/DataResponse', 'model/ErrorResponse', 'model/InlineResponse200', 'model/InlineResponse2001', 'model/MessageResponse', 'model/Params', 'model/Params1', 'model/Params2', 'model/Params3', 'model/Params4', 'model/Params5', 'model/Report', 'model/Status', 'model/User'], factory);
	  } else if (( false ? 'undefined' : (0, _typeof3.default)(module)) === 'object' && module.exports) {
	    module.exports = factory(__webpack_require__(4), __webpack_require__(47), __webpack_require__(49), __webpack_require__(51), __webpack_require__(55), __webpack_require__(56), __webpack_require__(59), __webpack_require__(60), __webpack_require__(61), __webpack_require__(62), __webpack_require__(63), __webpack_require__(64), __webpack_require__(65), __webpack_require__(66), __webpack_require__(68), __webpack_require__(19));
	  } else {
	    if (!root.SymbimedApi) {
	      root.SymbimedApi = {};
	    }
	    root.SymbimedApi.DefaultApi = factory(root.SymbimedApi.ApiClient, root.SymbimedApi.ArrayResponse, root.SymbimedApi.DataResponse, root.SymbimedApi.ErrorResponse, root.SymbimedApi.InlineResponse200, root.SymbimedApi.InlineResponse2001, root.SymbimedApi.MessageResponse, root.SymbimedApi.Params, root.SymbimedApi.Params1, root.SymbimedApi.Params2, root.SymbimedApi.Params3, root.SymbimedApi.Params4, root.SymbimedApi.Params5, root.SymbimedApi.Report, root.SymbimedApi.Status, root.SymbimedApi.User);
	  }
	})(undefined, function (ApiClient, ArrayResponse, DataResponse, ErrorResponse, InlineResponse200, InlineResponse2001, MessageResponse, Params, Params1, Params2, Params3, Params4, Params5, Report, Status, User) {
	  'use strict';
	
	  var exports = function exports(apiClient) {
	    this.apiClient = apiClient || ApiClient.instance;
	
	    this.createStatus = function (params, callback) {
	      var postBody = params;
	
	      if (params === undefined || params === null) {
	        throw new Error("Missing the required parameter 'params' when calling createStatus");
	      }
	
	      var pathParams = {};
	      var queryParams = {};
	      var headerParams = {};
	      var formParams = {};
	
	      var authNames = ['isDoctor'];
	      var contentTypes = ['application/octet-stream', 'application/json', 'application/x-www-form-urlencoded', 'multipart/form-data'];
	      var accepts = ['application/json'];
	      var returnType = DataResponse;
	
	      return this.apiClient.callApi('/status', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, callback);
	    };
	
	    this.findDoctorByName = function (name, callback) {
	      var postBody = null;
	
	      if (name === undefined || name === null) {
	        throw new Error("Missing the required parameter 'name' when calling findDoctorByName");
	      }
	
	      var pathParams = {};
	      var queryParams = {
	        'name': name
	      };
	      var headerParams = {};
	      var formParams = {};
	
	      var authNames = [];
	      var contentTypes = ['application/octet-stream', 'application/json', 'application/x-www-form-urlencoded', 'multipart/form-data'];
	      var accepts = ['application/json'];
	      var returnType = User;
	
	      return this.apiClient.callApi('/public/doctor', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, callback);
	    };
	
	    this.forgottenPassword = function (params, callback) {
	      var postBody = params;
	
	      if (params === undefined || params === null) {
	        throw new Error("Missing the required parameter 'params' when calling forgottenPassword");
	      }
	
	      var pathParams = {};
	      var queryParams = {};
	      var headerParams = {};
	      var formParams = {};
	
	      var authNames = [];
	      var contentTypes = ['application/octet-stream', 'application/json', 'application/x-www-form-urlencoded', 'multipart/form-data'];
	      var accepts = ['application/json'];
	      var returnType = MessageResponse;
	
	      return this.apiClient.callApi('/forgot', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, callback);
	    };
	
	    this.getAirDetails = function (cityName, callback) {
	      var postBody = null;
	
	      if (cityName === undefined || cityName === null) {
	        throw new Error("Missing the required parameter 'cityName' when calling getAirDetails");
	      }
	
	      var pathParams = {
	        'cityName': cityName
	      };
	      var queryParams = {};
	      var headerParams = {};
	      var formParams = {};
	
	      var authNames = ['isDoctor'];
	      var contentTypes = ['application/octet-stream', 'application/json', 'application/x-www-form-urlencoded', 'multipart/form-data'];
	      var accepts = ['application/json'];
	      var returnType = ArrayResponse;
	
	      return this.apiClient.callApi('/weather/air/{cityName}', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, callback);
	    };
	
	    this.getConfig = function (opts, callback) {
	      opts = opts || {};
	      var postBody = null;
	
	      var pathParams = {};
	      var queryParams = {
	        'lang': opts['lang']
	      };
	      var headerParams = {};
	      var formParams = {};
	
	      var authNames = [];
	      var contentTypes = ['application/octet-stream', 'application/json', 'application/x-www-form-urlencoded', 'multipart/form-data'];
	      var accepts = ['application/json'];
	      var returnType = DataResponse;
	
	      return this.apiClient.callApi('/survey/config', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, callback);
	    };
	
	    this.getConsultingConfig = function (callback) {
	      var postBody = null;
	
	      var pathParams = {};
	      var queryParams = {};
	      var headerParams = {};
	      var formParams = {};
	
	      var authNames = ['isDoctor'];
	      var contentTypes = ['application/octet-stream', 'application/json', 'application/x-www-form-urlencoded', 'multipart/form-data'];
	      var accepts = ['application/json'];
	      var returnType = DataResponse;
	
	      return this.apiClient.callApi('/consulting/config', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, callback);
	    };
	
	    this.getData = function (opts, callback) {
	      opts = opts || {};
	      var postBody = null;
	
	      var pathParams = {};
	      var queryParams = {
	        'patientId': opts['patientId'],
	        'period': opts['period']
	      };
	      var headerParams = {};
	      var formParams = {};
	
	      var authNames = ['isLoggedIn'];
	      var contentTypes = ['application/octet-stream', 'application/json', 'application/x-www-form-urlencoded', 'multipart/form-data'];
	      var accepts = ['application/json'];
	      var returnType = DataResponse;
	
	      return this.apiClient.callApi('/patient/health/data', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, callback);
	    };
	
	    this.getDoctorById = function (id, callback) {
	      var postBody = null;
	
	      if (id === undefined || id === null) {
	        throw new Error("Missing the required parameter 'id' when calling getDoctorById");
	      }
	
	      var pathParams = {
	        'id': id
	      };
	      var queryParams = {};
	      var headerParams = {};
	      var formParams = {};
	
	      var authNames = [];
	      var contentTypes = ['application/octet-stream', 'application/json', 'application/x-www-form-urlencoded', 'multipart/form-data'];
	      var accepts = ['application/json'];
	      var returnType = User;
	
	      return this.apiClient.callApi('/doctor/{id}', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, callback);
	    };
	
	    this.getFeed = function (opts, callback) {
	      opts = opts || {};
	      var postBody = null;
	
	      var pathParams = {};
	      var queryParams = {
	        'userCreated': opts['userCreated'],
	        'limit': opts['limit'],
	        'skip': opts['skip'],
	        'since': opts['since']
	      };
	      var headerParams = {};
	      var formParams = {};
	
	      var authNames = [];
	      var contentTypes = ['application/octet-stream', 'application/json', 'application/x-www-form-urlencoded', 'multipart/form-data'];
	      var accepts = ['application/json'];
	      var returnType = [Status];
	
	      return this.apiClient.callApi('/status', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, callback);
	    };
	
	    this.getGlobalInfo = function (callback) {
	      var postBody = null;
	
	      var pathParams = {};
	      var queryParams = {};
	      var headerParams = {};
	      var formParams = {};
	
	      var authNames = ['isDoctor'];
	      var contentTypes = ['application/octet-stream', 'application/json', 'application/x-www-form-urlencoded', 'multipart/form-data'];
	      var accepts = ['application/json'];
	      var returnType = DataResponse;
	
	      return this.apiClient.callApi('/doctor/global', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, callback);
	    };
	
	    this.getGlobalReport = function (opts, callback) {
	      opts = opts || {};
	      var postBody = null;
	
	      var pathParams = {};
	      var queryParams = {
	        'languageId': opts['languageId']
	      };
	      var headerParams = {};
	      var formParams = {};
	
	      var authNames = ['isDoctor'];
	      var contentTypes = ['application/octet-stream', 'application/json', 'application/x-www-form-urlencoded', 'multipart/form-data'];
	      var accepts = ['application/json'];
	      var returnType = DataResponse;
	
	      return this.apiClient.callApi('/doctor/report/pdf', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, callback);
	    };
	
	    this.getGlobalSymptoms = function (callback) {
	      var postBody = null;
	
	      var pathParams = {};
	      var queryParams = {};
	      var headerParams = {};
	      var formParams = {};
	
	      var authNames = ['isDoctor'];
	      var contentTypes = ['application/octet-stream', 'application/json', 'application/x-www-form-urlencoded', 'multipart/form-data'];
	      var accepts = ['application/json'];
	      var returnType = DataResponse;
	
	      return this.apiClient.callApi('/doctor/symptoms', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, callback);
	    };
	
	    this.getInfo = function (callback) {
	      var postBody = null;
	
	      var pathParams = {};
	      var queryParams = {};
	      var headerParams = {};
	      var formParams = {};
	
	      var authNames = [];
	      var contentTypes = ['application/octet-stream', 'application/json', 'application/x-www-form-urlencoded', 'multipart/form-data'];
	      var accepts = ['application/json'];
	      var returnType = DataResponse;
	
	      return this.apiClient.callApi('/info', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, callback);
	    };
	
	    this.getPatientList = function (opts, callback) {
	      opts = opts || {};
	      var postBody = null;
	
	      var pathParams = {};
	      var queryParams = {
	        'order': opts['order'],
	        'asc': opts['asc'],
	        'skip': opts['skip'],
	        'limit': opts['limit'],
	        'emailPrefix': opts['emailPrefix']
	      };
	      var headerParams = {};
	      var formParams = {};
	
	      var authNames = ['isDoctor'];
	      var contentTypes = ['application/octet-stream', 'application/json', 'application/x-www-form-urlencoded', 'multipart/form-data'];
	      var accepts = ['application/json'];
	      var returnType = [User];
	
	      return this.apiClient.callApi('/doctor/patients', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, callback);
	    };
	
	    this.getRecords = function (callback) {
	      var postBody = null;
	
	      var pathParams = {};
	      var queryParams = {};
	      var headerParams = {};
	      var formParams = {};
	
	      var authNames = ['isLoggedIn'];
	      var contentTypes = ['application/octet-stream', 'application/json', 'application/x-www-form-urlencoded', 'multipart/form-data'];
	      var accepts = ['application/json'];
	      var returnType = DataResponse;
	
	      return this.apiClient.callApi('/patient/record', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, callback);
	    };
	
	    this.getReport = function (opts, callback) {
	      opts = opts || {};
	      var postBody = null;
	
	      var pathParams = {};
	      var queryParams = {
	        'patientId': opts['patientId'],
	        'fromDate': opts['fromDate'],
	        'toDate': opts['toDate']
	      };
	      var headerParams = {};
	      var formParams = {};
	
	      var authNames = ['isLoggedIn'];
	      var contentTypes = ['application/octet-stream', 'application/json', 'application/x-www-form-urlencoded', 'multipart/form-data'];
	      var accepts = ['application/json'];
	      var returnType = Report;
	
	      return this.apiClient.callApi('/patient/health/report', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, callback);
	    };
	
	    this.getStatusById = function (id, callback) {
	      var postBody = null;
	
	      if (id === undefined || id === null) {
	        throw new Error("Missing the required parameter 'id' when calling getStatusById");
	      }
	
	      var pathParams = {
	        'id': id
	      };
	      var queryParams = {};
	      var headerParams = {};
	      var formParams = {};
	
	      var authNames = ['isLoggedIn'];
	      var contentTypes = ['application/octet-stream', 'application/json', 'application/x-www-form-urlencoded', 'multipart/form-data'];
	      var accepts = ['application/json'];
	      var returnType = Status;
	
	      return this.apiClient.callApi('/status/{id}', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, callback);
	    };
	
	    this.invitationRequest = function (opts, callback) {
	      opts = opts || {};
	      var postBody = null;
	
	      var pathParams = {};
	      var queryParams = {};
	      var headerParams = {};
	      var formParams = {
	        'name': opts['name'],
	        'email': opts['email'],
	        'phone': opts['phone'],
	        'website': opts['website']
	      };
	
	      var authNames = [];
	      var contentTypes = ['application/octet-stream', 'application/json', 'application/x-www-form-urlencoded', 'multipart/form-data'];
	      var accepts = ['application/json'];
	      var returnType = DataResponse;
	
	      return this.apiClient.callApi('/patient/invite', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, callback);
	    };
	
	    this.listDoctors = function (callback) {
	      var postBody = null;
	
	      var pathParams = {};
	      var queryParams = {};
	      var headerParams = {};
	      var formParams = {};
	
	      var authNames = [];
	      var contentTypes = ['application/octet-stream', 'application/json', 'application/x-www-form-urlencoded', 'multipart/form-data'];
	      var accepts = ['application/json'];
	      var returnType = [User];
	
	      return this.apiClient.callApi('/public/doctors', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, callback);
	    };
	
	    this.login = function (params, callback) {
	      var postBody = params;
	
	      if (params === undefined || params === null) {
	        throw new Error("Missing the required parameter 'params' when calling login");
	      }
	
	      var pathParams = {};
	      var queryParams = {};
	      var headerParams = {};
	      var formParams = {};
	
	      var authNames = [];
	      var contentTypes = ['application/octet-stream', 'application/json', 'application/x-www-form-urlencoded', 'multipart/form-data'];
	      var accepts = ['application/json'];
	      var returnType = MessageResponse;
	
	      return this.apiClient.callApi('/login', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, callback);
	    };
	
	    this.logout = function (callback) {
	      var postBody = null;
	
	      var pathParams = {};
	      var queryParams = {};
	      var headerParams = {};
	      var formParams = {};
	
	      var authNames = ['isLoggedIn'];
	      var contentTypes = ['application/octet-stream', 'application/json', 'application/x-www-form-urlencoded', 'multipart/form-data'];
	      var accepts = ['application/json'];
	      var returnType = MessageResponse;
	
	      return this.apiClient.callApi('/logout', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, callback);
	    };
	
	    this.patientPdfReport = function (opts, callback) {
	      opts = opts || {};
	      var postBody = null;
	
	      var pathParams = {};
	      var queryParams = {
	        'patientId': opts['patientId'],
	        'languageId': opts['languageId']
	      };
	      var headerParams = {};
	      var formParams = {};
	
	      var authNames = ['isValidated'];
	      var contentTypes = ['application/octet-stream', 'application/json', 'application/x-www-form-urlencoded', 'multipart/form-data'];
	      var accepts = ['application/json'];
	      var returnType = File;
	
	      return this.apiClient.callApi('/patient/health/pdf', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, callback);
	    };
	
	    this.postNotification = function (params, callback) {
	      var postBody = params;
	
	      if (params === undefined || params === null) {
	        throw new Error("Missing the required parameter 'params' when calling postNotification");
	      }
	
	      var pathParams = {};
	      var queryParams = {};
	      var headerParams = {};
	      var formParams = {};
	
	      var authNames = ['isDoctor'];
	      var contentTypes = ['application/octet-stream', 'application/json', 'application/x-www-form-urlencoded', 'multipart/form-data'];
	      var accepts = ['application/json'];
	      var returnType = MessageResponse;
	
	      return this.apiClient.callApi('/doctor/notify', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, callback);
	    };
	
	    this.postSurvey = function (symptom, callback) {
	      var postBody = null;
	
	      if (symptom === undefined || symptom === null) {
	        throw new Error("Missing the required parameter 'symptom' when calling postSurvey");
	      }
	
	      var pathParams = {};
	      var queryParams = {};
	      var headerParams = {};
	      var formParams = {
	        'symptom': symptom
	      };
	
	      var authNames = ['isLoggedIn'];
	      var contentTypes = ['application/octet-stream', 'application/json', 'application/x-www-form-urlencoded', 'multipart/form-data'];
	      var accepts = ['application/json'];
	      var returnType = DataResponse;
	
	      return this.apiClient.callApi('/survey', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, callback);
	    };
	
	    this.profile = function (callback) {
	      var postBody = null;
	
	      var pathParams = {};
	      var queryParams = {};
	      var headerParams = {};
	      var formParams = {};
	
	      var authNames = ['isLoggedIn'];
	      var contentTypes = ['application/octet-stream', 'application/json', 'application/x-www-form-urlencoded', 'multipart/form-data'];
	      var accepts = ['application/json'];
	      var returnType = InlineResponse200;
	
	      return this.apiClient.callApi('/profile', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, callback);
	    };
	
	    this.requestAnalyze = function (image, callback) {
	      var postBody = null;
	
	      if (image === undefined || image === null) {
	        throw new Error("Missing the required parameter 'image' when calling requestAnalyze");
	      }
	
	      var pathParams = {};
	      var queryParams = {};
	      var headerParams = {};
	      var formParams = {
	        'image': image
	      };
	
	      var authNames = ['isLoggedIn'];
	      var contentTypes = ['application/octet-stream', 'application/json', 'application/x-www-form-urlencoded', 'multipart/form-data'];
	      var accepts = ['application/json'];
	      var returnType = DataResponse;
	
	      return this.apiClient.callApi('/patient/record', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, callback);
	    };
	
	    this.resetPassword = function (params, callback) {
	      var postBody = params;
	
	      if (params === undefined || params === null) {
	        throw new Error("Missing the required parameter 'params' when calling resetPassword");
	      }
	
	      var pathParams = {};
	      var queryParams = {};
	      var headerParams = {};
	      var formParams = {};
	
	      var authNames = [];
	      var contentTypes = ['application/octet-stream', 'application/json', 'application/x-www-form-urlencoded', 'multipart/form-data'];
	      var accepts = ['application/json'];
	      var returnType = MessageResponse;
	
	      return this.apiClient.callApi('/reset', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, callback);
	    };
	
	    this.setConsultingConfig = function (day, location, fromTime, toTime, opts, callback) {
	      opts = opts || {};
	      var postBody = null;
	
	      if (day === undefined || day === null) {
	        throw new Error("Missing the required parameter 'day' when calling setConsultingConfig");
	      }
	
	      if (location === undefined || location === null) {
	        throw new Error("Missing the required parameter 'location' when calling setConsultingConfig");
	      }
	
	      if (fromTime === undefined || fromTime === null) {
	        throw new Error("Missing the required parameter 'fromTime' when calling setConsultingConfig");
	      }
	
	      if (toTime === undefined || toTime === null) {
	        throw new Error("Missing the required parameter 'toTime' when calling setConsultingConfig");
	      }
	
	      var pathParams = {};
	      var queryParams = {};
	      var headerParams = {};
	      var formParams = {
	        'day': day,
	        'comment': opts['comment'],
	        'location': location,
	        'from_time': fromTime,
	        'to_time': toTime
	      };
	
	      var authNames = ['isDoctor'];
	      var contentTypes = ['application/octet-stream', 'application/json', 'application/x-www-form-urlencoded', 'multipart/form-data'];
	      var accepts = ['application/json'];
	      var returnType = DataResponse;
	
	      return this.apiClient.callApi('/consulting/config', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, callback);
	    };
	
	    this.signup = function (profile, callback) {
	      var postBody = profile;
	
	      if (profile === undefined || profile === null) {
	        throw new Error("Missing the required parameter 'profile' when calling signup");
	      }
	
	      var pathParams = {};
	      var queryParams = {};
	      var headerParams = {};
	      var formParams = {};
	
	      var authNames = [];
	      var contentTypes = ['application/octet-stream', 'application/json', 'application/x-www-form-urlencoded', 'multipart/form-data'];
	      var accepts = ['application/json'];
	      var returnType = MessageResponse;
	
	      return this.apiClient.callApi('/signup', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, callback);
	    };
	
	    this.subscribeForBeta = function (email, opts, callback) {
	      opts = opts || {};
	      var postBody = null;
	
	      if (email === undefined || email === null) {
	        throw new Error("Missing the required parameter 'email' when calling subscribeForBeta");
	      }
	
	      var pathParams = {};
	      var queryParams = {};
	      var headerParams = {};
	      var formParams = {
	        'email': email,
	        'name': opts['name'],
	        'phone': opts['phone'],
	        'origin': opts['origin']
	      };
	
	      var authNames = [];
	      var contentTypes = ['application/octet-stream', 'application/json', 'application/x-www-form-urlencoded', 'multipart/form-data'];
	      var accepts = ['application/json'];
	      var returnType = DataResponse;
	
	      return this.apiClient.callApi('/public/mail/beta', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, callback);
	    };
	
	    this.supportEmail = function (params, callback) {
	      var postBody = params;
	
	      if (params === undefined || params === null) {
	        throw new Error("Missing the required parameter 'params' when calling supportEmail");
	      }
	
	      var pathParams = {};
	      var queryParams = {};
	      var headerParams = {};
	      var formParams = {};
	
	      var authNames = [];
	      var contentTypes = ['application/octet-stream', 'application/json', 'application/x-www-form-urlencoded', 'multipart/form-data'];
	      var accepts = ['application/json'];
	      var returnType = MessageResponse;
	
	      return this.apiClient.callApi('/public/mail/support', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, callback);
	    };
	
	    this.updateProfile = function (profile, callback) {
	      var postBody = profile;
	
	      if (profile === undefined || profile === null) {
	        throw new Error("Missing the required parameter 'profile' when calling updateProfile");
	      }
	
	      var pathParams = {};
	      var queryParams = {};
	      var headerParams = {};
	      var formParams = {};
	
	      var authNames = ['isLoggedIn'];
	      var contentTypes = ['application/octet-stream', 'application/json', 'application/x-www-form-urlencoded', 'multipart/form-data'];
	      var accepts = ['application/json'];
	      var returnType = MessageResponse;
	
	      return this.apiClient.callApi('/profile', 'PUT', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, callback);
	    };
	
	    this.uploadAttachment = function (statusId, file, callback) {
	      var postBody = null;
	
	      if (statusId === undefined || statusId === null) {
	        throw new Error("Missing the required parameter 'statusId' when calling uploadAttachment");
	      }
	
	      if (file === undefined || file === null) {
	        throw new Error("Missing the required parameter 'file' when calling uploadAttachment");
	      }
	
	      var pathParams = {};
	      var queryParams = {};
	      var headerParams = {};
	      var formParams = {
	        'statusId': statusId,
	        'file': file
	      };
	
	      var authNames = ['isDoctor'];
	      var contentTypes = ['multipart/form-data'];
	      var accepts = ['application/json'];
	      var returnType = InlineResponse2001;
	
	      return this.apiClient.callApi('/upload/attachment', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, callback);
	    };
	
	    this.uploadAvatar = function (file, callback) {
	      var postBody = null;
	
	      if (file === undefined || file === null) {
	        throw new Error("Missing the required parameter 'file' when calling uploadAvatar");
	      }
	
	      var pathParams = {};
	      var queryParams = {};
	      var headerParams = {};
	      var formParams = {
	        'file': file
	      };
	
	      var authNames = ['isValidated'];
	      var contentTypes = ['multipart/form-data'];
	      var accepts = ['application/json'];
	      var returnType = InlineResponse2001;
	
	      return this.apiClient.callApi('/upload/avatar', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, callback);
	    };
	  };
	
	  return exports;
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)(module)))

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	var _typeof2 = __webpack_require__(3);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var define = false;
	
	(function (root, factory) {
	  if (typeof define === 'function' && define.amd) {
	    define(['ApiClient'], factory);
	  } else if (( false ? 'undefined' : (0, _typeof3.default)(module)) === 'object' && module.exports) {
	    module.exports = factory(__webpack_require__(4));
	  } else {
	    if (!root.SymbimedApi) {
	      root.SymbimedApi = {};
	    }
	    root.SymbimedApi.Feedback = factory(root.SymbimedApi.ApiClient);
	  }
	})(undefined, function (ApiClient) {
	  'use strict';
	
	  var exports = function exports() {
	    var _this = this;
	  };
	
	  exports.constructFromObject = function (data, obj) {
	    if (data) {
	      obj = obj || new exports();
	
	      if (data.hasOwnProperty('type')) {
	        obj['type'] = ApiClient.convertToType(data['type'], 'String');
	      }
	      if (data.hasOwnProperty('patientId')) {
	        obj['patientId'] = ApiClient.convertToType(data['patientId'], 'String');
	      }
	      if (data.hasOwnProperty('period')) {
	        obj['period'] = ApiClient.convertToType(data['period'], 'String');
	      }
	      if (data.hasOwnProperty('comment')) {
	        obj['comment'] = ApiClient.convertToType(data['comment'], 'String');
	      }
	      if (data.hasOwnProperty('value')) {
	        obj['value'] = ApiClient.convertToType(data['value'], { 'String': 'String' });
	      }
	      if (data.hasOwnProperty('updatedAt')) {
	        obj['updatedAt'] = ApiClient.convertToType(data['updatedAt'], 'Date');
	      }
	    }
	    return obj;
	  };
	
	  exports.prototype['type'] = undefined;
	
	  exports.prototype['patientId'] = undefined;
	
	  exports.prototype['period'] = undefined;
	
	  exports.prototype['comment'] = undefined;
	
	  exports.prototype['value'] = undefined;
	
	  exports.prototype['updatedAt'] = undefined;
	
	  return exports;
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)(module)))

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	var _typeof2 = __webpack_require__(3);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var define = false;
	
	(function (root, factory) {
	  if (typeof define === 'function' && define.amd) {
	    define(['ApiClient'], factory);
	  } else if (( false ? 'undefined' : (0, _typeof3.default)(module)) === 'object' && module.exports) {
	    module.exports = factory(__webpack_require__(4));
	  } else {
	    if (!root.SymbimedApi) {
	      root.SymbimedApi = {};
	    }
	    root.SymbimedApi.SurveyQuestion = factory(root.SymbimedApi.ApiClient);
	  }
	})(undefined, function (ApiClient) {
	  'use strict';
	
	  var exports = function exports() {
	    var _this = this;
	  };
	
	  exports.constructFromObject = function (data, obj) {
	    if (data) {
	      obj = obj || new exports();
	
	      if (data.hasOwnProperty('name')) {
	        obj['name'] = ApiClient.convertToType(data['name'], 'String');
	      }
	      if (data.hasOwnProperty('creator')) {
	        obj['creator'] = ApiClient.convertToType(data['creator'], 'String');
	      }
	      if (data.hasOwnProperty('title')) {
	        obj['title'] = ApiClient.convertToType(data['title'], 'String');
	      }
	      if (data.hasOwnProperty('description')) {
	        obj['description'] = ApiClient.convertToType(data['description'], 'String');
	      }
	      if (data.hasOwnProperty('icon')) {
	        obj['icon'] = ApiClient.convertToType(data['icon'], 'String');
	      }
	      if (data.hasOwnProperty('formType')) {
	        obj['formType'] = ApiClient.convertToType(data['formType'], 'String');
	      }
	      if (data.hasOwnProperty('subType')) {
	        obj['subType'] = ApiClient.convertToType(data['subType'], 'String');
	      }
	      if (data.hasOwnProperty('measurementType')) {
	        obj['measurementType'] = ApiClient.convertToType(data['measurementType'], 'String');
	      }
	      if (data.hasOwnProperty('answer')) {
	        obj['answer'] = ApiClient.convertToType(data['answer'], 'String');
	      }
	      if (data.hasOwnProperty('options')) {
	        obj['options'] = ApiClient.convertToType(data['options'], ['String']);
	      }
	      if (data.hasOwnProperty('route')) {
	        obj['route'] = ApiClient.convertToType(data['route'], { 'String': 'String' });
	      }
	    }
	    return obj;
	  };
	
	  exports.prototype['name'] = undefined;
	
	  exports.prototype['creator'] = undefined;
	
	  exports.prototype['title'] = undefined;
	
	  exports.prototype['description'] = undefined;
	
	  exports.prototype['icon'] = undefined;
	
	  exports.prototype['formType'] = undefined;
	
	  exports.prototype['subType'] = undefined;
	
	  exports.prototype['measurementType'] = undefined;
	
	  exports.prototype['answer'] = undefined;
	
	  exports.prototype['options'] = undefined;
	
	  exports.prototype['route'] = undefined;
	
	  return exports;
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)(module)))

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _vue = __webpack_require__(12);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueRouter = __webpack_require__(432);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var define = false;
	
	_vue2.default.use(_vueRouter2.default);
	
	var router = new _vueRouter2.default({
		mode: 'history',
		routes: [{
			path: '/',
			name: 'home',
			component: __webpack_require__(395)
		}, {
			path: '/registration',
			name: 'registration',
			component: __webpack_require__(403)
		}, {
			path: '/reset/:token',
			name: 'reset',
			component: __webpack_require__(401)
		}, {
			path: '/legal',
			name: 'legal',
			component: __webpack_require__(398)
		}, {
			path: '/jobs',
			name: 'jobs',
			component: __webpack_require__(397)
		}, {
			path: '/info',
			name: 'info',
			component: __webpack_require__(396)
		}, {
			path: '/feed',
			name: 'feed',
			component: __webpack_require__(216)
		}, {
			path: '/admin/',
			name: 'admin',
			component: __webpack_require__(384),
			children: [{
				path: 'home',
				alias: '',
				component: __webpack_require__(385)
			}, {
				path: 'profile',
				component: __webpack_require__(390)
			}, {
				path: 'doctors',
				component: __webpack_require__(386)
			}, {
				path: 'patients',
				component: __webpack_require__(389)
			}, {
				path: 'patient/:id',
				component: __webpack_require__(388)
			}, {
				path: 'feed',
				component: __webpack_require__(387)
			}]
		}, {
			path: '/:name',
			name: 'doctor',
			component: __webpack_require__(402)
		}, {
			path: '*',
			component: __webpack_require__(400)
		}]
	});
	
	exports.default = router;

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _vuex = __webpack_require__(217);
	
	var _vuex2 = _interopRequireDefault(_vuex);
	
	var _vue = __webpack_require__(12);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var define = false;
	
	_vue2.default.use(_vuex2.default);
	
	exports.default = new _vuex2.default.Store({
	    state: {
	        counters: [],
	        feed: []
	    },
	    mutations: {
	        INCREMENT: function INCREMENT(_ref, counterId) {
	            var counters = _ref.counters;
	
	            counters.$set(counterId, counters[counterId] + 1);
	        },
	        DECREMENT: function DECREMENT(_ref2, counterId) {
	            var counters = _ref2.counters;
	
	            counters.$set(counterId, counters[counterId] - 1);
	        },
	        ADD_COUNTER: function ADD_COUNTER(_ref3) {
	            var counters = _ref3.counters;
	
	            counters.push(0);
	        }
	    }
	});

/***/ }),
/* 224 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var define = false;
	
	exports.default = {
		message: {
			hello: 'hello world'
		},
		home: {
			slogan: "Asthma tracking with your doctor",
	
			intro: "Pulmoment was a mobile software for asthma patients and their doctors. The project was developed between 2016 to 2018 by a group of students at Eötvös Loránd University in collaboration with Dr. András Szánthó. Due to the lack of funding, the support of the software has concluded in 2023. We hope our work will be used as a reference to build better healthcare solutions in the future. We're thankful for the support of our users and the medical community.",
			supportTitle: "Supported by",
			introtitle: "Condition tracking in a simple way",
			featurefirst: "Direct contact with your doctor",
			featurefirstdesc: "Through the application you can send messages to you doctor, who gets notification about critical symptoms and sees your condition changes in real time",
			featuresecond: "Questions, when it's needed",
			featureseconddesc: "Every patient is unique, therefore the system will check the measured data, so you have to fill the health survey only when it's needed",
			featurethird: "Health predictions",
			featurethirddesc: "Based on the recurring questions, we create unique reports from your data and notify you about the possible upcoming symptoms and the critical allergy seasons.",
			featurefourth: "Manage visit appointments",
			featurefourthdesc: "The application will send notifications about visits in the near future and changes in the appointment or about substitution",
			doctorslogan: "Overview about your patients, with a single click",
			doctorregistrate: "Registrate for free on the link below to get a better picture about you pateint's condition.",
			doctorregistrateinfo: "You can only have to leave your e-mail or phone number, and our team will contact you after finished setting up your profile.",
			specialThanks: "Special thanks for the help:",
			titleDaniel: "Project leader, software developer",
			titleLevente: "Mobile application developer",
			titleAndras: "Medical consultant",
			titleJulia: "Marketing and sales",
			titleMano: "PR and technological support",
			titleFanni: "Web application developer",
			titleDamiano: "Business developer",
			videotitle: "See it in action",
			fbtwitter: "Follow us on <a href=\"https://www.facebook.com/pulmoment/\" target=\"_blank\">Facebook</a> and <a href=\"https://twitter.com/pulmoment\" target=\"_blank\">Twitter</a> for news and updates."
		},
	
		milestones: {
			"title": "Milestones",
			"intro": {
				"date": "Spring of 2016",
				"title": "We started",
				"desc": "The beginning of the design phase based on the problems with the medical consultations of asthma patients. During this time, our team worked under the name of Symbimed, which was changed to Pulmoment by the summer of 2016. The new name is easier to understand and reflects our goals even better."
			},
			"elte": {
				"date": "2016.05.11.",
				"title": "ELTE Innovative Student Idea Award",
				"desc": "Our idea was awarded first place at the ELTE Innovative Student Idea Award 2016 by the largest Hungarian university. Our team assembled at the Faculty of Informatics, and we are proud to work with students of ELTE. We will continue to cooperate with the university, through R&D activities."
			},
			"district": {
				"date": "2016.05.17.",
				"title": "Students' Startup Competition of Újbuda",
				"desc": "The project was awarded by the Council of Újbuda. We believe that Újbuda is the most innovative district of Budapest, due to a large number of IT companies and presence of universities. This is the reason why we positioned our product development here."
			},
			"pediatricBeta": {
				"date": "2016.11.04.",
				"title": "52. Hungarian Pediatric Pulmonology Conference - First public beta version",
				"desc": "We introduced the first public beta version during the event, with the interface for both doctors and patients. This was the first time when we presented our project for a pulmonologist audience and their feedback confirmed the need for our service."
			},
			"pilotRelease": {
				"date": "2017.04.27.",
				"title": "First public release",
				"desc": "We released the first public version of Pulmoment, in a pilot phase. First, we test our solutions with a group of patients in Hungary, while we still working on new features."
			},
			"gitr": {
				"date": "2017.05.12.",
				"title": "Get in the Ring - Chendgu",
				"desc": "Enterprise Hungary and the Hungarian National Trading House selected Pulmoment to be one of four competing Hungarian startups at the Get in the Ring competition in China. In the end, a Chinese startup won the grand prize, however, after the event, we had the chance to learn about the local culture and the state of the local healthcare situation. The number of chronic pulmonary patients in China is extraordinary high, so our service could be a really useful solution for both the governmental and the private care. A group of local doctors agreed to support our cause."
			},
			"beSmart": {
				"date": "2017.06.22.",
				"title": "Hungarian e-Health Day - Düsseldorf",
				"desc": "Budapest Enterprise Agency provided us an opportunity to present our product in Germany during the Hungarian e-Health Day event. By the local competition in Düsseldorf, Pulmoment won the second prize. Besides this, we had the chance to learn about the local healthcare innovations and the services for international startups."
			},
			"ministry": {
				"date": "2017.07.14.",
				"title": "Startup of the Month Award",
				"desc": "The Hungarian Ministry for National Economy awarded Pulmoment as the Startup of the Month in June."
			},
			"now": {
				"date": "Now",
				"title": "Moving forward",
				"desc": "We are continuously looking for pulmonologists, research institutions and healthcare organizations for partnership. If you agree with our goals, please contact us for further details."
			}
		},
	
		admin: {
			edit_news: "Edit news",
			editnews_note: "Below you can write short news for your patients about general informations or consulting hours.",
			title: "Title",
			content: "Content",
			image: "Image",
			general: "General",
			change_appointment: "Change of appointment",
			substitution: "Substitution",
			release: "Release",
			save: "Save",
			facebook_link: "Facebook link",
			website: "Website",
			healthcareId: "Healthcare ID",
			discipline: "Discipline",
			add_new: "Add new",
			needsignin: "Please sign in to view this page",
			current: "Current",
			consultinghours: "Soon you can set your consulting hours in our system.",
			nextoverall: "Next report",
			novisit: "No visits in the future",
			totalizedsymptoms: "Summarized number of symptoms in the past month",
			allpatients: "All patients",
			filledinspector: "Filled monthly control survey",
			noinspector: "No filled control survey yet",
			newpatients: "New registered patients",
			rescueMedUsage: "Rescue medication usage",
			summary: "Summary",
			numberofsymptoms: "Number of symptoms",
			lastFourWeek: "last four week",
			symptom: "Symptom",
			data: "Data",
			patientspage: "Patient's page",
			mothersname: "Mother's name:",
			socialsecuritynumber: "Social security number:",
			medicines: "Medicines:",
			printsummary: "Print medical summary",
			findinspector: "Send control survey request",
			useofmedicines: "Medication usage",
			rescueMedSymptom: "Symptoms and rescue medication usage",
			factor: "Factor",
			value: "Value",
			tendency: "Tendency",
			patients: "Patients",
			doctors: "Doctors",
			descinfo: "In the mobile application patients can find your data. Please make sure you give data that can be seen by everyone",
			doctorspage: "Doctor's page",
			sendfeedback: "Send feedback",
			feedbackinfo: "Send your opinion about our application. Here you can report a problem about the software or the medical data",
			phonenumber: "Phone number",
			message: "Message",
			monthlyReport: "Monthly report",
			dailyReport: "Daily report"
		},
	
		for_patients: "For patients",
		doctors: "For doctors",
		see_more: "See more",
		read_more: "Read more",
		contact_us: "Contact Us",
		contact_us_directly: "Contact us directly:",
		app_links: "Pulmoment is available for Android and iOS devices:",
		thank_you: "In 2023 the development of Pulmoment has ended and it's not available anymore on the App Store or Google Play.",
	
		report_feedback: "Report problem, send feedback, or any other information",
		contact: "Contact",
		sign_in: "Sign In",
		sign_out: "Sign Out",
		email: "E-mail",
		password: "Password",
		cancel: "Cancel",
		home_page: "Home",
		patients: "Patients",
		profile: "Profile",
		news: "News",
		report_problem: "Bug report",
		signin_note: "This page is for doctors only. Patients can download our application from Google Play or the App Store. If you don't have an account, you can register one for free in the 'Registration' link below.",
		registration: "Registration",
		name: "Name",
		attributes: "Attributes",
		introduction: "Introduction",
		contact_name: "Contact name",
		contact_data: "Contact data",
		peakflowmeter: "Peak flow meter",
		peakflowmeterinfo: "The peak flow meter can be used at home. It shows the airways stricture increasing before the symptoms appear. It presage the asthma episode if the measured values are lower than the usual values. If the daily wobbling of the peak flow passes 20% it indicates asthma, more than 20-30% wobbling indicate serious inflamation and obstruction. Please ask your doctor what to do in this situation.",
		peakflowmeterlink: "Details:"
	
	};

/***/ }),
/* 225 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var define = false;
	
	exports.default = {
		"INID.survey.moreThanNeeded": "More than perscribed",
		"INID.survey.asNeeded": "As perscribed",
		"INID.survey.notUsed": "Did not used it",
		"INID.survey.feltSick": "Felt very sick",
		"INID.survey.hardlyBearable": "It was hardly bearable",
		"INID.survey.smallProblem": "Only had small problem",
		"INID.survey.hadNoProblem": "Had no problem at all",
		"INID.unit.lpm": "Liter / minute",
		"INID.unit.mlpm": "Milliliter / minute",
		"INID.unit.cm": "cm",
		"INID.unit.kg": "kg",
		"INID.survey.causePhysical": "Physical exercise, running, laughing, crying",
		"INID.survey.causeSmog": "Smog",
		"INID.survey.causeWind": "Wind",
		"INID.survey.causeEmotion": "Emotions",
		"INID.survey.causeUnknown": "I don\'t know",
		"INID.survey.asthma": "Asthma",
		"INID.survey.copd": "COPD",
		"INID.survey.allergy": "Allergy",
	
		"INID.survey.lastHour": "In the last hour",
		"INID.survey.forenoon": "At morning",
		"INID.survey.night": "At night",
		"INID.survey.yesterDayEvening": "Yesterday evening",
		"INID.survey.other": "Other time",
	
		"INID.survey.controlWorkoutNone": "Had no workout",
		"INID.survey.controlWorkoutWeeklyTwo": "2 hours a week",
		"INID.survey.controlWorkoutWeeklyFour": "4 hours a week",
		"INID.survey.controlWorkoutWeeklySix": "6 hours a week",
		"INID.survey.controlWorkoutWeeklyMore": "More than 8 hours a week",
	
		"INID.survey.generalControlAll": "Used as perscribed",
		"INID.survey.generalControlMostly": "Mostly as perscribed",
		"INID.survey.generalControlHalf": "Half of the perscribed dose",
		"INID.survey.generalControlRare": "Rarely used it",
		"INID.survey.generalControlNone": "Did not used it",
	
		"INID.ACTWork.0": "Folyamatosan",
		"INID.ACTWork.1": "Gyakran",
		"INID.ACTWork.2": "Néha",
		"INID.ACTWork.3": "Ritkán",
		"INID.ACTWork.4": "Soha",
	
		"INID.ACTBreath.0": "Naponta többször",
		"INID.ACTBreath.1": "Naponta egyszer",
		"INID.ACTBreath.2": "Heti 3-6 alkalommal",
		"INID.ACTBreath.3": "Heti 1-2 alkalommal",
		"INID.ACTBreath.4": "Egyszer sem",
	
		"INID.ACTSleep.0": "Hetente legalább 4 alkalommal",
		"INID.ACTSleep.1": "Hetente 2-3 éjszaka",
		"INID.ACTSleep.2": "Hetente 1 alkalommal",
		"INID.ACTSleep.3": "Heti 1-2 alkalommal",
		"INID.ACTSleep.4": "Soha",
	
		"INID.ACTMedication.0": "Naponta legalább 3 alkalommal",
		"INID.ACTMedication.1": "Napi 1-2 alkalommal",
		"INID.ACTMedication.2": "Heti 2-3 alkalommal",
		"INID.ACTMedication.3": "Heti 1 alkalommal vagy ritkábban",
		"INID.ACTMedication.4": "Nem kellett használnom",
	
		"INID.ACTSubjective.0": "Egyáltalán nem kontrollált",
		"INID.ACTSubjective.1": "Rosszul kontrollált",
		"INID.ACTSubjective.2": "Részben kontrollált",
		"INID.ACTSubjective.3": "Jól kontrollált",
		"INID.ACTSubjective.4": "Tökéletesen kontrollált",
	
		"INID.ACTSummary.problem": "Not well controlled",
		"INID.ACTSummary.ok": "Well controller"
	};

/***/ }),
/* 226 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var define = false;
	
	exports.default = {
		"INID.survey.moreThanNeeded": "Többször használtam mint a felírt mennyiség",
		"INID.survey.asNeeded": "A felírt mennyiségben",
		"INID.survey.notUsed": "Nem használtam",
		"INID.survey.feltSick": "Nagyon rosszul voltam",
		"INID.survey.hardlyBearable": "Nehezen volt elviselhető",
		"INID.survey.smallProblem": "Csak kisebb problémám volt",
		"INID.survey.hadNoProblem": "Mégsem volt tünetem",
		"INID.survey.causePhysical": "Fizikai terhelés, futás, nevetés, sírás",
		"INID.survey.causeSmog": "Szmog",
		"INID.survey.causeWind": "Szél",
		"INID.survey.causeEmotion": "Érzelmek",
		"INID.survey.causeUnknown": "Nem tudom",
		"INID.unit.lpm": "Liter / perc",
		"INID.unit.mlpm": "Milliliter / perc",
		"INID.unit.cm": "cm",
		"INID.unit.kg": "kg",
		"INID.survey.asthma": "Asztma",
		"INID.survey.copd": "COPD",
		"INID.survey.allergy": "Allergia",
	
		"INID.survey.lastHour": "Az elmúlt órában",
		"INID.survey.forenoon": "Délelőtt",
		"INID.survey.night": "Éjszaka",
		"INID.survey.yesterDayEvening": "Tegnap este",
		"INID.survey.other": "Más időpontban",
	
		"INID.survey.controlWorkoutNone": "Nem volt rá alkalmam",
		"INID.survey.controlWorkoutWeeklyTwo": "Heti 2 órát",
		"INID.survey.controlWorkoutWeeklyFour": "Heti 4 órát",
		"INID.survey.controlWorkoutWeeklySix": "Heti 6 órát",
		"INID.survey.controlWorkoutWeeklyMore": "Több mint 8 órát hetente",
	
		"INID.survey.generalControlAll": "A felírt mennyiségben használtam",
		"INID.survey.generalControlMostly": "Többnyire a megbeszéltek szerint",
		"INID.survey.generalControlHalf": "Az adagok felét használtam",
		"INID.survey.generalControlRare": "Ritkán használtam",
		"INID.survey.generalControlNone": "Egyáltalán nem használtam",
	
		"INID.ACTWork.0": "Folyamatosan",
		"INID.ACTWork.1": "Gyakran",
		"INID.ACTWork.2": "Néha",
		"INID.ACTWork.3": "Ritkán",
		"INID.ACTWork.4": "Soha",
	
		"INID.ACTBreath.0": "Naponta többször",
		"INID.ACTBreath.1": "Naponta egyszer",
		"INID.ACTBreath.2": "Heti 3-6 alkalommal",
		"INID.ACTBreath.3": "Heti 1-2 alkalommal",
		"INID.ACTBreath.4": "Egyszer sem",
	
		"INID.ACTSleep.0": "Hetente legalább 4 alkalommal",
		"INID.ACTSleep.1": "Hetente 2-3 éjszaka",
		"INID.ACTSleep.2": "Hetente 1 alkalommal",
		"INID.ACTSleep.3": "Heti 1-2 alkalommal",
		"INID.ACTSleep.4": "Soha",
	
		"INID.ACTMedication.0": "Naponta legalább 3 alkalommal",
		"INID.ACTMedication.1": "Napi 1-2 alkalommal",
		"INID.ACTMedication.2": "Heti 2-3 alkalommal",
		"INID.ACTMedication.3": "Heti 1 alkalommal vagy ritkábban",
		"INID.ACTMedication.4": "Nem kellett használnom",
	
		"INID.ACTSubjective.0": "Egyáltalán nem kontrollált",
		"INID.ACTSubjective.1": "Rosszul kontrollált",
		"INID.ACTSubjective.2": "Részben kontrollált",
		"INID.ACTSubjective.3": "Jól kontrollált",
		"INID.ACTSubjective.4": "Tökéletesen kontrollált",
	
		"INID.ACTSummary.problem": "Nem jól kontrollált",
		"INID.ACTSummary.ok": "Jól kontrollált"
	};

/***/ }),
/* 227 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var define = false;
	
	exports.default = {
		message: {
			hello: 'hello világ'
		},
		home: {
			slogan: "Asztma naplózás az orvosoddal",
			intro: "A Pulmoment egy mobil program volt asztmás betegek és orvosaik számára. A projektet 2016 és 2018 között egy csapat hallgató fejlesztette az Eötvös Loránd Tudományegyetem Informatikai Karán, Dr. Szánthó András tüdőgyógyász szakorvos közreműködésével. A szoftver támogatása 2023-ban véget ért, de reméljük, hogy munkánk segítségével jobb egészségügyi megoldások születnek a jövőben. Köszönettel tartozunk a felhasználóinknak és az egészségügyi szakembereknek a támogatásukért.",
			supportTitle: "Támogatóink",
			introtitle: "Állapot naplózás, egyszerűen",
			featurefirst: "Közvetlen kapcsolat az orvossal",
			featurefirstdesc: "A programon keresztül üzenetet küldhetsz az orvosodnak, értesítést kap a kritikus tünetekről és valós időben látja az állapotod változását.",
			featuresecond: "Kérdések, szükség esetén",
			featureseconddesc: "Nem minden beteg egyforma, ezért a rendszer figyelembe veszi a mért adatokat, hogy ez alapján csak akkor kelljen kitölteni az állapotfelmérőt, ha tényleg szükséges.",
			featurethird: "Állapotváltozás előrejelzések",
			featurethirddesc: "A folyamatos kérdéssoroknak alapján nem csak a hosszú távú egészségügyi adatokat tekinthetik át a betegek, hanem kimutatásokat is kapnak a várható tünetekről és a kritikus időszakokról.",
			featurefourth: "Vizit időpont kezelés",
			featurefourthdesc: "A mobil alkalmazás figyelmezetést küld a közelgő találkozókról, és ha épp időpontváltozás vagy helyettesítés befolyásolja a kapott időpontot.",
			doctorslogan: "Összkép a páciensekről, egy gombnyomásra.",
			doctorregistrate: "Regisztáljon ingyenesen az alábbi linken, hogy még jobb rálátást kapjon a betegei állapotáról:",
			doctorregistrateinfo: "Elég megadnia egy email címet vagy egy telefonszámot, és a csapatunk személyesen felkeresi a profilja beállítása miatt.",
			specialThanks: "Külön köszönet a sok segítségért:",
			titleDaniel: "Projekt vezető, szoftverfejlesztő",
			titleLevente: "Mobil alkalmazás fejlesztő",
			titleAndras: "Egészségügyi szakértő",
			titleJulia: "Marketing és sales",
			titleMano: "PR és technológiai segítségnyújtás",
			titleFanni: "Web alkalmazás fejlesztő",
			titleDamiano: "Üzletfejlesztő",
			videotitle: "Nézd meg a gyakorlatban",
			fbtwitter: "Kövess minket <a href=\"https://www.facebook.com/pulmoment/\" target=\"_blank\">Facebookon</a> és <a href=\"https://twitter.com/pulmoment\" target=\"_blank\">Twitteren</a> további hírekkel kapcsolatban."
		},
	
		milestones: {
			"title": "Mérföldkövek",
			"intro": {
				"date": "2016 tavasz",
				"title": "Elindultunk",
				"desc": "A tervezési fázis kezdete az asztmás viziteket érintő nehézségek alapján. Ekkor még Symbimed név alatt működött a csapatunk, 2016 nyarán váltottunk a Pulmoment névre, ami könnyebben érthető és jobban tükrözi a céljainkat."
			},
			"elte": {
				"date": "2016.05.11.",
				"title": "ELTE Innovatív Hallgatói Ötletpályázat",
				"desc": "Az ötletünket első helyen díjazta a 2016-os hallgatói pályázatán az ország legnagyobb egyeteme. Csapatunk az Informatikai Karon állt össze és büszkék vagyunk arra, hogy ELTE-s emberekkel együtt dolgozunk. A jövőben is folyamatosan kooperálunk az egyetemmel kutatási és fejlesztési tevékenységekben."
			},
			"district": {
				"date": "2016.05.17.",
				"title": "Újbudai Hallgatói Startup Pályázat",
				"desc": "A projektet az újbudai önkormányzat elismerésben részesítette. Hiszünk benne, hogy Újbuda a főváros leginnovatívabb kerülete, a jelentős mennyiségű informatikai cég és egyetemek jelenlétének köszönhetően. Ez a fő oka annak, hogy itt pozicionáltuk a termékünk fejlesztését."
			},
			"pediatricBeta": {
				"date": "2016.11.04.",
				"title": "52. Gyermektüdőgyógyász Konferencia - Első publikus béta verzió",
				"desc": "A rendezvényen során bemutattuk a Pulmoment első publikus béta verzióját, a betegeknek és orvosoknak szánt felülettel egyaránt. Első alkalommal prezentálhattunk közvetlenül tüdőgyógyász közönségnek és a visszajelzések megerősítették a szolgáltatásunk jelentőségét."
			},
			"pilotRelease": {
				"date": "2017.04.27.",
				"title": "Első publikus kiadás",
				"desc": "Megjelent a Pulmoment első kiadásra szánt verziója, pilot fázisban. Elsőként Magyarországon teszteljük egy kontrollcsoport segítségével, miközben új funkciók fejlesztésén dolgozunk."
			},
			"gitr": {
				"date": "2017.05.12.",
				"title": "Get in the Ring - Chengdu",
				"desc": "Az Enterprise Hungary és a Magyar Nemzeti Kereskedőház kiválasztotta a Pulmomentet a négy magyar csapat közé, akik Kínában versenyezhetnek a Get in the Ring startup versenyen. Végül a fődíjat egy kínai csapat vitte el, de a rendezvényen után nagyon sokat tanultunk a helyi kultúráról és az egészségügy helyzetéről. Kínában a krónikus tüdőbetegek száma rendkívüli méretű, emiatt a szolgáltatásunk nagyon hasznos megoldást jelenthet állami és privát irányból is. Ezzel egy helyi orvos csapat is egyetértett és biztosítottak a támogatásukról."
			},
			"beSmart": {
				"date": "2017.06.22.",
				"title": "Hungarian e-Health Day - Düsseldorf",
				"desc": "A Budapesti Vállalkozásfejlesztési Közalapítvány lehetőséget biztosított a termékünk németországi bemutatására, a Hungarian e-Health Day keretein belül. A Düsseldorfban megrendezett helyi versenyen a Pulmoment második helyet ért el. Emellett, egy kiváló programsorozat keretén belül megismerhettük a régió egészségügyi innovációt és a nemzetközi startupok számára biztosított lehetőségeket."
			},
			"ministry": {
				"date": "2017.07.14.",
				"title": "A Hónap Startupja díj",
				"desc": "A Nemzetgazdasági Minisztérium a Pulmomentnek ítélte a júniusi Hónap Startup Vállakozása elismerést."
			},
			"now": {
				"date": "Most",
				"title": "Haladunk tovább",
				"desc": "Folyamatosan keresünk tüdőgyógyászokat, kutatóintézményeket és egészségügyi szervezeteket akik nyitottak közreműködésre a hatékonyabb kezelés gyakorlati megvalósításához. Ha egyetért a céljainkkal, lépjen velünk kapcsolatban további információkért."
			}
		},
	
		admin: {
			edit_news: "Hír szerkesztő",
			editnews_note: "Az alábbi oldalon rövid híreket írhat a páciensei számára, általános információkkal vagy a rendeléssel kapcsolatban.",
			title: "Cím",
			content: "Tartalom",
			image: "Kép",
			general: "Általános",
			change_appointment: "Időpontváltozás",
			substitution: "Helyettesítés",
			release: "Publikálva",
			save: "Mentés",
			discipline: "Szakterület",
			facebook_link: "Facebook oldal címe",
			website: "Weboldal",
			healthcareId: "Egészségügyi nyilvántartási szám",
			add_new: "Új hozzáadása",
			needsignin: "Az oldal megjelenítéshez bejelentkezés szükséges",
			current: "Aktuális",
			consultinghours: "Hamarosan megadhatja rendelési idejét is a rendszerünkben.",
			nextoverall: "Következő összefoglaló",
			novisit: "Nem található következő vizit",
			totalizedsymptoms: "Összesített tünetek száma az elmúlt hónapban",
			allpatients: "Összes páciens",
			filledinspector: "Kitöltött havi állapotfelmérők",
			noinspector: "Még nincsenek kitöltött állapotfelmérők",
			newpatients: "Frissen regisztrált páciensek",
			rescueMedUsage: "Tüneti szer használat",
			summary: "Összesítés",
			numberofsymptoms: "Tünetek száma",
			lastFourWeek: "elmúlt négy hét",
			symptom: "Tünet",
			data: "Adatok",
			patientspage: "Páciens adatlap",
			mothersname: "Anyja neve:",
			socialsecuritynumber: "TAJ szám:",
			medicines: "Gyógyszerek:",
			printsummary: "Állapot összefoglaló nyomtatása",
			findinspector: "Kontroll kérdések küldése",
			useofmedicines: "Gyógyszerhasználat",
			rescueMedSymptom: "Tünetek and tüneti gyógyszerhasználat",
			factor: "Faktor",
			value: "Érték",
			tendency: "Tendencia",
			patients: "Páciensek",
			doctors: "Orvosok",
			descinfo: "A mobil alkalmazásban bármikor elérhetik az adatait a páciensek, tehát csak olyan információt adjon meg, amit meg szeretne osztani másokkal.",
			doctorspage: "Orvosi felület",
			sendfeedback: "Visszajelzés küldése",
			feedbackinfo: "Küld el nekünk véleményedet az alkalmazás használatával kapcsolatban.Ugyanitt jelezheted ha hibát találtál a szoftverben vagy az egészségügyi naplózás folyamatában.",
			phonenumber: "Telefonszám",
			message: "Üzenet",
			monthlyReport: "Havi bontás",
			dailyReport: "Napi bontás"
		},
	
		for_patients: "Pácienseknek",
		doctors: "Orvosoknak",
		see_more: "Tovább",
		read_more: "Tovább",
		contact_us: "Lépjen velünk kapcsolatba:",
		contact_us_directly: "Lépjen velünk kapcsolatba közvetlenül:",
		app_links: "A Pulmoment elérhető Android és iOS eszközökre:",
		thank_you: "2023-ban a Pulmoment fejlesztése véget ért és nem elérhető az alkalmazásboltokban.",
	
		report_feedback: "Hibabejelentés, visszajelzés küldése vagy egyéb megkeresés esetén.",
		contact: "Kapcsolatfelvétel",
		sign_in: "Bejelentkezés",
		sign_out: "Kijelentkezés",
		email: "E-mail",
		password: "Jelszó",
		cancel: "Mégsem",
		home_page: "Főoldal",
		patients: "Páciensek",
		profile: "Profilom",
		news: "Hírek",
		report_problem: "Hibajelentés",
		signin_note: "Ezen a felületen kizárólag az orvosok számára biztosítunk belépést. A páciensek elérhetik az alkalmazásunkat az App Store vagy a Google Play felületén. Ha még nem regisztrált a rendszerünkbe, az alábbi linken ingyenesen megteheti:",
		registration: "Regisztráció",
		name: "Név",
		attributes: "Jellemzők",
		introduction: "Bemutatkozás",
		contact_name: "Elérhetőség neve",
		contact_data: "Elérhetőség adata",
		peakflowmeter: "Csúcsáramlásmérő",
		peakflowmeterinfo: "A csúcsáramlásmérőt otthoni körülmények közt is használhatja. Segítségével már a tünetek megjelenése előtt kimutatható a légúti szűkület kisfokú növekedése is. Az asztmás rohamot előrejelezheti az, ha a mért értékek a szokásosnál alacsonyabbak. Ha a csúcsáramlás napi ingadozása meghaladja a 20 százalékot, az már asztmára utal, a 20-30 százaléknál is nagyobb változás pedig már súlyosabb gyulladást és obstrukciót jelez. Kérdezze meg orvosát, hogy mi a teendő ebben az esetben!",
		peakflowmeterlink: "Részletek:"
	
	};

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _vueToast = __webpack_require__(433);
	
	var _vueToast2 = _interopRequireDefault(_vueToast);
	
	var _ContactDialog = __webpack_require__(392);
	
	var _ContactDialog2 = _interopRequireDefault(_ContactDialog);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		components: {
			VueToast: _vueToast2.default,
			ContactDialog: _ContactDialog2.default
		},
		mounted: function mounted() {
			var toast = this.$refs.toast;
			this.$bus.$on('showToast', function (text, theme) {
				toast.showToast(text, {
					theme: theme || 'default',
					timeLife: 3000,
					closeBtn: false
				});
			});
		}
	};

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _Navbar = __webpack_require__(9);
	
	var _Navbar2 = _interopRequireDefault(_Navbar);
	
	var _generated = __webpack_require__(6);
	
	var _generated2 = _interopRequireDefault(_generated);
	
	var _lodash = __webpack_require__(8);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		components: {
			Navbar: _Navbar2.default
		},
		data: function data() {
			return {
				authorized: false,
				admin: false
			};
		},
	
		methods: {
			getHash: function getHash() {
				return ("955b376\n");
			},
			openDialog: function openDialog() {
				this.$bus.$emit('showContact', 'support');
			},
			checkUser: function checkUser() {
				var _this = this;
	
				this.$bus.$emit('showLoading', true);
				_generated2.default.ApiClient.instance.profile(function (error, data, response) {
					if (error) {
						console.error(error);
						_this.authorized = false;
					} else {
						console.log('logged in?');
						_this.authorized = true;
						if (response.body.data.group === "admin" || _lodash2.default.includes(response.body.data.groups, "admin")) {
							_this.admin = true;
						}
					}
					console.log(response);
					_this.$bus.$emit('showLoading', false);
				});
			}
		},
		mounted: function mounted() {
			this.checkUser();
		}
	};

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _stringify = __webpack_require__(24);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _generated = __webpack_require__(6);
	
	var _generated2 = _interopRequireDefault(_generated);
	
	var _LineChart = __webpack_require__(394);
	
	var _LineChart2 = _interopRequireDefault(_LineChart);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _lodash = __webpack_require__(8);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		components: {
			LineChart: _LineChart2.default
		},
		data: function data() {
			return {
				notice: true,
				globalSymptoms: [],
				newPatients: [],
				globalInfo: {
					hasNextConsulting: false
				}
			};
		},
	
		methods: {
			notifyPatients: function notifyPatients() {
				this.$bus.$emit('showToast', 'Figyelmeztetés elküldve');
			},
			showPatient: function showPatient(patient) {
				this.$router.push('/admin/patient/' + patient._id);
			},
			controlProgress: function controlProgress() {
				if (this.globalInfo.patientCount > 0 && this.globalInfo.filledControl > 0) {
					return Math.round(this.globalInfo.filledControl / this.globalInfo.patientCount * 100);
				} else {
					return 0;
				}
			}
		},
		mounted: function mounted() {
			var _this = this;
	
			this.$bus.$emit('showLoading', true);
	
			_generated2.default.ApiClient.instance.getGlobalSymptoms(function (error, data, response) {
				if (error) {
					console.error(error);
				} else {
					var symptoms = _lodash2.default.mapValues(_lodash2.default.groupBy(data["data"]["symptoms"], "updatedAt"), "length");
					console.log((0, _stringify2.default)(data));
					var graphData = {
						weeks: [],
						data: [{
							name: "Tünet",
							values: []
						}]
					};
					for (var i = 0; i < 30; i++) {
						var day = (0, _moment2.default)().subtract(i, 'days');
	
						var matches = 0;
						for (var symptomDay in symptoms) {
							if (day.isSame(symptomDay, "day")) {
								matches++;
							}
						}
	
						graphData.weeks[i] = day.toDate();
						graphData.data[0].values[i] = matches;
					}
	
					console.log(graphData);
					_this.globalSymptoms = graphData;
				}
			});
	
			_generated2.default.ApiClient.instance.getPatientList({
				order: 'registrationDate',
				asc: false,
				skip: 0,
				limit: 5,
				emailPrefix: ""
			}, function (error, data, response) {
				if (error) {
					console.error(error);
				} else {
					_this.newPatients = data;
				}
			});
	
			_generated2.default.ApiClient.instance.getGlobalInfo(function (error, data, response) {
				if (error) {
					console.error(error);
				} else {
					_this.globalInfo = data.data;
					if (_this.globalInfo.nextConsultingDate) {
						_this.globalInfo.nextConsultingDate = (0, _moment2.default)(_this.globalInfo.nextConsultingDate).format('YYYY.MM.DD.');
					}
				}
				_this.$bus.$emit('showLoading', false);
			});
		}
	};

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _generated = __webpack_require__(6);
	
	var _generated2 = _interopRequireDefault(_generated);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _lodash = __webpack_require__(8);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		data: function data() {
			return {
				doctors: []
			};
		},
		mounted: function mounted() {
			var _this = this;
	
			this.$bus.$emit('showLoading', true);
	
			_generated2.default.ApiClient.instance.listDoctors(function (error, data, response) {
				if (error) {
					console.error(error);
				} else {
					console.log(data);
					_this.doctors = data;
				}
				_this.$bus.$emit('showLoading', false);
			});
		},
	
		methods: {
			simpleDate: function simpleDate(date) {
				return (0, _moment2.default)(date).format("YYYY.MM.DD - HH:mm");
			}
		}
	};

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _generated = __webpack_require__(6);
	
	var _generated2 = _interopRequireDefault(_generated);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		data: function data() {
			return {
				editor: {
					published: true,
					text: "",
					title: "",
					image: null,
					type: "general"
				},
				loading: false
			};
		},
	
		methods: {
			newStatus: function newStatus() {
				var _this = this;
	
				this.loading = true;
				_generated2.default.ApiClient.instance.createStatus(this.editor, function (error, data, response) {
					if (error) {
						console.error(error);
						_this.loading = false;
					} else {
						console.log('API called successfully. Returned data: ');
						console.log(data);
						var statusId = data.data._id;
	
						if (document.getElementById('fileInput').files[0]) {
							_generated2.default.ApiClient.instance.uploadAttachment(statusId, document.getElementById('fileInput').files[0], function (error, data, response) {
								if (error) {
									console.error(error);
									_this.loading = false;
								} else {
									console.log(response);
									_this.$bus.$emit('showToast', 'Sikeres mentés', 'info');
									_this.reload();
								}
							});
						} else {
							_this.$bus.$emit('showToast', 'Sikeres mentés', 'info');
							_this.reload();
						}
					}
				});
			},
			reload: function reload() {
				var _this2 = this;
	
				this.editor = {
					published: true,
					text: "",
					title: "",
					image: null,
					type: "general"
				};
				_generated2.default.ApiClient.instance.getFeed({ userCreated: true }, function (error, data, response) {
					if (error) {
						console.error(error);
					} else {
						console.log('API called successfully. Returned data: ' + data);
						_this2.$store.state.feed = data;
					}
				});
				this.loading = false;
			}
		},
		mounted: function mounted() {
			this.reload();
		}
	};

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _stringify = __webpack_require__(24);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _getIterator2 = __webpack_require__(31);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _generated = __webpack_require__(6);
	
	var _generated2 = _interopRequireDefault(_generated);
	
	var _BarChart = __webpack_require__(393);
	
	var _BarChart2 = _interopRequireDefault(_BarChart);
	
	var _lodash = __webpack_require__(8);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _vue = __webpack_require__(12);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var medicationConfig = {
		"category.rescue": "Tüneti szer",
		"category.control": "Kontroll szer",
		"category.other": "Egyéb",
		"form.inhaler": "Spray",
		"form.powder": "Inhalációs por",
		"form.pill": "Tabletta",
		"form.liquid": "Folyadék",
		"freq.dailyOne": "Napi egy",
		"freq.dailyTwo": "Napi kettő",
		"freq.dailyThree": "Napi három",
		"freq.dailyFour": "Napi négy",
		"freq.other": "Egyéb",
		"freq.asNeeded": "Szükség esetén"
	};
	
	exports.default = {
		components: {
			BarChart: _BarChart2.default
		},
		data: function data() {
			return {
				test1: "Test1",
				test2: "Test2",
				patient: {},
				data: {},
				medicationValues: {},
				sort: {},
				reportDate: (0, _moment2.default)(),
				now: (0, _moment2.default)(),
				measurementEvents: [],
				dailyMedications: {}
			};
		},
	
		methods: {
			onSort: function onSort(sort) {
				this.sort = sort;
				this.data.factors = _lodash2.default.sortByOrder(this.data.factors, this.sort.name, this.sort.type);
			},
			pdfUrl: function pdfUrl() {
				return _generated2.default.ApiClient.instance.apiClient.basePath + "/patient/health/pdf?patientId=" + this.$route.params.id + "&languageId=" + this.$i18n.locale;
			},
			notifyPatient: function notifyPatient() {
				var _this = this;
	
				_generated2.default.ApiClient.instance.postNotification({ patientId: this.$route.params.id, notificationType: 'survey' }, function (error, data, response) {
					if (error) {
						console.error(error);
					} else {
						console.log(data);
						_this.$bus.$emit('showToast', 'Figyelmeztetés elküldve');
					}
				});
			},
			toShortDate: function toShortDate(val) {
				return (0, _moment2.default)(val).format('YYYY.MM.DD.');
			},
			timeFromDate: function timeFromDate(val) {
				return (0, _moment2.default)(val).format('HH:mm');
			},
			loadReport: function loadReport() {
				var _this2 = this;
	
				_generated2.default.ApiClient.instance.getReport({ patientId: this.$route.params.id, fromDate: this.reportDate.startOf('month').toISOString(), toDate: this.reportDate.endOf('month').toISOString() }, function (error, data, response) {
					if (error) {
						console.error(error);
					} else {
						console.log(data);
						if (data.profile.patientData && data.profile.patientData.medication) {
							var _iteratorNormalCompletion = true;
							var _didIteratorError = false;
							var _iteratorError = undefined;
	
							try {
								for (var _iterator = (0, _getIterator3.default)(data.profile.patientData.medication), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
									var medication = _step.value;
	
									medication.category = medicationConfig[medication.category];
									medication.form = medicationConfig[medication.form];
									medication.frequencyUnit = medicationConfig[medication.frequencyUnit];
								}
							} catch (err) {
								_didIteratorError = true;
								_iteratorError = err;
							} finally {
								try {
									if (!_iteratorNormalCompletion && _iterator.return) {
										_iterator.return();
									}
								} finally {
									if (_didIteratorError) {
										throw _iteratorError;
									}
								}
							}
						}
	
						_this2.patient = data.profile;
						_this2.data = data;
						_this2.medicationValues = data.medicationGraph;
						_this2.measurementEvents = _lodash2.default.map(data.measurements, function (m) {
							m.date = (0, _moment2.default)(m.updatedAt).format("YYYY/MM/DD");
							m.title = "Measurement";
							return m;
						});
	
						var startDay = _this2.reportDate.clone().startOf('month');
						var endDay = _this2.reportDate.clone().endOf('month');
						var day = startDay.clone();
						var graphDays = {};
	
						var medications = _lodash2.default.filter(data.measurements, function (m) {
							return m.type === "medicationUsage" && m.value && (0, _moment2.default)(m.updatedAt).isBetween(startDay, endDay);
						});
	
						var symptoms = _lodash2.default.filter(data.measurements, function (m) {
							return m.type === "symptom" && m.value && m.value == "true" && (0, _moment2.default)(m.updatedAt).isBetween(startDay, endDay);
						});
	
						_lodash2.default.map(symptoms, function (s) {
							s.type = "medicationUsage";
							s.subType = _this2.$t('admin.symptom');
							s.value = 1;
							medications.push(s);
						});
	
						console.log("MED");
						console.log((0, _stringify2.default)(medications));
	
						medications = _lodash2.default.map(medications, function (m) {
							m.value = parseInt(m.value);
							return m;
						});
	
						var medicationTypes = _lodash2.default.uniq(_lodash2.default.map(medications, "subType"));
						var dayGroup = _lodash2.default.groupBy(medications, function (m) {
							return (0, _moment2.default)(m.updatedAt).startOf("day");
						});
	
						dayGroup = _lodash2.default.mapValues(dayGroup, function (v) {
							return _lodash2.default.mapValues(_lodash2.default.groupBy(v, "subType"), function (v) {
								return _lodash2.default.sumBy(v, "value");
							});
						});
	
						while (day.isBefore(endDay)) {
							day = day.add(1, "day");
	
							var valz = {};
	
							for (var medDay in dayGroup) {
								if ((0, _moment2.default)(medDay).isSame(day, "day")) {
									valz = dayGroup[medDay];
								}
							}
	
							var _iteratorNormalCompletion2 = true;
							var _didIteratorError2 = false;
							var _iteratorError2 = undefined;
	
							try {
								for (var _iterator2 = (0, _getIterator3.default)(medicationTypes), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
									var type = _step2.value;
	
									if (!_lodash2.default.has(valz, type)) {
										valz[type] = 0;
									}
								}
							} catch (err) {
								_didIteratorError2 = true;
								_iteratorError2 = err;
							} finally {
								try {
									if (!_iteratorNormalCompletion2 && _iterator2.return) {
										_iterator2.return();
									}
								} finally {
									if (_didIteratorError2) {
										throw _iteratorError2;
									}
								}
							}
	
							graphDays[day.clone().format("YYYY-MM-DD")] = valz;
						}
	
						console.log("OK");
						console.log(graphDays);
	
						_this2.dailyMedications = graphDays;
					}
				});
			}
		},
		mounted: function mounted() {
			this.loadReport();
		}
	};

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _getIterator2 = __webpack_require__(31);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _stringify = __webpack_require__(24);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _generated = __webpack_require__(6);
	
	var _generated2 = _interopRequireDefault(_generated);
	
	var _lodash = __webpack_require__(8);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var images = __webpack_require__(218);
	
	exports.default = {
		data: function data() {
			return {
				patients: [],
				patientsPage: [],
				showHidden: false,
				hidden: false,
				profile: {},
				sort: {
					name: "name",
					type: "asc"
				},
				page: 1,
				size: 25
			};
		},
	
		watch: {
			patients: {
				handler: function handler(newPatients) {
					if (this.profile) {
						console.log((0, _stringify2.default)(this.profile));
						var _iteratorNormalCompletion = true;
						var _didIteratorError = false;
						var _iteratorError = undefined;
	
						try {
							for (var _iterator = (0, _getIterator3.default)(newPatients), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
								var patient = _step.value;
	
								if (patient.hidden) {
									if (!_lodash2.default.includes(this.profile.hiddenPatients, patient._id)) {
										this.profile.hiddenPatients.push(patient._id);
									}
								} else {
									if (_lodash2.default.includes(this.profile.hiddenPatients, patient._id)) {
										_lodash2.default.pull(this.profile.hiddenPatients, patient._id);
									}
								}
							}
						} catch (err) {
							_didIteratorError = true;
							_iteratorError = err;
						} finally {
							try {
								if (!_iteratorNormalCompletion && _iterator.return) {
									_iterator.return();
								}
							} finally {
								if (_didIteratorError) {
									throw _iteratorError;
								}
							}
						}
	
						_generated2.default.ApiClient.instance.updateProfile(this.profile, function (error, data, response) {
							if (error) {
								console.error(error);
							}
						});
					}
				},
				deep: true
			}
		},
		methods: {
			refreshTable: function refreshTable() {
				var ind = (this.page - 1) * this.size;
				this.patientsPage = this.patients.slice(ind, ind + this.size);
			},
			onSort: function onSort(sort) {
				var _this = this;
	
				this.sort = sort;
				this.patients.sort(function (a, b) {
					return a[_this.sort.name].localeCompare(b[_this.sort.name]);
				});
				if (this.sort.type == "desc") {
					this.patients.reverse();
				}
				this.refreshTable();
			},
			onPagination: function onPagination(e) {
				this.size = e.size;
				this.page = e.page;
				this.refreshTable();
			},
			showPatient: function showPatient(patient) {
				this.$router.push('/admin/patient/' + patient._id);
			}
		},
		mounted: function mounted() {
			var _this2 = this;
	
			this.$bus.$emit('showLoading', true);
			_generated2.default.ApiClient.instance.getPatientList({}, function (error, data, response) {
				if (error) {
					console.error(error);
				} else {
					var _iteratorNormalCompletion2 = true;
					var _didIteratorError2 = false;
					var _iteratorError2 = undefined;
	
					try {
						for (var _iterator2 = (0, _getIterator3.default)(data), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
							var patient = _step2.value;
	
							if (!patient.name) {
								patient.name = "";
							}
							if (!patient.avatar) {
								patient.avatar = images('./placeholder.png');
							}
						}
					} catch (err) {
						_didIteratorError2 = true;
						_iteratorError2 = err;
					} finally {
						try {
							if (!_iteratorNormalCompletion2 && _iterator2.return) {
								_iterator2.return();
							}
						} finally {
							if (_didIteratorError2) {
								throw _iteratorError2;
							}
						}
					}
	
					_this2.patients = data;
				}
				_this2.onSort(_this2.sort);
	
				_generated2.default.ApiClient.instance.profile(function (error, data, response) {
					if (error) {
						console.error(error);
					} else {
						_this2.profile = data.data;
						if (_this2.profile.hiddenPatients) {
							var _iteratorNormalCompletion3 = true;
							var _didIteratorError3 = false;
							var _iteratorError3 = undefined;
	
							try {
								for (var _iterator3 = (0, _getIterator3.default)(_this2.patients), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
									var patient = _step3.value;
	
									if (_lodash2.default.includes(_this2.profile.hiddenPatients, patient._id)) {
										patient.hidden = true;
									}
								}
							} catch (err) {
								_didIteratorError3 = true;
								_iteratorError3 = err;
							} finally {
								try {
									if (!_iteratorNormalCompletion3 && _iterator3.return) {
										_iterator3.return();
									}
								} finally {
									if (_didIteratorError3) {
										throw _iteratorError3;
									}
								}
							}
						} else {
							_this2.profile.hiddenPatients = [];
						}
					}
					_this2.$bus.$emit('showLoading', false);
				});
			});
		}
	};

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _generated = __webpack_require__(6);
	
	var _generated2 = _interopRequireDefault(_generated);
	
	var _lodash = __webpack_require__(8);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		data: function data() {
			return {
				profile: {}
			};
		},
	
		methods: {
			reload: function reload() {
				var _this = this;
	
				_generated2.default.ApiClient.instance.profile(function (error, data, response) {
					if (error) {
						console.error(error);
					} else {
						_this.profile = data['data'];
					}
				});
			},
			save: function save() {
				var _this2 = this;
	
				_generated2.default.ApiClient.instance.updateProfile(this.profile, function (error, data, response) {
					if (error) {
						console.error(error);
					} else {
						if (document.getElementById('fileInput').files.length > 0) {
							_generated2.default.ApiClient.instance.uploadAvatar(document.getElementById('fileInput').files[0], function (error, data, response) {
								if (error) {
									console.error(error);
								} else {
									_this2.$bus.$emit('showToast', 'Sikeres mentés', 'info');
									console.log(response);
									_this2.reload();
								}
							});
						} else {
							_this2.$bus.$emit('showToast', 'Sikeres mentés', 'info');
							_this2.reload();
						}
					}
				});
			},
			deleteContact: function deleteContact(contact) {
				this.profile.doctorData.contact = _lodash2.default.pull(this.profile.doctorData.contact, contact);
	
				this.profile.doctorData.contact.push({});
				this.profile.doctorData.contact.pop();
			},
			newContact: function newContact() {
				this.profile.doctorData.contact.push({
					name: "",
					value: ""
				});
			}
		},
		mounted: function mounted() {
			this.reload();
		}
	};

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _tween = __webpack_require__(212);
	
	var _tween2 = _interopRequireDefault(_tween);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var inputPrimaryColor = '#2196f3';
	var inputSecondaryColor = '#ffffff';
	
	var StyleKitName = {};
	(function () {
	
	    function drawLogo(canvas, process, targetFrame, resizing) {
	        canvas = typeof canvas === 'string' ? document.getElementById(canvas) : canvas;
	        if (!canvas) {
	            return;
	        }
	        var context = canvas.getContext('2d');
	
	        context.save();
	        var resizedFrame = applyResizingBehavior(resizing, makeRect(0, 0, 240, 240), targetFrame);
	        context.translate(resizedFrame.x, resizedFrame.y);
	        context.scale(resizedFrame.w / 240, resizedFrame.h / 240);
	        context.rotate(Math.PI / 8);
	
	        var fillColor = inputPrimaryColor;
	        var color = inputPrimaryColor;
	        var fillColor2 = inputSecondaryColor;
	
	        var easing = process * 2;
	        var position = easing * 50 + 55;
	        var alpha = Math.sin(90 * easing * Math.PI / 180);
	        var rotation = -30 + easing * 30;
	
	        roundedRect(context, -37.73, -42.27, 100, 100, 18);
	        context.fillStyle = color;
	        context.fill();
	
	        function group2CanvasLayer(width, height) {
	            context.save();
	            context.translate(position - 107.727507588, position - 112.27);
	            context.rotate(-rotation * Math.PI / 180);
	
	            context.beginPath();
	            context.moveTo(10.99, 45.78);
	            context.bezierCurveTo(7.75, 45.78, 4.56, 44.54, 2.46, 42.46);
	            context.lineTo(-44.28, -3.8);
	            context.bezierCurveTo(-47.34, -6.84, -48.54, -10.6, -47.53, -13.52);
	            context.bezierCurveTo(-47.68, -13.75, -47.89, -14.03, -48.17, -14.31);
	            context.lineTo(-52.05, -18.15);
	            context.bezierCurveTo(-55.75, -21.81, -55.75, -27.76, -52.05, -31.41);
	            context.lineTo(-40.3, -43.04);
	            context.bezierCurveTo(-38.52, -44.81, -36.14, -45.78, -33.61, -45.78);
	            context.bezierCurveTo(-31.07, -45.78, -28.69, -44.81, -26.91, -43.04);
	            context.lineTo(-26.08, -42.23);
	            context.bezierCurveTo(-25.98, -42.12, -25.88, -42.03, -25.78, -41.94);
	            context.bezierCurveTo(-25.33, -42.05, -24.86, -42.11, -24.37, -42.11);
	            context.bezierCurveTo(-21.38, -42.11, -18.71, -39.92, -17.39, -38.61);
	            context.lineTo(17.52, -4.05);
	            context.bezierCurveTo(17.74, -3.83, 18.44, -3.51, 19.25, -3.51);
	            context.bezierCurveTo(19.67, -3.51, 19.88, -3.59, 19.92, -3.61);
	            context.lineTo(32.72, -9.31);
	            context.bezierCurveTo(33.94, -9.85, 35.22, -10.13, 36.54, -10.13);
	            context.bezierCurveTo(40.35, -10.13, 43.72, -7.84, 45.12, -4.31);
	            context.lineTo(54.17, 18.49);
	            context.bezierCurveTo(56.05, 23.23, 53.73, 28.71, 49, 30.72);
	            context.lineTo(15.38, 44.93);
	            context.bezierCurveTo(14.04, 45.5, 12.56, 45.78, 10.99, 45.78);
	            context.lineTo(10.99, 45.78);
	            context.closePath();
	            context.fillStyle = fillColor;
	            context.fill();
	
	            context.beginPath();
	            context.moveTo(-33.61, -41.11);
	            context.bezierCurveTo(-32.39, -41.11, -31.17, -40.65, -30.25, -39.74);
	            context.lineTo(-29.42, -38.92);
	            context.bezierCurveTo(-28.07, -37.58, -26.66, -36.78, -25.78, -36.78);
	            context.bezierCurveTo(-25.47, -36.78, -25.22, -36.89, -25.08, -37.11);
	            context.bezierCurveTo(-24.93, -37.33, -24.69, -37.44, -24.37, -37.44);
	            context.bezierCurveTo(-23.5, -37.44, -22.09, -36.64, -20.73, -35.3);
	            context.lineTo(14.18, -0.74);
	            context.bezierCurveTo(15.41, 0.48, 17.38, 1.17, 19.25, 1.17);
	            context.bezierCurveTo(20.17, 1.17, 21.08, 1, 21.86, 0.65);
	            context.lineTo(34.66, -5.05);
	            context.bezierCurveTo(35.28, -5.32, 35.92, -5.45, 36.54, -5.45);
	            context.bezierCurveTo(38.33, -5.45, 40.02, -4.38, 40.73, -2.6);
	            context.lineTo(49.77, 20.2);
	            context.bezierCurveTo(50.73, 22.6, 49.54, 25.4, 47.14, 26.42);
	            context.lineTo(13.52, 40.63);
	            context.bezierCurveTo(12.76, 40.95, 11.89, 41.11, 10.99, 41.11);
	            context.bezierCurveTo(9.07, 41.11, 7.06, 40.4, 5.8, 39.15);
	            context.lineTo(-40.94, -7.11);
	            context.bezierCurveTo(-42.78, -8.94, -43.66, -11.3, -42.88, -12.36);
	            context.bezierCurveTo(-42.11, -13.42, -42.99, -15.79, -44.83, -17.62);
	            context.lineTo(-48.71, -21.46);
	            context.bezierCurveTo(-50.56, -23.29, -50.56, -26.28, -48.71, -28.1);
	            context.lineTo(-36.96, -39.74);
	            context.bezierCurveTo(-36.04, -40.65, -34.82, -41.11, -33.61, -41.11);
	            context.closePath();
	            context.moveTo(-33.61, -50.46);
	            context.bezierCurveTo(-37.4, -50.46, -40.96, -49, -43.64, -46.35);
	            context.lineTo(-55.39, -34.72);
	            context.bezierCurveTo(-58.07, -32.07, -59.54, -28.54, -59.54, -24.78);
	            context.bezierCurveTo(-59.55, -21.02, -58.07, -17.5, -55.39, -14.85);
	            context.lineTo(-52.59, -12.07);
	            context.bezierCurveTo(-52.81, -8.17, -51.09, -3.94, -47.62, -0.5);
	            context.lineTo(-0.88, 45.77);
	            context.bezierCurveTo(2.13, 48.75, 6.46, 50.46, 10.99, 50.46);
	            context.bezierCurveTo(13.21, 50.46, 15.31, 50.05, 17.23, 49.23);
	            context.lineTo(50.85, 35.02);
	            context.bezierCurveTo(54.29, 33.57, 56.98, 30.87, 58.43, 27.44);
	            context.bezierCurveTo(59.88, 24, 59.93, 20.22, 58.57, 16.77);
	            context.lineTo(49.52, -6.02);
	            context.bezierCurveTo(48.47, -8.65, 46.68, -10.88, 44.32, -12.45);
	            context.bezierCurveTo(42.01, -13.99, 39.32, -14.8, 36.54, -14.8);
	            context.bezierCurveTo(34.55, -14.8, 32.61, -14.39, 30.78, -13.57);
	            context.lineTo(19.6, -8.6);
	            context.lineTo(-14.05, -41.91);
	            context.bezierCurveTo(-16.24, -44.08, -19.73, -46.65, -24.03, -46.78);
	            context.bezierCurveTo(-26.65, -49.16, -30.02, -50.46, -33.61, -50.46);
	            context.lineTo(-33.61, -50.46);
	            context.closePath();
	            context.fillStyle = fillColor2;
	            context.fill();
	
	            context.restore();
	        }
	
	        context.save();
	        context.globalAlpha = alpha;
	        group2CanvasLayer(canvas.width, canvas.height);
	        context.restore();
	
	        context.restore();
	    }
	
	    function clearCanvas(canvas) {
	        canvas = typeof canvas === 'string' ? document.getElementById(canvas) : canvas;
	        if (canvas) {
	            canvas.getContext('2d').clearRect(0, 0, canvas.width, canvas.height);
	        }
	    }
	
	    function applyResizingBehavior(resizing, rect, targetRect) {
	        if (targetRect === undefined || equalRects(rect, targetRect) || equalRects(targetRect, makeRect(0, 0, 0, 0))) {
	            return rect;
	        }
	
	        var scales = makeSize(0, 0);
	        scales.w = Math.abs(targetRect.w / rect.w);
	        scales.h = Math.abs(targetRect.h / rect.h);
	        switch (resizing) {
	            case 'aspectfit':
	                {
	                    scales.w = Math.min(scales.w, scales.h);
	                    scales.h = scales.w;
	                    break;
	                }
	            case 'aspectfill':
	                {
	                    scales.w = Math.max(scales.w, scales.h);
	                    scales.h = scales.w;
	                    break;
	                }
	            case 'stretch':
	            case undefined:
	                break;
	            case 'center':
	                {
	                    scales.w = 1;
	                    scales.h = 1;
	                    break;
	                }
	            default:
	                throw 'Unknown resizing behavior "' + resizing + '". Use "aspectfit", "aspectfill", "stretch" or "center" as resizing behavior.';
	        }
	
	        var result = makeRect(Math.min(rect.x, rect.x + rect.w), Math.min(rect.y, rect.y + rect.h), Math.abs(rect.w), Math.abs(rect.h));
	        result.w *= scales.w;
	        result.h *= scales.h;
	        result.x = targetRect.x + (targetRect.w - result.w) / 2;
	        result.y = targetRect.y + (targetRect.h - result.h) / 2;
	        return result;
	    }
	
	    function roundedRect(context, x, y, w, h, r) {
	        context.beginPath();
	        context.arc(x + r, y + r, r, Math.PI, 1.5 * Math.PI);
	        context.arc(x + w - r, y + r, r, 1.5 * Math.PI, 2 * Math.PI);
	        context.arc(x + w - r, y + h - r, r, 0, 0.5 * Math.PI);
	        context.arc(x + r, y + h - r, r, 0.5 * Math.PI, Math.PI);
	        context.closePath();
	    }
	
	    function makeRect(x, y, w, h) {
	        return { x: x, y: y, w: w, h: h };
	    }
	
	    function equalRects(r1, r2) {
	        return r1.x === r2.x && r1.y === r2.y && r1.w == r2.w && r1.h === r2.h;
	    }
	
	    function makeSize(w, h) {
	        return { w: w, h: h };
	    }
	
	    StyleKitName.drawLogo = drawLogo;
	
	    StyleKitName.clearCanvas = clearCanvas;
	    StyleKitName.makeRect = makeRect;
	})();
	
	exports.default = {
	    props: ['primaryColor', 'secondaryColor'],
	    mounted: function mounted() {
	        if (this.primaryColor && this.secondaryColor) {
	            inputPrimaryColor = this.primaryColor;
	            inputSecondaryColor = this.secondaryColor;
	        }
	        var values = { x: 0 };
	        var tween = new _tween2.default.Tween(values).to({ x: 0.5 }, 1500).easing(_tween2.default.Easing.Bounce.Out).onUpdate(function () {
	            StyleKitName.clearCanvas('animatedLogoCanvas');
	            StyleKitName.drawLogo('animatedLogoCanvas', this.x, StyleKitName.makeRect(115, 115, 240, 240), 'center');
	        }).start();
	
	        requestAnimationFrame(animate);
	
	        function animate(time) {
	            requestAnimationFrame(animate);
	            _tween2.default.update(time);
	        }
	    }
	};

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _generated = __webpack_require__(6);
	
	var _generated2 = _interopRequireDefault(_generated);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		data: function data() {
			return {
				type: 'contact',
				body: {
					email: "",
					message: this.message
				},
				dialog: this.$refs['contactDialog']
			};
		},
	
		methods: {
			onOpen: function onOpen() {
				console.log('Opened');
			},
			onClose: function onClose(type) {
				console.log('Closed', type);
			},
			openDialog: function openDialog() {
				this.dialog.open();
			},
			closeDialog: function closeDialog() {
				this.dialog.close();
			},
			sendMessage: function sendMessage() {
				var _this = this;
	
				this.body['type'] = this.type;
				_generated2.default.ApiClient.instance.supportEmail(this.body, function (error, data, response) {
					if (error) {
						console.error(error);
					} else {
						console.log(data);
						_this.$bus.$emit('showToast', 'Köszönjük! Hamarosan felvesszük önnel a kapcsolatot.');
					}
					_this.closeDialog();
				});
			}
		},
		created: function created() {
			var _this2 = this;
	
			this.$bus.$on('showContact', function (type) {
				_this2.type = type;
				_this2.openDialog();
			});
		},
		mounted: function mounted() {
			this.dialog = this.$refs['contactDialog'];
			console.log(this.dialog);
		}
	};

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _BlogService = __webpack_require__(73);
	
	var _BlogService2 = _interopRequireDefault(_BlogService);
	
	var _downsize = __webpack_require__(86);
	
	var _downsize2 = _interopRequireDefault(_downsize);
	
	var _lodash = __webpack_require__(8);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var langTags = {
		"en": 8,
		"hu": 7
	};
	
	exports.default = {
		data: function data() {
			return {
				posts: []
			};
		},
	
		methods: {
			tagForLang: function tagForLang() {
				return langTags[this.$i18n.locale] || langTags["en"];
			}
		},
		mounted: function mounted() {
			var _this = this;
	
			_BlogService2.default.getPosts(function (err, posts) {
				posts = _lodash2.default.filter(posts, function (p) {
					return _lodash2.default.includes(p.tags, _this.tagForLang());
				});
				_this.posts = _lodash2.default.map(_lodash2.default.take(posts, 3), function (post) {
					var sizes = post.better_featured_image.media_details.sizes;
					if (sizes.large) {
						post.image = sizes.large.source_url;
					} else if (sizes.medium) {
						post.image = sizes.medium.source_url;
					} else {
						post.image = post.better_featured_image.source_url;
					}
	
					post.excerpt.rendered = (0, _downsize2.default)(post.excerpt.rendered, { "words": 30, "append": "..." });
					return post;
				});
			});
		}
	};

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _c = __webpack_require__(74);
	
	var _c2 = _interopRequireDefault(_c);
	
	var _lodash = __webpack_require__(8);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = {
		props: ['values'],
		methods: {
			loadChart: function loadChart() {
	
				if (!this.values) {
					return;
				}
	
				var xAxis = ['x'];
				var cols = [];
	
				var i = 0;
				for (var day in this.values) {
					var j = 0;
					for (var medName in this.values[day]) {
						if (i == 0) {
							cols[j] = [medName];
						} else {
							cols[j].push(this.values[day][medName]);
						}
						j++;
					}
					xAxis.push(day);
					i++;
				}
	
				cols.push(xAxis);
	
				console.log(cols);
	
				var chart = _c2.default.generate({
					bindto: '#chart',
					data: {
						x: 'x',
						columns: cols,
						type: 'bar'
					},
					bar: {
						width: {
							ratio: 0.8
						}
					},
					axis: {
						x: {
							type: 'timeseries',
							tick: {
								format: function format(x) {
									return (0, _moment2.default)(x).format('MMM DD');
								}
							}
						},
						y: {
							tick: {
								format: function format(d) {
									return parseInt(d) == d ? d : null;
								}
							}
						}
					}
				});
			}
		},
		watch: {
			'values': function values(val, oldVal) {
				this.loadChart();
			}
		},
		mounted: function mounted() {
			this.loadChart();
		}
	};

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _getIterator2 = __webpack_require__(31);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _c = __webpack_require__(74);
	
	var _c2 = _interopRequireDefault(_c);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = {
		props: ['values'],
		methods: {
			loadChart: function loadChart() {
	
				if (!this.values.weeks) {
					return;
				}
	
				var xAxis = [];
				var cols = [];
	
				console.log('vasd');
				console.log(this.values.weeks);
				xAxis.push('x');
	
				var _iteratorNormalCompletion = true;
				var _didIteratorError = false;
				var _iteratorError = undefined;
	
				try {
					for (var _iterator = (0, _getIterator3.default)(this.values.weeks), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
						var week = _step.value;
	
						xAxis.push(week);
					}
				} catch (err) {
					_didIteratorError = true;
					_iteratorError = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion && _iterator.return) {
							_iterator.return();
						}
					} finally {
						if (_didIteratorError) {
							throw _iteratorError;
						}
					}
				}
	
				cols.push(xAxis);
	
				var _iteratorNormalCompletion2 = true;
				var _didIteratorError2 = false;
				var _iteratorError2 = undefined;
	
				try {
					for (var _iterator2 = (0, _getIterator3.default)(this.values.data), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
						var data = _step2.value;
	
						var values = data.values;
						values.unshift(data.name);
						cols.push(values);
					}
				} catch (err) {
					_didIteratorError2 = true;
					_iteratorError2 = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion2 && _iterator2.return) {
							_iterator2.return();
						}
					} finally {
						if (_didIteratorError2) {
							throw _iteratorError2;
						}
					}
				}
	
				console.log(xAxis);
				console.log(cols);
	
				var chart = _c2.default.generate({
					bindto: '#chart',
					data: {
						x: 'x',
						columns: cols
					},
					size: {
						height: 200
					},
					axis: {
						x: {
							type: 'timeseries',
							tick: {
								format: function format(x) {
									return (0, _moment2.default)(x).format('MMM DD');
								}
							}
						},
						y: {
							tick: {
								format: function format(d) {
									return parseInt(d) == d ? d : null;
								}
							}
						}
					}
				});
			}
		},
		watch: {
			'values': function values(val, oldVal) {
				this.loadChart();
			}
		},
		mounted: function mounted() {
			this.loadChart();
		}
	};

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _vue = __webpack_require__(12);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _generated = __webpack_require__(6);
	
	var _generated2 = _interopRequireDefault(_generated);
	
	var _AnimatedLogo = __webpack_require__(391);
	
	var _AnimatedLogo2 = _interopRequireDefault(_AnimatedLogo);
	
	var _BlogService = __webpack_require__(73);
	
	var _BlogService2 = _interopRequireDefault(_BlogService);
	
	var _lodash = __webpack_require__(8);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _downsize = __webpack_require__(86);
	
	var _downsize2 = _interopRequireDefault(_downsize);
	
	var _Navbar = __webpack_require__(9);
	
	var _Navbar2 = _interopRequireDefault(_Navbar);
	
	var _StoreLinks = __webpack_require__(404);
	
	var _StoreLinks2 = _interopRequireDefault(_StoreLinks);
	
	var _Milestones = __webpack_require__(399);
	
	var _Milestones2 = _interopRequireDefault(_Milestones);
	
	var _FeedView = __webpack_require__(216);
	
	var _FeedView2 = _interopRequireDefault(_FeedView);
	
	var _tween = __webpack_require__(212);
	
	var _tween2 = _interopRequireDefault(_tween);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var teamImages = __webpack_require__(436);
	var images = __webpack_require__(435);
	
	exports.default = {
		name: 'hello',
		components: {
			AnimatedLogo: _AnimatedLogo2.default,
			Navbar: _Navbar2.default,
			StoreLinks: _StoreLinks2.default,
			Milestones: _Milestones2.default,
			FeedView: _FeedView2.default
		},
		data: function data() {
			return {
				type: 'patient',
				currentIntro: 0,
				tween: undefined,
				introLoaded: false,
				video: this.$refs['videoDialog'],
				team: [{
					"last": "Eke",
					"first": "Dániel",
					"desc": "home.titleDaniel",
					"image": "ekedaniel_grad.jpg"
				}, {
					"last": "Bernáth",
					"first": "Levente",
					"desc": "home.titleLevente",
					"image": "bernathlevente_grad.jpg"
				}, {
					"last": "Dr. Szánthó",
					"first": "András",
					"desc": "home.titleAndras",
					"image": "szanthoandras_grad.jpg"
				}],
				thanksFor: [{
					"last": "Szücs",
					"first": "András"
				}, {
					"last": "Rákosi",
					"first": "Fanni"
				}, {
					last: "Czár Barna",
					first: "Manó"
				}, {
					last: "Kovács",
					first: "Angelika"
				}, {
					last: "Vass",
					first: "Bálint"
				}, {
					last: "Morvay Pál",
					first: "Tomasz"
				}]
			};
		},
	
		methods: {
			heroImage: function heroImage() {
				if (this.type === 'patient') {
					return images('./home-bg-patient.jpg');
				} else {
					return images('./home-bg-doctor.jpg');
				}
			},
			teamImgUrl: function teamImgUrl(path) {
				return teamImages('./' + path);
			},
			introImage: function introImage(num) {
				if (this.checkLang() == 'hu') {
					return images('./phone_hu_' + num + '.jpg');
				} else {
					return images('./phone_en_' + num + '.jpg');
				}
			},
			showContact: function showContact() {
				this.$bus.$emit('showContact', 'contact');
			},
			checkLang: function checkLang() {
				return this.$i18n.locale;
			},
			changeType: function changeType(type) {
				if (this.type == type) {
					this.scroll();
				}
				this.type = type;
			},
			contactMail: function contactMail() {
				if (this.checkLang() == 'hu') {
					return "mailto:hello@pulmoment.com?subject=Kapcsolatfelvétel";
				} else {
					return "mailto:hello@pulmoment.com?subject=Contact";
				}
			},
			scroll: function scroll() {
				var coords = { y: 0 };
				var tween = new _tween2.default.Tween(coords).to({ y: 400 }, 1000).onUpdate(function () {
					scrollTo(0, coords.y);
				}).easing(_tween2.default.Easing.Cubic.Out).start();
			},
			loopIntro: function loopIntro() {
				var _this = this;
	
				var values = { x: 1 };
				this.tween = new _tween2.default.Tween(values).to({ x: 0.0 }, 500).onUpdate(function () {
					var introImages = [_this.$refs.variableA, _this.$refs.variableB, _this.$refs.variableC];
					introImages[_this.currentIntro].style.opacity = values.x;
	
					if (values.x === 0) {
						_this.currentIntro = (_this.currentIntro + 1) % introImages.length;
						var nextIntro = (_this.currentIntro + 2) % introImages.length;
						for (var i in introImages) {
							var index = (_this.currentIntro + i) % introImages.length;
							introImages[index].style.zIndex = introImages.length - i;
						}
						introImages[nextIntro].style.opacity = 1;
					}
				}).repeat(Infinity).delay(2000).start();
			},
			adClose: function adClose(type) {
				if (type == "ok") {
					this.$router.push('/registration/');
				}
			}
		},
		created: function created() {
			this.loopIntro();
		},
		mounted: function mounted() {
			var _this2 = this;
	
			this.video = this.$refs['videoDialog'];
	
			this.$nextTick(function () {});
	
			setTimeout(function () {
				_this2.introLoaded = true;
			}, 2000);
		},
		destroyed: function destroyed() {
			this.tween.stop();
		}
	};

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _Navbar = __webpack_require__(9);
	
	var _Navbar2 = _interopRequireDefault(_Navbar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		components: {
			Navbar: _Navbar2.default
		},
		mounted: function mounted() {}
	};

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _Navbar = __webpack_require__(9);
	
	var _Navbar2 = _interopRequireDefault(_Navbar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		data: function data() {
			return {
				jobs: [{
	
					title: "javascript frontend developer",
					description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam risus nibh, mollis molestie facilisis tempor, finibus eu ex. Phasellus nec nunc in orci tincidunt varius vel nec felis. Duis lorem nisi, placerat eget euismod auctor, mollis sit amet augue. Maecenas odio justo, tristique quis odio dapibus, luctus rutrum leo. Proin tellus elit, ultricies eu mi et, tempus semper felis. Aliquam quis nulla felis. Curabitur ut vestibulum ex. Quisque tristique arcu dolor, at bibendum urna elementum sit amet.",
					work_hours: "6",
					salary_range: " 25"
				}, {
					title: "Junior javascript frontend developer",
					description: "Cras at mauris eleifend felis ullamcorper rhoncus vitae et augue. Mauris maximus ligula non lectus condimentum pellentesque. Nulla in turpis est. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Cras auctor aliquet quam a bibendum. Duis eu sodales quam. Morbi maximus orci ut elementum aliquet. Nulla scelerisque augue malesuada turpis lobortis iaculis. Nullam feugiat nisi ac pretium pharetra. Quisque et sollicitudin est. Aliquam finibus faucibus augue, eget feugiat turpis pretium sodales. Nunc ac neque enim. Nulla mollis lacus neque, ut fringilla turpis gravida id.",
					work_hours: "12",
					salary_range: " 20"
				}, {
					title: "android developer",
					description: "Suspendisse congue tellus rhoncus, feugiat mauris quis, varius massa. Sed porttitor nulla egestas, lobortis diam at, laoreet nibh. Donec eu sapien auctor urna fermentum rhoncus. Etiam eget luctus eros. Aliquam erat volutpat. Nam sit amet nisl ut erat convallis bibendum eu sed nibh. Aliquam eget enim blandit, molestie turpis et, lobortis libero. Nam fermentum est vel justo tristique, sit amet egestas elit consequat. Fusce posuere efficitur neque id iaculis. Nulla a posuere nunc, eu aliquet odio. Duis quis varius tellus. Vestibulum vulputate tellus ac dui semper, ac semper leo viverra. Donec vitae arcu eu diam bibendum congue sit amet fringilla arcu. Nulla facilisi. Vestibulum quis turpis eu nisl malesuada eleifend. Aliquam eu mauris purus.",
					work_hours: "12",
					salary_range: "18"
				}, {
					title: "android developer",
					description: "Suspendisse congue tellus rhoncus, feugiat mauris quis, varius massa. Sed porttitor nulla egestas, lobortis diam at, laoreet nibh. Donec eu sapien auctor urna fermentum rhoncus. Etiam eget luctus eros. Aliquam erat volutpat. Nam sit amet nisl ut erat convallis bibendum eu sed nibh. Aliquam eget enim blandit, molestie turpis et, lobortis libero. Nam fermentum est vel justo tristique, sit amet egestas elit consequat. Fusce posuere efficitur neque id iaculis. Nulla a posuere nunc, eu aliquet odio. Duis quis varius tellus. Vestibulum vulputate tellus ac dui semper, ac semper leo viverra. Donec vitae arcu eu diam bibendum congue sit amet fringilla arcu. Nulla facilisi. Vestibulum quis turpis eu nisl malesuada eleifend. Aliquam eu mauris purus.",
					work_hours: "12",
					salary_range: "18"
				}, {
					title: "sales manager",
					description: "Suspendisse congue tellus rhoncus, feugiat mauris quis, varius massa. Sed porttitor nulla egestas, lobortis diam at, quis turpis eu nisl malesuada eleifend. Aliquam eu mauris purus.",
					work_hours: "12",
					salary_range: "18"
				}, {
					title: "ios developer",
					description: "Suspendisse congue tellus rhoncus, feugiat mauris quis, varius massa. Sed porttitor nulla egestas, lobortis diam at, laoreet nibh. Donec eu sapien auctor urna fermentum rhoncus. Etiam eget luctus eros. Aliquam erat volutpat. Nam sit amet nisl ut erat convallis bibendum eu sed nibh. Aliquam eget enim blandit, molestie turpis et, lobortis libero. Nam fermentum est vel justo tristique, sit amet egestas elit consequat. Fusce posuere efficitur neque id iaculis. Nulla a posuere nunc, eu aliquet odio. Duis quis varius tellus. Vestibulum vulputate tellus ac dui semper, ac semper leo viverra. Donec vitae arcu eu diam bibendum congue sit amet fringilla arcu. Nulla facilisi. Vestibulum quis turpis eu nisl malesuada eleifend. Aliquam eu mauris purus.",
					work_hours: "12",
					salary_range: "18"
				}, {
					title: "android developer",
					description: "Suspendisse congue tellus rhoncus, feugiat mauris quis, varius massa. Sed porttitor nulla egestas, lobortis diam at, laoreet nibh. Donec eu sapien auctor urna fermentum rhoncus. Etiam eget luctus eros. Aliquam erat volutpat. Nam sit amet nisl ut erat convallis bibendum eu sed nibh. Aliquam eget enim blandit, molestie turpis et, lobortis libero. Nam fermentum est vel justo trtur neque idc vitae arcu eu diam bibendum congue sit amet fringilla arcu. Nulla facilisi. Vestibulum quis turpis eu nisl malesuada eleifend. Aliquam eu mauris purus.",
					work_hours: "12",
					salary_range: "18"
				}]
			};
		},
	
		components: {
			Navbar: _Navbar2.default
		},
		mounted: function mounted() {}
	};

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _Navbar = __webpack_require__(9);
	
	var _Navbar2 = _interopRequireDefault(_Navbar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		components: {
			Navbar: _Navbar2.default
		},
		mounted: function mounted() {}
	};

/***/ }),
/* 245 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = {
		data: function data() {
			return {
				milestones: ["intro", "elte", "district", "pediatricBeta", "pilotRelease", "gitr", "beSmart", "ministry", "now"]
			};
		}
	};

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _Navbar = __webpack_require__(9);
	
	var _Navbar2 = _interopRequireDefault(_Navbar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		components: {
			Navbar: _Navbar2.default
		}
	};

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _stringify = __webpack_require__(24);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _generated = __webpack_require__(6);
	
	var _generated2 = _interopRequireDefault(_generated);
	
	var _vue = __webpack_require__(12);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		data: function data() {
			return {
				email: undefined,
				password: undefined,
				authorized: false,
				showLoading: false,
				rememberMail: true,
				currentLang: this.$i18n.locale
			};
		},
	
		methods: {
			changeLang: function changeLang(lang) {
				this.$i18n.locale = lang;
				this.currentLang = lang;
				_generated2.default.ApiClient.instance.apiClient.defaultHeaders["languageId"] = lang;
				this.$cookie.set('lang', lang);
			},
			toggleRightSidenav: function toggleRightSidenav() {
				this.$refs.rightSidenav.toggle();
			},
			closeRightSidenav: function closeRightSidenav() {
				this.$refs.rightSidenav.close();
			},
			login: function login() {
				var _this = this;
	
				_generated2.default.ApiClient.instance.login({
					'email': this.email,
					'password': this.password
				}, function (error, data, response) {
					if (error) {
						console.error(error);
						_this.$bus.$emit('showToast', 'Sikertelen bejelentkezés');
					} else {
						console.log('API called successfully. Returned data: ');
						console.log((0, _stringify2.default)(response));
						if (_this.rememberMail) {
							_this.$localStorage.set('email', _this.email);
						}
						_this.checkUser();
						_this.$router.push('/admin/');
					}
				});
			},
			passwordReset: function passwordReset() {
				var _this2 = this;
	
				_generated2.default.ApiClient.instance.forgottenPassword({ 'email': this.email }, function (error, data, response) {
					if (error) {
						console.error(error);
						_this2.$bus.$emit('showToast', 'Hiba történt, próbálja meg később');
					} else {
						_this2.$bus.$emit('showToast', 'Jelszó visszaállító email elküldve');
					}
				});
			},
			checkUser: function checkUser() {
				var _this3 = this;
	
				_generated2.default.ApiClient.instance.profile(function (error, data, response) {
					if (error) {
						_this3.authorized = false;
					} else {
						console.log('logged in?');
						_this3.authorized = true;
					}
				});
			},
			logout: function logout() {
				var _this4 = this;
	
				_generated2.default.ApiClient.instance.logout(function (error, data, response) {
					if (error) {
						console.error(error);
					} else {
						console.log(data);
						_this4.checkUser();
						_this4.$router.push('/');
					}
				});
			}
		},
		watch: {
			rememberMail: function rememberMail(val) {
				if (!val) {
					this.$localStorage.remove('email');
				}
			}
		},
		created: function created() {
			var _this5 = this;
	
			this.$bus.$on('showLoading', function (val) {
				_this5.showLoading = val;
			});
			this.$bus.$on('showLogin', function () {
				if (_this5.authorized) {
					_this5.$router.push('/admin/');
				} else {
					_this5.$refs.rightSidenav.toggle();
				}
			});
		},
		mounted: function mounted() {
			this.checkUser();
			console.log(this.$localStorage.get('email'));
			this.email = this.$localStorage.get('email');
		}
	};

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _Navbar = __webpack_require__(9);
	
	var _Navbar2 = _interopRequireDefault(_Navbar);
	
	var _generated = __webpack_require__(6);
	
	var _generated2 = _interopRequireDefault(_generated);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		components: {
			Navbar: _Navbar2.default
		},
		data: function data() {
			return {
				password: undefined
			};
		},
	
		methods: {
			reset: function reset() {
				var _this = this;
	
				_generated2.default.ApiClient.instance.resetPassword({
					token: this.$route.params.token,
					password: this.password
				}, function (error, data, response) {
					if (error) {
						console.error(error);
						_this.$bus.$emit('showToast', 'Hiba történt, ellenőrizze a megadott jelszót és próbálja meg újra');
					} else {
						console.log(response);
						_this.$bus.$emit('showToast', 'Sikeres jelszó átállítás, most már bejelentkezhet');
					}
				});
			}
		}
	};

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _Navbar = __webpack_require__(9);
	
	var _Navbar2 = _interopRequireDefault(_Navbar);
	
	var _generated = __webpack_require__(6);
	
	var _generated2 = _interopRequireDefault(_generated);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var images = __webpack_require__(218);
	var placeholder = images('./placeholder.png');
	
	function fillPlaceholder(profile) {
		if (!profile.avatar) {
			profile.avatar = placeholder;
		}
		if (!profile.doctorData.speciality) {
			profile.doctorData.speciality = "Nincs megadva";
		}
		if (!profile.doctorData.specification) {
			profile.doctorData.specification = "Nincs megadva";
		}
		if (!profile.doctorData.website) {
			profile.doctorData.website = "Nincs megadva";
		}
		if (!profile.doctorData.facebookPageUrl) {
			profile.doctorData.facebookPageUrl = "Nincs megadva";
		}
		if (!profile.doctorData.introduction) {
			profile.doctorData.introduction = "Nincs megadva";
		}
		return profile;
	}
	
	exports.default = {
		components: {
			Navbar: _Navbar2.default
		},
		data: function data() {
			return {
				status: 0,
				profile: {
					doctorData: {}
				}
			};
		},
		mounted: function mounted() {
			var _this = this;
	
			this.status = 0;
			_generated2.default.ApiClient.instance.findDoctorByName(this.$route.params.name, function (error, data, response) {
				if (error) {
					console.error(error);
					_this.status = 404;
				} else {
					_this.profile = fillPlaceholder(data);
					console.log(_this.profile);
					_this.status = 200;
				}
			});
		}
	};

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _Navbar = __webpack_require__(9);
	
	var _Navbar2 = _interopRequireDefault(_Navbar);
	
	var _generated = __webpack_require__(6);
	
	var _generated2 = _interopRequireDefault(_generated);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		components: {
			Navbar: _Navbar2.default
		},
		data: function data() {
			return {
				form: {
					password: "",
					maybeDoctor: true,
					doctorData: {
						phone: undefined,
						healthcareId: undefined,
						website: undefined,
						facebookPageUrl: undefined,
						speciality: undefined,
						workplaces: [{
							name: '',
							department: '',
							assignment: ''
						}],
						specialities: [{
							name: ''
						}],
						contactEmail: undefined,
						contactPhone: undefined
					}
				},
				mailSame: false,
				phoneSame: false
			};
		},
	
		methods: {
			registration: function registration() {
				var _this = this;
	
				if (!this.form.name || !this.form.email || !this.form.doctorData.phone || !this.form.doctorData.healthcareId) {
					this.$bus.$emit('showToast', 'Kérjük töltse ki a szükséges mezőket.');
				} else {
					_generated2.default.ApiClient.instance.signup(this.form, function (error, data, response) {
						if (error) {
							console.error(error);
							if (response.body.message == "err_reg_email_format") {
								_this.$bus.$emit('showToast', 'Hibás e-mail cím, kérjük ellenőrizze!');
							} else {
								_this.$bus.$emit('showToast', 'Hiba történt, próbálja meg később');
							}
						} else {
							console.log(response);
							_this.$bus.$emit('showToast', 'Köszönjük! Hamarosan felvesszük önnel a kapcsolatot.');
						}
					});
				}
			},
			deleteElement: function deleteElement(from, what) {
				from = _.pull(from, what);
				this.$forceUpdate();
			}
		},
		mounted: function mounted() {}
	};

/***/ }),
/* 251 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = {
		props: ['type'],
		methods: {
			showLogin: function showLogin() {
				this.$bus.$emit('showLogin');
			}
		}
	};

/***/ }),
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 297 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 298 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 299 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 300 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 301 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 302 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 303 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 304 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 305 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 306 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 307 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 308 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 309 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 310 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 311 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 312 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 313 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 314 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 315 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 316 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 317 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 318 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 319 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 320 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 321 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 322 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 323 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 324 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 325 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./af": 87,
		"./af.js": 87,
		"./ar": 94,
		"./ar-dz": 88,
		"./ar-dz.js": 88,
		"./ar-kw": 89,
		"./ar-kw.js": 89,
		"./ar-ly": 90,
		"./ar-ly.js": 90,
		"./ar-ma": 91,
		"./ar-ma.js": 91,
		"./ar-sa": 92,
		"./ar-sa.js": 92,
		"./ar-tn": 93,
		"./ar-tn.js": 93,
		"./ar.js": 94,
		"./az": 95,
		"./az.js": 95,
		"./be": 96,
		"./be.js": 96,
		"./bg": 97,
		"./bg.js": 97,
		"./bm": 98,
		"./bm.js": 98,
		"./bn": 99,
		"./bn.js": 99,
		"./bo": 100,
		"./bo.js": 100,
		"./br": 101,
		"./br.js": 101,
		"./bs": 102,
		"./bs.js": 102,
		"./ca": 103,
		"./ca.js": 103,
		"./cs": 104,
		"./cs.js": 104,
		"./cv": 105,
		"./cv.js": 105,
		"./cy": 106,
		"./cy.js": 106,
		"./da": 107,
		"./da.js": 107,
		"./de": 110,
		"./de-at": 108,
		"./de-at.js": 108,
		"./de-ch": 109,
		"./de-ch.js": 109,
		"./de.js": 110,
		"./dv": 111,
		"./dv.js": 111,
		"./el": 112,
		"./el.js": 112,
		"./en-au": 113,
		"./en-au.js": 113,
		"./en-ca": 114,
		"./en-ca.js": 114,
		"./en-gb": 115,
		"./en-gb.js": 115,
		"./en-ie": 116,
		"./en-ie.js": 116,
		"./en-il": 117,
		"./en-il.js": 117,
		"./en-nz": 118,
		"./en-nz.js": 118,
		"./eo": 119,
		"./eo.js": 119,
		"./es": 122,
		"./es-do": 120,
		"./es-do.js": 120,
		"./es-us": 121,
		"./es-us.js": 121,
		"./es.js": 122,
		"./et": 123,
		"./et.js": 123,
		"./eu": 124,
		"./eu.js": 124,
		"./fa": 125,
		"./fa.js": 125,
		"./fi": 126,
		"./fi.js": 126,
		"./fo": 127,
		"./fo.js": 127,
		"./fr": 130,
		"./fr-ca": 128,
		"./fr-ca.js": 128,
		"./fr-ch": 129,
		"./fr-ch.js": 129,
		"./fr.js": 130,
		"./fy": 131,
		"./fy.js": 131,
		"./gd": 132,
		"./gd.js": 132,
		"./gl": 133,
		"./gl.js": 133,
		"./gom-latn": 134,
		"./gom-latn.js": 134,
		"./gu": 135,
		"./gu.js": 135,
		"./he": 136,
		"./he.js": 136,
		"./hi": 137,
		"./hi.js": 137,
		"./hr": 138,
		"./hr.js": 138,
		"./hu": 139,
		"./hu.js": 139,
		"./hy-am": 140,
		"./hy-am.js": 140,
		"./id": 141,
		"./id.js": 141,
		"./is": 142,
		"./is.js": 142,
		"./it": 143,
		"./it.js": 143,
		"./ja": 144,
		"./ja.js": 144,
		"./jv": 145,
		"./jv.js": 145,
		"./ka": 146,
		"./ka.js": 146,
		"./kk": 147,
		"./kk.js": 147,
		"./km": 148,
		"./km.js": 148,
		"./kn": 149,
		"./kn.js": 149,
		"./ko": 150,
		"./ko.js": 150,
		"./ky": 151,
		"./ky.js": 151,
		"./lb": 152,
		"./lb.js": 152,
		"./lo": 153,
		"./lo.js": 153,
		"./lt": 154,
		"./lt.js": 154,
		"./lv": 155,
		"./lv.js": 155,
		"./me": 156,
		"./me.js": 156,
		"./mi": 157,
		"./mi.js": 157,
		"./mk": 158,
		"./mk.js": 158,
		"./ml": 159,
		"./ml.js": 159,
		"./mn": 160,
		"./mn.js": 160,
		"./mr": 161,
		"./mr.js": 161,
		"./ms": 163,
		"./ms-my": 162,
		"./ms-my.js": 162,
		"./ms.js": 163,
		"./mt": 164,
		"./mt.js": 164,
		"./my": 165,
		"./my.js": 165,
		"./nb": 166,
		"./nb.js": 166,
		"./ne": 167,
		"./ne.js": 167,
		"./nl": 169,
		"./nl-be": 168,
		"./nl-be.js": 168,
		"./nl.js": 169,
		"./nn": 170,
		"./nn.js": 170,
		"./pa-in": 171,
		"./pa-in.js": 171,
		"./pl": 172,
		"./pl.js": 172,
		"./pt": 174,
		"./pt-br": 173,
		"./pt-br.js": 173,
		"./pt.js": 174,
		"./ro": 175,
		"./ro.js": 175,
		"./ru": 176,
		"./ru.js": 176,
		"./sd": 177,
		"./sd.js": 177,
		"./se": 178,
		"./se.js": 178,
		"./si": 179,
		"./si.js": 179,
		"./sk": 180,
		"./sk.js": 180,
		"./sl": 181,
		"./sl.js": 181,
		"./sq": 182,
		"./sq.js": 182,
		"./sr": 184,
		"./sr-cyrl": 183,
		"./sr-cyrl.js": 183,
		"./sr.js": 184,
		"./ss": 185,
		"./ss.js": 185,
		"./sv": 186,
		"./sv.js": 186,
		"./sw": 187,
		"./sw.js": 187,
		"./ta": 188,
		"./ta.js": 188,
		"./te": 189,
		"./te.js": 189,
		"./tet": 190,
		"./tet.js": 190,
		"./tg": 191,
		"./tg.js": 191,
		"./th": 192,
		"./th.js": 192,
		"./tl-ph": 193,
		"./tl-ph.js": 193,
		"./tlh": 194,
		"./tlh.js": 194,
		"./tr": 195,
		"./tr.js": 195,
		"./tzl": 196,
		"./tzl.js": 196,
		"./tzm": 198,
		"./tzm-latn": 197,
		"./tzm-latn.js": 197,
		"./tzm.js": 198,
		"./ug-cn": 199,
		"./ug-cn.js": 199,
		"./uk": 200,
		"./uk.js": 200,
		"./ur": 201,
		"./ur.js": 201,
		"./uz": 203,
		"./uz-latn": 202,
		"./uz-latn.js": 202,
		"./uz.js": 203,
		"./vi": 204,
		"./vi.js": 204,
		"./x-pseudo": 205,
		"./x-pseudo.js": 205,
		"./yo": 206,
		"./yo.js": 206,
		"./zh-cn": 207,
		"./zh-cn.js": 207,
		"./zh-hk": 208,
		"./zh-hk.js": 208,
		"./zh-tw": 209,
		"./zh-tw.js": 209
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 329;


/***/ }),
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/appstore.eede94e.png";

/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/bg.34e5a00.jpg";

/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/home-bg-doctor.db7d222.jpg";

/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/home-bg-patient.b02cb32.jpg";

/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/home-phone-cropped-1.4789edc.png";

/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/home_bg_patient.6906ddc.png";

/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/home_bg_patient_white.0ae7c2f.jpg";

/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/home_phone_cropped_1.2c11a9d.jpg";

/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/001-pint.d812752.png";

/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/002-collaboration.fefa42e.png";

/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/003-earning.db32f43.png";

/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/004-student.f7ea50a.png";

/***/ }),
/* 354 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 355 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 356 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 357 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/pattern.bc93f22.png";

/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/pattern_fixed_transparent.535d97e.png";

/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/phone_en_1.ef06659.jpg";

/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/phone_en_2.3a9589a.jpg";

/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/phone_hu_0.e2865af.jpg";

/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/phone_hu_1.456df74.jpg";

/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/phone_hu_2.fa380b0.jpg";

/***/ }),
/* 365 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/playstore.ee48e71.png";

/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/digitalacademy.543cf58.jpg";

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/elte.8ccb443.jpg";

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/szanthoestarsa.6aa6472.jpg";

/***/ }),
/* 370 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHgAAACgCAYAAADHCaiQAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAHGhJREFUeNrsXQmYHFW1PlU9mZnMkpVkEiYkLAlowqYSFF4IBFQERcCIiPEJsoMPFFQWZVVZBRUEJGwCAiIgSx6yqIQIGgw7AQkJSQhLSMg2WWYye5f37/qL1FSququqq7prJnX4Dpnurq6+df971nvuvZphGJJS3yU97YIU4JRSgFNKAU4pBTilFOCUUoBTSgHegqjC7c2Jjy8t1W/vqnhHxeMU76x4jOLhivsprlacVdxOXqH4Q8VvKX5d8Vz+XRR1S60M0x+RsRXnSZfU92owpx/wpj+AYwZ1X8WHKT6AgNb4/O5Yx+u1ihcqfpL8Lw6IlMoA8GjF31A8TfHuEd1zkOI9yD9V/ILiOxU/SElPqQQANyr+vuKjqXrjpInkcxTfoPhGxWtSJyseyig+TfEcxT8uAbjOQXWJ4n8rPoVtSQGOkD6j+O+Kr2Vnl4vGUZL/xjalKjoCOk7xVbSPSaEpHHDnUm1HTQMVj1S8FftzCJ09OIEb6f1/oLirNwNcSbX4o5jb+5LiP3IQBXXIfqf4k4rPVtxWRBt2oq3/LB08aCnEV7XUiJmPIzCRTsUtilcpnqf4VcWv0CFc1lsAxoP9QfHhMbYTgLyseBE5LJ3OcOs7ilcH+N52ir+s+JuKJ/jUUBky4vmhHBiH8TMkGl5U/JDipxW/l1SA6xTfy4ePk6DerqYEj+boHxnyXgcrfpQDcnmBaxHSfY/XDo3YEQQfqvgjhnY3U7oT42TVlghcayD9WfFZil8jSM8Vcb/PKX5E8SiPz5Fdu5W/cXzE4Dqpgd7+84pnKN4/KQDfUCJw7TRe8RcV30FJLob2VHyfA7wK+hH/VHws1Wsp/aFD6PX/XvG25QT4PNqxUlOr4mYxc9hRhGB7iWg3G1Khc/A8rviXioeVOXQ9RvFMqvCSAwxH4eIyPPgCesAzKV3tUfSlIdrhVdrShwzRkc/+fILCu+3ohJ1dSoDh2Fwj5ZlmhEnALFIHVdjyYm5mKAdXSa6MyvxOts7c/tVuqRmVwDyFpvhyxVeWyou+OgLbF5Ym0iYiZJqqeER4cCtUz2Vlm4pfSYN+r3pdmQM8wfRjxtXnxinBCBWOKuNDTqNHi7ni3yquCgsuEk1jKq6UEfo96q/qpINr0Tn0tmMBGCHRhQl4yFZmh1aEA9d83DEV18pw/SElEjXUgr2GoEH3jgNgeHW7lfnhAKxVwfFaGHNmKKFvzNyi1PIfFbj9exu4IDQaKddBUQKMm/0wAQ+Hud23+fcbQb+cVX2zlf6ojMzcrv6u6o3gWrQrbXJkAB9Gl73ctMymmt8OBm611GmvymjlVFkedC+nHzBuLxrgijCGPSaaY/sb4dJCv05VhaxTdvdXyjtbq173kz5AcB5+EgXA+4k5JVZuetMRImBG6QTGxAXsboU0VtykJHgunao+Q6hx26VYgI+UZNROo2KyyfHeKsaGngRHapD+DxmmP0ynqk8RVNHJxQCMSoUvJeRhDhKzbtpuOn5Kr9JDNWdUD6yRUcpr1nMOeJ+s8UeuelhYgCcp3johD4IZn8E9hFPkP/ltb7U0ZB6QGm0eveY+SZhwOSAswPskaNgjH/tsD/xEfiHm7I8LuJVSpS2R4fqDfcWpykdTwwCsE+AkECYWrvH4DCU017qp5xH6vVKpLWdqMlKCY3e9JGcVBYoXhgQFGHp9QgIab028r/P4fL3i63rGvFXSX3tbhmaeyMW/ERPCsysU/zVB2q2RyY9AAMOhGZCAxvspjJvqlN5h+gylmJviSGhAUjAPjQLAM8QsjS03aflCWS+Ad5Rk5PIOVHyRmDXHbg+GjM5lm8Dtp6T3HSW9f4/LsWqk7Yf52k4iKTqIhCYGBXiHhDS8mqaiwtWXMmuqUIi3xHyjQoboM5WLFYvttQjxOPLiXxCzYC4JNMELSy+ARySg0VDP/6v4CPGu3sAqQtRQ3YFHqVAmeYj+VNye87m0wSj++yAhAA/zwiyfk1Vuggj6mRZEGdHxUMn1+gtKRS+KG+AMtUd/Kf36ai+qF486cS+Ak7C2CJk0P9OUQ5U5bkRt/GB9lnqgDhTSxdmuK6gST0yIphMOtoYgACdlL4NaP14kvOVK7SMZoL+knKvKuNtURTs8L2EJj8FBAE6K6mly+lUAE+rYxu93S93PB+lzNlbKqlLM9aJNmJdG0UFnggCuCwJkEkIkLPU8rye8SEF+KNXau3Yvea2S2gsG6c+M1qT7aIlfgpeqlmRVF71FoBsTAnBVEIDLHd9hsdmveiY6NPVfpwzUn5MabYGS3H524DPKg67Fe5r6qinFcY1R4yN1b6Qp19MJTArAmSAquqPMjV3hNiIhtd1GTQ5oJa027lAiVXVmU3bySc3ZCU8DYC3yVLGB1GfHhuzut7UaY+mpG6clKFQyggC8royxLwrKsLj6P5vb334KznqbFfmYoTKVLa69qdnYbf912b3PVtLcHeV8gJb7fb252dj1qbXZvXP2Xw2i9zb3E8pGnUEAXlWGBqKzsDboKkqF4T5Isx4AZHPqGbTR2PHKdmP0S1FKMWqqM9I8pFab/zM9t7gC99awjHWXhAC8MQjAK8vQQDhUrxaWowqn9OY6u91oUOq7NidZAKNbaiJ+hmyuu7ql/2KbfX+GnARaHwTgJWWwH//Of4GmJKhFedEf5Oxw1qj8mA3FncagnAqvkLXquraGSm35blE6WtAGbcbo11uNbX9jxtroOgOzSdgB4B9lBjfrZSqSAjCQ+GShS6Aaq3ITCRkPFZ3VlBodXqe9el2lrBgVVUwMR67NGLWkxfjEV5QZcOp9xMPHlTnyaBGP5TxeYdKb9KQrS9jIS9hZi/Or6Ezu/5tLJ97VP1Gjv/1EjbZ4dLQZrazSGgOXtxuN72Vypi6bA51twP+GS3k3XNtgxuf+JXiR1xdiJBQZYBOSY71UJHaDbTHG5yyh2XQ758B/p80YMx3LVLRIt6WqkP76ookq/r5U+dIDYC46jYGWH4h1xdOlvNm/94Oq6FaJYccXn570LG87XKFgrvEK+TAI2pSNvHRNdspJyhnKRgWyYaZIu9X9qsyQrJ+0GjtQinMePyYe/lJGgOd6fZCvrui5EjcSqb9D8qto7zBp0wN1Ko9665uasvsf2y113cWDbJqDddnPnrfRGPdDdf9mJFoqcqkCze4gPtHbAJ4tpUumQ8UcUdi503xNJmjK3+kwGu5Y3f2FozplaIuWfwFEwbvh+1Xa0il6zi0xbb+uddj9APTj4WUCNxsW4FfY8XETvL8jpcCSUDNMalVe9FKPWFgjGIiCs2ImI/T7m7M7f1/Z7o7islqaVGordlZhWC2cN9j4dmO4XZtkpXxVlvCV/uPtPXgT7DD2bDopxsZhSehUf+ZAV/81S42u/D8j5+YUUKyZrWr0+Q/2194Zp9R0RXH9n7P51UqS6xWWLZgL0TdX/dioDYvkB5dBPa8OAzDoUToQcU3NIBzbXswitvl+vgDJ1LTOgk1SUj5IxcITM7Kh2igqZFIhktS1rMvu/QMF88o8v4r6bJQ6XVBigJ/M31/5abbEO1uCdTV3Kf5KsJyIL+5WUtxarOaE09Zt1C5rN0b+Sb3sNnJ7a+leA2yelHbyoYVaNjTAayjFcVOTX3CzuVDJD/dTOlQvykmEB94lAzvajcaXlf2vxWuLPVauPiDmTNjFJXJQXyik+fwM77sl/nU4bTFIsBQHbrfyxEcubsru88U2Y5RyArPrfdwfyGN7iYvErNeOmx7yTAoEAPh5KTARUFqA4yctl5qs6WjKTjquyxjyD10LlWaG0xXnvPoaAizFAgxVc0PMfdoqiSKkRQevU8DOgVPXnatnC6wh8KU4c/kz/ISxfj2QRySCU8Z6iwSjWzLa+nolydvm7LBRJ5ZztYmNfNoRS25QmRLXvhFdfoXOL8DYwve3yQBY98uqE7RQjo6RWwazobpGW3iD8sR33tz2S650yFyearg1EH313Rj761E6WJEBDLqDcWtZVbSRy1X5YsMowjlESrRWe2O/On3uI5Xa6q0qtZVicZW2zCwAlBq34j68caME3MsroPReFUQcgsRcl20ZKtr0ojtlcFdLdvzpXUb9qi5joNi5W/FGYycvNY2zJQ6OSSBwjMK/4gDYuvlfI24wAsr2ZMGbzUno+uznftghI/6CKUo4Wj25XoVRw/PZYWzUhtmxuRE2DCVCPwvmTQRXDz+N2OttFylquidiMgHbkN39lnaj4Voz5224sla4fBxTn1hmGtXc+uVBVX+YPN6L/KEoAQ4waZvxy2rQaF1BwYVNbTEmPNlijD9JchuHG1a9l4O7pE57w0+4hON0o1jPCrV8TdAvVRQxklDDHMVOPB3+JNj42MMV71yw3RMOATCUc6X6Ib22Wnv3CqWKz0eViJenbdZnFQQYe3nsXGQfoebq5DC+SkURoGAaEeWiwyKQ4ISo6NzkvlavvTypQxu+V7sx4pfqdZvntZqvtchR1LadKSG2UA6roi3CzMkJUiAXGr2KLoUVzmnUVlRwYDbJi30ucit2Jx4U9N0SPmVTHCHDdXaR9+iQRDlZpiVWNlbPSJumq/HnxVnD1z5cxUwfYirwB8U8SxSlntgEZesiGhJMRRuBcPKR6MhaC8t6SKOuABZtXZ5baH6bHRZgxNDHFJsjiKqWF3nXQWxQjABbRXdZH05WRsU3qIwzXJMYZjEs5o1rO7qMupZKbeVgc21xxcfheasxzuAyUVdvHstk+msLpEDN++oQfYLyYRQhflgsMFEB3EV7LCFALoENNnKgWlLaYQxr7ZJBMzuM4S8ocO7rlqo16sOjVNhzepW2bDsmOvTm7C7V3VLrKsUAHjsN1GhvFar0XBOwsVg0NzWqLFiU1fgA6Xi69KclwItWIm70R6JCSakCddDCLhn8apdR/4B6/8VWGbuoQlYpaLpy4LcbI3+z1ph0d5X24ak12vxT+mlNDbq0DVbgvedWdmvkvucrARcEYOwH9jXmGiRpAAuBOp2hwSXib71OR1BJ9BnRZruMAc+vNSY/1i0193fK4DcrZfUag6rV3CUgK1Zhu1mKk13ZYTRcrK69rcpYcZoyCJpZPWm4PqrmzyFYI/7KapdQcl+OEpC41tNcwZQa5iwLbffX5k8cITN1yi5uJ7VKLfpYXNai1Og0BVhutQlCHtuCsTwDCEAb73fKkLN82Hk/TV9N7ZavwaiawcluC6MGIs5ibZxqPUUKlHX6l2Aj19wNxqd59qDhU+K7Qu3XUUhTwJ5Xa75OZke6qyXP5w+LWVW6MA4Q4q7GRzLky8zErClWRQOsdqMRWzREvHowqMuWyW1XXKMt8mOFOjySHdau9UdIjDsqlGK5BUTh12LWQD8VVkXbO7fN2KbMyS9davS3ckX4RuEu7HSJhd+lvT0/7gcp5Xoa7L+B/Z+Pc4QA7cEa3J5buqlsZAxbJfkbYHDSarTFfrcsbncAjC2QJ4uPisjeBrAlzbeJec4AZlk+CNPFWAjenP2Un/nYWKKvANIr9KC7GFkcLeZCu/dK1dpyrUpHrPwbxfdLngMlvLu4U5qNCVJrvCH9tDVxbv692S/r0ir9tSW51RP+4/Hcrn1vlRLYj3/cMAxJqe+SnnZBCnBKKcAppQCnlAKcUhnDpJ2O+UWQ++4nZv71hbSL46P5t59XUglGPHuM4qfJ308h6EUSnIewXzIOsEKGZrTt/W3T7u39AONQRFTcu811DuP7HWk3916AsYmZNV+GAjGk41CR8BL/TcHt5QBjCwHM92IvCswQrU+7tPcCPIJs1axCerFT3ZMu98TxtNaCK8yHYmbcOS2IWuqxYpVqmPeb5+G87Uh175Y4tzbDXireVdOVvIelbaBZUFLkNheLMwAbbM+JQriPHNfg2bCB+UDH+5gtayKvlHDFhNuzb/Dbq6XI6sogAN+s+Eu219h5x23xGc71m2PrTHQUJred+21dTufMIoD7Gem5NBWdjfVP4/K0q5vfQUfgOPjpLkAfJObMlWb7zkH09p2E1fkH215jF9lDHNfgiPfvevQfBk8bBzU2SvmdywDxIlS+YP1vre1e2CjueAm5RChImDSQD2TxoDzSUmW7Dq9rXK6rdpEKzWWwjCvQLgwk7GizJztzust96nh/q01V4n0uYp3jOZ1HxuHeU/IIB54Xp6d/SvGFzAV8zUf/4hDs8xztwr2O5b0kboCd6sar1MRtpGV9vJeNKE5HAf6BIX7f6zm7XQAOonpRX3SfixZwEg6c9trIdGo54+A4yW2wPE51rrP9+8nm62+/IvFu0O1s1xIxq0grmQvYW3oeSw8tgxLi2eK9lOWIPL93mJjbI3b0NYDFw0bOcCRUsA+G/UjcUp9/jN+3n3XcSJ/lINt7ONvh2+K+Sh++xv6O8BN+xRi+/iRN0D/jVNHFUJRLUypdvHtn7epLZY5GltJ2OsthD/X4/kEOj/zvdArtZuHrcdvgqFVtWIKqeooe8CzFjzmcOEjTnQnQNAivZjre28lDuzjBe9bFw4cN71/syOsNNJ7sRh/QIVmdkLY6t/oFuEOlZyE8bPZkhzDM4QBps0UbiI8nSYH9ocslwaUiqOs/+AitSkUbXULBKheHsNYxSOcxiTQvgCPWZyR4Nr1WjbYXam832/Og5vpWMVdSRLEpdzH+Q61LEqS9AGizZdNqj1mOGPhgOpMb4gA4KftoYJ/GhxxScRs9VIv2Ycc8z9fFAF3M8okdHa+hmu1H947jgLTTXrLpsMuRjs8amWSZEYeKdm5uPUTi2y43HzlVHMC7y+W6cXnaLo44NQ5qcIQ+oLcdbTlUNs/oWTZ5soepCaSmgwC80CVD43aYRkvMHee2jeK+Lu/ZkwJY7OXMvB3lcf8wi8G6XHwBaBXnHmKPOkKfMBmqA+moRa6ioTbOcjQQ+zftTrvRxBh1j4jVnJO+RS9a5+/t5jLQINWvODJNcFjsp3V/iSHWPWJOe3YxFh0Vok2fUHyOmHnr0VSjzvusoANo0QSXvsJmZ+9Iz4ma4UxyWIRBg7TmvVED/DQbYE8LIqn+k5BxcLXLIPAzEL5Bzkd3OjROBzNL17okGA6KQMvB1hbaavkM6XnG72GO/sezY3Hayy6qfgH72q6mfQGsB1SNJ4aMMd0OLx7potqj2FYYWaAfubyPWaYHQyYsnIM1yFnB1j6T9zgcQ2dyY564bz2MqUbnyXCfp8MVeRz8HD3UP/oEuoNq3Jk63IEqShxq1HBJFPjZKwrq9XUx88FfFvcV9WjLkVSlfs+fmO8i9YbNO8/neWMr4ZvEnHiY7vh8gi20s+j+PPbfOTAHuDhwkcXB82gHR9IWjqXRr7R1dhNHPq51q0i4zCVGfNbluvdop7an1DgHgMbfW80O7fQxELBBzDXs5B0pCXUOiVvFAYeB2exyn5MJvPPQBo3grmHbm/M4rJNsmsDpMzjpdsWvMYKwjj9fEHeiYxn5qQDfQWde6eLqbxTvFe/W70RJbQQv7KREsw8pLvT9fwW4HtpnTpgfKmUmC87Z3xhCOOlWKcPi6C2BSpmLXifuZTKw6+enUPR+gBFr/tnxHtTyVyXeI+BSgEtId9D+zGQW52vSMzebUsRU6tmkZ+i9bkn29hR662dKtIUPiZTg7BYGLmqqbrDFz31eRW9pdCpDwEu3FBu8JdFAAoz9wFamAPc9QlUlMlW/3pK86L5qZ5GqHSCbKjiQwsTU6tXljhKSBDDaUqhCRAt5b2TP9vN5LX7jSNl8MsSNMPeLKo1v00v+N99HKra23NKbJIAxA4S5Zq/1O5jBQlV/2GrJC3x2NkBF8QIya37quDAN+n+K7xYzt3wqBwik9zoJfiBHnwQYS0hRyoLE/yMe12Azz4aQIRak7ATeoxDhnAnMOKHwzZqtaWQs61xRgZqumRwQUMPIs2MSfhJ/8zrH9Q3Sc9J+iwAYpTZ3EmBUM7hN+KOzMWWIs5nCHBKFyX+s1b2nwHXbirm9Pio87GWpWEnxPTGLDG8kA+xzxSzZxVRlPQH9NNUzig7s89gwD09IiJ11kw4wHniKx2eYR0bhACbqp4l3uc45VN8zQvw+6pmOo8rNV/a7ByXxl9Kz1BWhzsH87XsonSfyubAoGwd0LmModCIlGebEXnuFa/7EWHhJqQGOO1WJh0LB2NYO6atkhyG7g9IVr709sKoOkxGHSrjCvdMpvX/Ocw2K2O6nuv2i9JzO/Aal7puU4m/RqQLAWGD2gJgHZiMk+gklP0ONhPtey0ExVUKsDEy6BA+herUqFu2E7Rsmilm6mq8yAQdfopLh/10++5y4H20LgLBSfjw7/sICg+NMhjU70FF6jO9DIlGcUEUb3En1+yMO2tm06xiAT1MbVVFdQ6JfZFSwR7nAjVuCd6VTcZcDYNi4M6g2/5Ln+6M4AKbK5nncC2kDZ7GDrRrooexsFKp9hl7uIw5Hp79NVdZQOtHOVwkknKfrqZpRynMZBQGr9L9DjbCUEvscr4P6t6Y8H+MAwGGdD0mZKU4J3pv/PuxQh3+gx3mJ7b29XL6Pzl5okyiLvknVi0K07Ryx8X2U+IsYet1kk17YRueGLqhnHsy2nkJfALFsE+0mwERpDrZlPJz3B/2W2mF/OllrOQgNqvI9kwBu3BKMDp1Hm2XR9RxUx7Az4Lk+zn+nyabqwUomD5zqtY52HU7XvvSs2ym511M9X0X7jk7/PaX0fAJypvRcfolrltPLRSHeIF4zg6blEmqAhx3Ptpz3TjzFJcHWioNZDsk7gnHvh7RXcFLm0xO1OzcH8h4POMKYJym1jQQCQKLK/1lmn9ZxUNzI38BWR6hWPIAO1N2Odi5mEmQy7/VZgvt1Dv67pEzTfEmX4K0ZolgAo8T2ZkqZZXenMY5c75CII3gtnJZmG+A3UJ0/TNtsbWxyCO3h9rTvx1H6TmWIdSnv5xUm3WdTvRadQFPSHFJoqjlANTpn1tE6BtuR7e0A78CHm2tTzcupUq1OABC1jB2P5vs3UtJaqRoh5T+nJJ7GQXMwgZtGx2gfm9N0sa0NE5kqDLoYbht6vmc43q+hh1xPR6yGQFpLcLpl06Zs68lt5E46ghtLrRHiAtiSzAV0dg6n+mu1ebNjmcl6jKBdzVTkJIZRFzHcaKKKncsBsRM97KMZqnjR+wHbPIAAHEbn7gOq72GUuE7yag7WJv69is/azOcztgQVDQBWcpTfynjSXijeShu5O8OJbZhFuo2fQ6Wexe/eYuu0FnqpYQke8xjyOPJWsmmt8FF0uB6kloGGeJcgrpJo1k71CYC34oi+jKP7Asfn8F6xjuhk5mhvcti7Z8V9KUuQ3x/DTNhulPodmHpspzO2gJKKJMRblPjljJNns40zpJdTXABDle1CnuIx8mfK5tsMBaUMtcU4pg/Bn6IJqKbULaR6h1S+bpNILzpXYjrLty8B/CS92OkRp+ngjU+gA7UXs2VjbOp7Lm36c4yVF4VQq69JH6K4AJ7BRMQrRdyjnpK5BzNN+He8LXP1DoGE7X6RajZdIVHCTNYzAa8fRnuJSYT/ETOXbJ9MeIMaAenGlymd3SmE5QO4EA2nFz2ZErqn9FycBkAxjYflqS/RdqaUYIAHUkL3Jah7Ss8Slnco9cgVYy3s4lJmfFKAwxNsJibFT5KeO880E8y/Ue2+IZtv/ZdSLwH4UIILKZ3F2BeT60tTCHo/wFCzJzDZ8M8U1NJSesR7H6d06UoKcEq9mf4rwAC5G+7FwJvMLwAAAABJRU5ErkJggg=="

/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/bernathlevente.99d5155.jpg";

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/bernathlevente_grad.489df32.jpg";

/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/damiano_grad.3ebda40.jpg";

/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/ekedaniel.306d8ae.jpg";

/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/ekedaniel_grad.cb1b8e6.jpg";

/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/rakosifanni_grad.410140d.jpg";

/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/szanthoandras.fbdc5a1.jpg";

/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/szanthoandras_grad.2fa3aa8.jpg";

/***/ }),
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(307)
	
	var Component = __webpack_require__(5)(
	  /* script */
	  __webpack_require__(228),
	  /* template */
	  __webpack_require__(414),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(315)
	
	var Component = __webpack_require__(5)(
	  /* script */
	  __webpack_require__(229),
	  /* template */
	  __webpack_require__(422),
	  /* scopeId */
	  "data-v-5f6faf1f",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(308)
	
	var Component = __webpack_require__(5)(
	  /* script */
	  __webpack_require__(230),
	  /* template */
	  __webpack_require__(415),
	  /* scopeId */
	  "data-v-3cb0271f",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(316)
	
	var Component = __webpack_require__(5)(
	  /* script */
	  __webpack_require__(231),
	  /* template */
	  __webpack_require__(423),
	  /* scopeId */
	  "data-v-7732563c",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(320)
	
	var Component = __webpack_require__(5)(
	  /* script */
	  __webpack_require__(232),
	  /* template */
	  __webpack_require__(427),
	  /* scopeId */
	  "data-v-b8e01cbe",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(303)
	
	var Component = __webpack_require__(5)(
	  /* script */
	  __webpack_require__(233),
	  /* template */
	  __webpack_require__(410),
	  /* scopeId */
	  "data-v-1073e7d0",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(310)
	
	var Component = __webpack_require__(5)(
	  /* script */
	  __webpack_require__(234),
	  /* template */
	  __webpack_require__(417),
	  /* scopeId */
	  "data-v-4863bce4",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(301)
	
	var Component = __webpack_require__(5)(
	  /* script */
	  __webpack_require__(235),
	  /* template */
	  __webpack_require__(408),
	  /* scopeId */
	  "data-v-0892d718",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(313)
	
	var Component = __webpack_require__(5)(
	  /* script */
	  __webpack_require__(236),
	  /* template */
	  __webpack_require__(420),
	  /* scopeId */
	  "data-v-5034db93",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(299)
	
	var Component = __webpack_require__(5)(
	  /* script */
	  __webpack_require__(237),
	  /* template */
	  __webpack_require__(406),
	  /* scopeId */
	  "data-v-03f8209a",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(319)
	
	var Component = __webpack_require__(5)(
	  /* script */
	  __webpack_require__(239),
	  /* template */
	  __webpack_require__(426),
	  /* scopeId */
	  "data-v-a5f9584c",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(321)
	
	var Component = __webpack_require__(5)(
	  /* script */
	  __webpack_require__(240),
	  /* template */
	  __webpack_require__(428),
	  /* scopeId */
	  "data-v-f2e9d4ea",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(305)
	
	var Component = __webpack_require__(5)(
	  /* script */
	  __webpack_require__(241),
	  /* template */
	  __webpack_require__(412),
	  /* scopeId */
	  "data-v-221b7304",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(304)
	
	var Component = __webpack_require__(5)(
	  /* script */
	  __webpack_require__(242),
	  /* template */
	  __webpack_require__(411),
	  /* scopeId */
	  "data-v-1bc35bd0",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(302)
	
	var Component = __webpack_require__(5)(
	  /* script */
	  __webpack_require__(243),
	  /* template */
	  __webpack_require__(409),
	  /* scopeId */
	  "data-v-0ea0a1c0",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(314)
	
	var Component = __webpack_require__(5)(
	  /* script */
	  __webpack_require__(244),
	  /* template */
	  __webpack_require__(421),
	  /* scopeId */
	  "data-v-5c70c4ae",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(318)
	
	var Component = __webpack_require__(5)(
	  /* script */
	  __webpack_require__(245),
	  /* template */
	  __webpack_require__(425),
	  /* scopeId */
	  "data-v-8908b930",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(317)
	
	var Component = __webpack_require__(5)(
	  /* script */
	  __webpack_require__(246),
	  /* template */
	  __webpack_require__(424),
	  /* scopeId */
	  "data-v-7af6c696",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(306)
	
	var Component = __webpack_require__(5)(
	  /* script */
	  __webpack_require__(248),
	  /* template */
	  __webpack_require__(413),
	  /* scopeId */
	  "data-v-2ce12f38",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(312)
	
	var Component = __webpack_require__(5)(
	  /* script */
	  __webpack_require__(249),
	  /* template */
	  __webpack_require__(419),
	  /* scopeId */
	  "data-v-4eb63352",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(309)
	
	var Component = __webpack_require__(5)(
	  /* script */
	  __webpack_require__(250),
	  /* template */
	  __webpack_require__(416),
	  /* scopeId */
	  "data-v-460abe23",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(298)
	
	var Component = __webpack_require__(5)(
	  /* script */
	  __webpack_require__(251),
	  /* template */
	  __webpack_require__(405),
	  /* scopeId */
	  "data-v-0142273d",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 405 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "storelinks"
	  }, [_c('b', [_vm._v(_vm._s(_vm.$t("thank_you")))])])
	},staticRenderFns: []}

/***/ }),
/* 406 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('md-dialog', {
	    ref: "contactDialog",
	    attrs: {
	      "md-open-from": "#custom",
	      "md-close-to": "#custom"
	    }
	  }, [_c('md-dialog-title', [_vm._v(_vm._s(_vm.$t("admin.sendfeedback")))]), _vm._v(" "), _c('md-dialog-content', [_vm._v("\n\t\t" + _vm._s(_vm.$t("admin.feedbackinfo")) + "\n\t\t\n\t\t"), (_vm.type === 'contact') ? _c('md-input-container', [_c('label', [_vm._v(_vm._s(_vm.$t("name")))]), _vm._v(" "), _c('md-textarea', {
	    model: {
	      value: (_vm.body.name),
	      callback: function($$v) {
	        _vm.$set(_vm.body, "name", $$v)
	      },
	      expression: "body.name"
	    }
	  })], 1) : _vm._e(), _vm._v(" "), (_vm.type === 'contact') ? _c('md-input-container', [_c('label', [_vm._v(_vm._s(_vm.$t("email")))]), _vm._v(" "), _c('md-textarea', {
	    model: {
	      value: (_vm.body.email),
	      callback: function($$v) {
	        _vm.$set(_vm.body, "email", $$v)
	      },
	      expression: "body.email"
	    }
	  })], 1) : _vm._e(), _vm._v(" "), (_vm.type === 'contact') ? _c('md-input-container', [_c('label', [_vm._v(_vm._s(_vm.$t("admin.phonenumber")))]), _vm._v(" "), _c('md-textarea', {
	    model: {
	      value: (_vm.body.phone),
	      callback: function($$v) {
	        _vm.$set(_vm.body, "phone", $$v)
	      },
	      expression: "body.phone"
	    }
	  })], 1) : _vm._e(), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v(_vm._s(_vm.$t("admin.message")))]), _vm._v(" "), _c('md-textarea', {
	    model: {
	      value: (_vm.body.message),
	      callback: function($$v) {
	        _vm.$set(_vm.body, "message", $$v)
	      },
	      expression: "body.message"
	    }
	  })], 1)], 1), _vm._v(" "), _c('md-dialog-actions', [_c('md-button', {
	    staticClass: "md-primary",
	    nativeOn: {
	      "click": function($event) {
	        _vm.closeDialog()
	      }
	    }
	  }, [_vm._v("Cancel")]), _vm._v(" "), _c('md-button', {
	    staticClass: "md-primary",
	    nativeOn: {
	      "click": function($event) {
	        _vm.sendMessage()
	      }
	    }
	  }, [_vm._v("Ok")])], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "header"
	  }, [(_vm.showLoading) ? _c('md-progress', {
	    staticClass: "progress md-accent",
	    attrs: {
	      "md-indeterminate": ""
	    }
	  }) : _vm._e(), _vm._v(" "), _c('md-whiteframe', {
	    staticClass: "content row center-xs middle-xs"
	  }, [_c('section', {
	    staticClass: "lang col-md-4"
	  }, [_c('md-menu', [_c('md-button', {
	    attrs: {
	      "md-menu-trigger": ""
	    }
	  }, [(_vm.currentLang == 'hu') ? _c('span', [_c('img', {
	    staticClass: "flag",
	    attrs: {
	      "src": __webpack_require__(45)
	    }
	  }), _vm._v(" "), _c('span', [_vm._v("HUN")])]) : _c('span', [_c('img', {
	    staticClass: "flag",
	    attrs: {
	      "src": __webpack_require__(44)
	    }
	  }), _vm._v(" "), _c('span', [_vm._v("ENG")])])]), _vm._v(" "), _c('md-menu-content', [_c('md-menu-item', {
	    on: {
	      "click": function($event) {
	        _vm.changeLang('en')
	      }
	    }
	  }, [_c('img', {
	    staticClass: "flag",
	    attrs: {
	      "src": __webpack_require__(44)
	    }
	  }), _vm._v(" "), _c('span', [_vm._v("ENG")])]), _vm._v(" "), _c('md-menu-item', {
	    on: {
	      "click": function($event) {
	        _vm.changeLang('hu')
	      }
	    }
	  }, [_c('img', {
	    staticClass: "flag",
	    attrs: {
	      "src": __webpack_require__(45)
	    }
	  }), _vm._v(" "), _c('span', [_vm._v("HUN")])])], 1)], 1)], 1), _vm._v(" "), _c('router-link', {
	    staticClass: "logo col-md-4",
	    attrs: {
	      "to": "/"
	    }
	  }, [_c('img', {
	    staticClass: "logo",
	    attrs: {
	      "src": __webpack_require__(215)
	    }
	  })]), _vm._v(" "), _c('section', {
	    staticClass: "menu col-md-4"
	  })], 1), _vm._v(" "), _c('md-sidenav', {
	    ref: "rightSidenav",
	    staticClass: "md-right",
	    on: {
	      "open": function($event) {
	        _vm.open('Right')
	      },
	      "close": function($event) {
	        _vm.close('Right')
	      }
	    }
	  }, [_c('md-toolbar', [_c('div', {
	    staticClass: "md-toolbar-container"
	  }, [_c('h3', {
	    staticClass: "md-title"
	  }, [_vm._v(_vm._s(_vm.$t("sign_in")))])])]), _vm._v(" "), _c('div', {
	    staticClass: "auth"
	  }, [_c('form', {
	    attrs: {
	      "novalidate": ""
	    },
	    on: {
	      "submit": function($event) {
	        $event.stopPropagation();
	        $event.preventDefault();
	        return _vm.submit($event)
	      }
	    }
	  }, [_c('md-input-container', [_c('label', [_vm._v(_vm._s(_vm.$t("email")))]), _vm._v(" "), _c('md-input', {
	    model: {
	      value: (_vm.email),
	      callback: function($$v) {
	        _vm.email = $$v
	      },
	      expression: "email"
	    }
	  })], 1), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v(_vm._s(_vm.$t("password")))]), _vm._v(" "), _c('md-input', {
	    attrs: {
	      "type": "password"
	    },
	    model: {
	      value: (_vm.password),
	      callback: function($$v) {
	        _vm.password = $$v
	      },
	      expression: "password"
	    }
	  })], 1)], 1), _vm._v(" "), _c('md-checkbox', {
	    model: {
	      value: (_vm.rememberMail),
	      callback: function($$v) {
	        _vm.rememberMail = $$v
	      },
	      expression: "rememberMail"
	    }
	  }, [_vm._v("E-mail cím megjegyzése")]), _c('br'), _vm._v(" "), _c('md-button', {
	    staticClass: "md-raised",
	    on: {
	      "click": _vm.login
	    }
	  }, [_vm._v(_vm._s(_vm.$t("sign_in")))]), _vm._v(" "), _c('md-button', {
	    staticClass: "md-raised md-warn",
	    on: {
	      "click": _vm.closeRightSidenav
	    }
	  }, [_vm._v(_vm._s(_vm.$t("cancel")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("signin_note")))]), _vm._v(" "), _c('router-link', {
	    staticClass: "md-primary",
	    attrs: {
	      "tag": "md-button",
	      "to": "/registration"
	    }
	  }, [_vm._v(_vm._s(_vm.$t("registration")))]), _vm._v(" "), _c('p', [_vm._v("Elfelejtett jelszó esetén adja meg a fenti mezőben az e-mail címét és kattintson az alábbi gombra:")]), _vm._v(" "), _c('md-button', {
	    staticClass: "md-primary",
	    on: {
	      "click": _vm.passwordReset
	    }
	  }, [_vm._v("Jelszó visszaállítás")])], 1)], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 408 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "profile"
	  }, [_c('md-card', [_c('md-card-header', [_c('div', {
	    staticClass: "md-title"
	  }, [_vm._v(_vm._s(_vm.$t("profile")))])]), _vm._v(" "), _c('md-card-content', [_c('div', {
	    staticClass: "avatar"
	  }, [_c('img', {
	    attrs: {
	      "src": _vm.profile.avatar
	    }
	  })]), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v(_vm._s(_vm.$t("admin.image")))]), _vm._v(" "), _c('md-file', {
	    attrs: {
	      "id": "fileInput"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('md-input-container', {
	    staticClass: "col-md-6"
	  }, [_c('label', [_vm._v(_vm._s(_vm.$t("name")))]), _vm._v(" "), _c('md-input', {
	    model: {
	      value: (_vm.profile.name),
	      callback: function($$v) {
	        _vm.$set(_vm.profile, "name", $$v)
	      },
	      expression: "profile.name"
	    }
	  })], 1), _vm._v(" "), (_vm.profile.doctorData) ? _c('md-input-container', {
	    staticClass: "col-md-6"
	  }, [_c('label', [_vm._v(_vm._s(_vm.$t("admin.healthcareId")))]), _vm._v(" "), _c('md-input', {
	    model: {
	      value: (_vm.profile.doctorData.healthcareId),
	      callback: function($$v) {
	        _vm.$set(_vm.profile.doctorData, "healthcareId", $$v)
	      },
	      expression: "profile.doctorData.healthcareId"
	    }
	  })], 1) : _vm._e()], 1), _vm._v(" "), _c('p', {
	    staticClass: "description"
	  }), _c('p', {
	    staticClass: "desc"
	  }, [_vm._v(_vm._s(_vm.$t("admin.descinfo")))]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [(_vm.profile.doctorData) ? _c('md-input-container', {
	    staticClass: "col-md-6"
	  }, [_c('label', [_vm._v(_vm._s(_vm.$t("admin.discipline")))]), _vm._v(" "), _c('md-input', {
	    model: {
	      value: (_vm.profile.doctorData.speciality),
	      callback: function($$v) {
	        _vm.$set(_vm.profile.doctorData, "speciality", $$v)
	      },
	      expression: "profile.doctorData.speciality"
	    }
	  })], 1) : _vm._e(), _vm._v(" "), (_vm.profile.doctorData) ? _c('md-input-container', {
	    staticClass: "col-md-6"
	  }, [_c('label', [_vm._v(_vm._s(_vm.$t("attributes")))]), _vm._v(" "), _c('md-input', {
	    model: {
	      value: (_vm.profile.doctorData.specification),
	      callback: function($$v) {
	        _vm.$set(_vm.profile.doctorData, "specification", $$v)
	      },
	      expression: "profile.doctorData.specification"
	    }
	  })], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [(_vm.profile.doctorData) ? _c('md-input-container', {
	    staticClass: "col-md-6"
	  }, [_c('label', [_vm._v(_vm._s(_vm.$t("admin.facebook_link")))]), _vm._v(" "), _c('md-input', {
	    model: {
	      value: (_vm.profile.doctorData.facebookPageUrl),
	      callback: function($$v) {
	        _vm.$set(_vm.profile.doctorData, "facebookPageUrl", $$v)
	      },
	      expression: "profile.doctorData.facebookPageUrl"
	    }
	  })], 1) : _vm._e(), _vm._v(" "), (_vm.profile.doctorData) ? _c('md-input-container', {
	    staticClass: "col-md-6"
	  }, [_c('label', [_vm._v(_vm._s(_vm.$t("admin.website")))]), _vm._v(" "), _c('md-input', {
	    model: {
	      value: (_vm.profile.doctorData.website),
	      callback: function($$v) {
	        _vm.$set(_vm.profile.doctorData, "website", $$v)
	      },
	      expression: "profile.doctorData.website"
	    }
	  })], 1) : _vm._e()], 1), _vm._v(" "), _c('p', {
	    staticClass: "desc"
	  }, [_vm._v("Publikus Facebook oldal megadásával a páciensek a Pulmoment alkalmazásán keresztül is olvashatják a Facebookon megosztott híreit.")]), _vm._v(" "), (_vm.profile.doctorData) ? _c('md-input-container', [_c('label', [_vm._v(_vm._s(_vm.$t("introduction")))]), _vm._v(" "), _c('md-textarea', {
	    model: {
	      value: (_vm.profile.doctorData.introduction),
	      callback: function($$v) {
	        _vm.$set(_vm.profile.doctorData, "introduction", $$v)
	      },
	      expression: "profile.doctorData.introduction"
	    }
	  })], 1) : _vm._e()], 1), _vm._v(" "), _c('md-card-actions', [_c('md-button', {
	    staticClass: "md-primary",
	    on: {
	      "click": function($event) {
	        _vm.save()
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t("admin.save")))])], 1)], 1), _vm._v(" "), _c('md-card', [_c('md-card-header', [_c('div', {
	    staticClass: "md-title"
	  }, [_vm._v(_vm._s(_vm.$t("contact")))])]), _vm._v(" "), (_vm.profile.doctorData) ? _c('md-card-content', _vm._l((_vm.profile.doctorData.contact), function(contact) {
	    return _c('div', {
	      staticClass: "row"
	    }, [_c('md-input-container', {
	      staticClass: "col-md-5"
	    }, [_c('label', [_vm._v(_vm._s(_vm.$t("contact_name")))]), _vm._v(" "), _c('md-input', {
	      model: {
	        value: (contact.name),
	        callback: function($$v) {
	          _vm.$set(contact, "name", $$v)
	        },
	        expression: "contact.name"
	      }
	    })], 1), _vm._v(" "), _c('md-input-container', {
	      staticClass: "col-md-5"
	    }, [_c('label', [_vm._v(_vm._s(_vm.$t("contact_data")))]), _vm._v(" "), _c('md-input', {
	      model: {
	        value: (contact.value),
	        callback: function($$v) {
	          _vm.$set(contact, "value", $$v)
	        },
	        expression: "contact.value"
	      }
	    })], 1), _vm._v(" "), _c('md-button', {
	      staticClass: "md-warn",
	      on: {
	        "click": function($event) {
	          _vm.deleteContact(contact)
	        }
	      }
	    }, [_vm._v("Törlés")])], 1)
	  })) : _vm._e(), _vm._v(" "), _c('md-card-actions', [_c('md-button', {
	    staticClass: "md-primary",
	    on: {
	      "click": function($event) {
	        _vm.newContact()
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t("admin.add_new")))]), _vm._v(" "), _c('md-button', {
	    staticClass: "md-primary",
	    on: {
	      "click": function($event) {
	        _vm.save()
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t("admin.save")))])], 1)], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "jobs"
	  }, [_c('navbar'), _vm._v(" "), _c('section', {
	    staticClass: "content"
	  }, [_c('p', {
	    staticClass: "md-display-3 bottomSpace"
	  }, [_vm._v("Join us because it's awesome!")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "text-align": "center"
	    }
	  }, [_c('md-button', {
	    staticClass: " md-raised md-primary",
	    attrs: {
	      "href": "#h1"
	    }
	  }, [_vm._v("See open positions")])], 1), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('h1', {
	    staticClass: "md-display-3",
	    staticStyle: {
	      "text-align": "center"
	    },
	    attrs: {
	      "id": "h1"
	    }
	  }, [_vm._v(" Open positions: ")]), _vm._v(" "), _c('div', {
	    staticClass: "md-card-container row "
	  }, _vm._l((_vm.jobs), function(job) {
	    return _c('div', {
	      staticClass: "col-md-6"
	    }, [_c('md-card', {
	      staticClass: "card"
	    }, [_c('md-card-header', {
	      staticClass: "md-primary"
	    }, [_c('div', {
	      staticClass: "md-title"
	    }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(job.title) + "\n\t\t\t\t\t\t")])]), _vm._v(" "), _c('md-card-expand', [_c('md-card-actions', [_c('md-button', {
	      staticClass: "md-icon-button",
	      attrs: {
	        "md-expand-trigger": ""
	      }
	    }, [_c('md-icon', [_vm._v("keyboard_arrow_down")])], 1)], 1), _vm._v(" "), _c('md-card-content', [_c('span', {
	      staticClass: "md-subheading"
	    }, [_vm._v("Description:")]), _c('br'), _vm._v(" "), _c('span', {
	      staticClass: "md-body2"
	    }, [_vm._v(_vm._s(job.description))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('md-card-actions', [_c('md-button', {
	      staticClass: "md-raised md-primary"
	    }, [_vm._v("Apply")])], 1), _vm._v(" "), _c('span', {
	      staticClass: "footers"
	    }, [_c('span', {
	      staticStyle: {}
	    }, [_vm._v("Work hours:")]), _vm._v(" "), _c('span', [_vm._v(" " + _vm._s(job.work_hours + " hours/week"))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("Salary range:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(job.salary_range) + " €")])])], 1)], 1)], 1)], 1)
	  }))])], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('p', {
	    staticClass: "md-subheading",
	    staticStyle: {
	      "text-align": "center",
	      "color": "indigo"
	    }
	  }, [_vm._v("\n\t\t\tWork with us on the most-convinient health tracking software to help the lives of chronic desease patients.\n\t\t\tWe are looking for university students, who are determined enough to consider a "), _c('br'), _vm._v("\n\t\t\tproduct as their own child, and ready to experiment with new solutions. All of the listed job opportunites are very flexible.\n\t\t\tWe can support you with professional practice and public research"), _c('br'), _vm._v(" projects. Please write us,  if you are interested in the healthcare\n\t\t\tfield, and you feel like your expertise could be valuable for our project.\n\t\t")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "image-container"
	  }, [_c('p', {
	    staticClass: "md-display-3 bottomSpace"
	  }, [_vm._v("Why us?")]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "container bottomSpace col-md-6"
	  }, [_c('p', [_vm._v(" sdsaportunites are very flexible."), _c('br'), _vm._v("\n\t\t\t\t\t\t\tWe can support you with professional "), _c('br'), _vm._v("practice and public research"), _c('br')]), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(350),
	      "alt": "we love our team!"
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "container bottomSpace col-md-6"
	  }, [_c('p', [_vm._v(" sdsaportunites are very flexible."), _c('br'), _vm._v("\n\t\t\t\t\t\tWe can support you with professional "), _c('br'), _vm._v("practice and public research"), _c('br')]), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(351),
	      "alt": "we love our team!"
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "container bottomSpace col-md-6"
	  }, [_c('p', [_vm._v(" sdsaportunites are very flexible."), _c('br'), _vm._v("\n\t\t\t\t\t\t\tWe can support you with professional "), _c('br'), _vm._v("practice and public research"), _c('br')]), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(352),
	      "alt": "we love our team!"
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "container bottomSpace col-md-6"
	  }, [_c('p', [_vm._v(" sdsaportunites are very flexible."), _c('br'), _vm._v("\n\t\t\t\t\t\t\tWe can support you with professional "), _c('br'), _vm._v("practice and public research"), _c('br')]), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(353),
	      "alt": "we love our team!"
	    }
	  })])])])
	}]}

/***/ }),
/* 410 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "patient"
	  }, [_c('md-card', [_c('md-card-header', [_c('div', {
	    staticClass: "md-title"
	  }, [_vm._v(_vm._s(_vm.patient.name))]), _vm._v(" "), _c('div', {
	    staticClass: "md-subhead"
	  }, [_vm._v(_vm._s(_vm.$t("admin.patientspage")))])]), _vm._v(" "), (_vm.patient.patientData) ? _c('md-card-content', [_c('section', {
	    staticClass: "row"
	  }, [_c('div', [_c('img', {
	    staticClass: "avatar",
	    attrs: {
	      "src": _vm.patient.avatar
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-10"
	  }, [_c('b', [_vm._v("Életkor:")]), _vm._v(" " + _vm._s(_vm.patient.patientData.age)), _c('br'), _vm._v(" "), _c('b', [_vm._v("E-mail:")]), _vm._v(" "), _c('a', {
	    attrs: {
	      "href": 'mailto:' + _vm.patient.email
	    }
	  }, [_vm._v(_vm._s(_vm.patient.email))]), _c('br'), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.$t("admin.mothersname")))]), _vm._v(" " + _vm._s(_vm.patient.patientData.mothersName)), _c('br'), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.$t("admin.socialsecuritynumber")))]), _vm._v(" " + _vm._s(_vm.patient.patientData.socialSecurity)), _c('br')])]), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.$t("admin.medicines")))]), _vm._v(" "), _c('section', {
	    staticClass: "row"
	  }, _vm._l((_vm.patient.patientData.medication), function(medication) {
	    return _c('div', {
	      staticClass: "medication col-md-4"
	    }, [_c('div', {
	      staticClass: "content"
	    }, [_vm._v("\n\t\t\t\t\t\tNév: "), _c('b', [_vm._v(_vm._s(medication.name))]), _c('br'), _vm._v("\n\t\t\t\t\t\tKategória: " + _vm._s(medication.category)), _c('br'), _vm._v("\n\t\t\t\t\t\tForma: " + _vm._s(medication.form)), _c('br'), _vm._v("\n\t\t\t\t\t\tFelírt mennyiség: " + _vm._s(medication.frequencyUnit) + " x " + _vm._s(medication.frequencyVal) + " adag"), _c('br'), _vm._v("\n\t\t\t\t\t\tHatóanyag: " + _vm._s(medication.doseVal ? medication.doseVal : 'Nincs megadva')), _c('br')])])
	  }))]) : _vm._e(), _vm._v(" "), _c('md-card-actions', [_c('md-button', {
	    attrs: {
	      "href": _vm.pdfUrl(),
	      "target": "_blank"
	    }
	  }, [_vm._v(_vm._s(_vm.$t("admin.printsummary")))]), _vm._v(" "), _c('md-button', {
	    on: {
	      "click": function($event) {
	        _vm.notifyPatient()
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t("admin.findinspector")))])], 1)], 1), _vm._v(" "), _c('md-whiteframe', {
	    attrs: {
	      "md-elevation": "2"
	    }
	  }, [_c('md-tabs', [_c('md-tab', {
	    attrs: {
	      "id": "monthly",
	      "md-label": _vm.$t('admin.monthlyReport')
	    }
	  }, [_c('div', {
	    staticClass: "row interval"
	  }, [_c('span', {
	    staticClass: "col-xs-4"
	  }, [_c('md-button', {
	    staticClass: "md-primary",
	    on: {
	      "click": function($event) {
	        _vm.reportDate.subtract(1, 'months');
	        _vm.loadReport();
	      }
	    }
	  }, [_c('md-icon', [_vm._v("keyboard_arrow_left")]), _vm._v("Előző hónap")], 1)], 1), _vm._v(" "), _c('span', {
	    staticClass: "col-xs-4"
	  }, [_c('md-button', [_vm._v("Megjelenített hónap: " + _vm._s(_vm.reportDate.format("YYYY MMMM")))])], 1), _vm._v(" "), _c('span', {
	    staticClass: "col-xs-4"
	  }, [(_vm.reportDate.isBefore(_vm.now)) ? _c('md-button', {
	    staticClass: "md-primary",
	    on: {
	      "click": function($event) {
	        _vm.reportDate.add(1, 'months');
	        _vm.loadReport();
	      }
	    }
	  }, [_vm._v("Következő hónap"), _c('md-icon', [_vm._v("keyboard_arrow_right")])], 1) : _vm._e()], 1)]), _vm._v(" "), _c('md-card', [_c('md-card-header', [_c('div', {
	    staticClass: "md-title"
	  }, [_vm._v(_vm._s(_vm.$t("admin.rescueMedSymptom")))])]), _vm._v(" "), _c('md-card-content', [_c('bar-chart', {
	    attrs: {
	      "values": _vm.dailyMedications
	    }
	  })], 1)], 1), _vm._v(" "), _c('md-table-card', [_c('md-table', {
	    attrs: {
	      "md-sort": "title",
	      "md-sort-type": "desc"
	    },
	    on: {
	      "sort": _vm.onSort
	    }
	  }, [_c('md-table-header', [_c('md-table-row', [_c('md-table-head', {
	    attrs: {
	      "md-sort-by": "title"
	    }
	  }, [_vm._v(_vm._s(_vm.$t("admin.factor")))]), _vm._v(" "), _c('md-table-head', {
	    attrs: {
	      "md-sort-by": "value"
	    }
	  }, [_vm._v(_vm._s(_vm.$t("admin.value")))]), _vm._v(" "), _c('md-table-head', [_vm._v(_vm._s(_vm.$t("admin.tendency")))])], 1)], 1), _vm._v(" "), _c('md-table-body', _vm._l((_vm.data.factors), function(factor, index) {
	    return _c('md-table-row', {
	      key: index,
	      attrs: {
	        "md-item": factor
	      }
	    }, [_c('md-table-cell', {
	      key: 'title',
	      attrs: {
	        "md-numeric": false
	      }
	    }, [_vm._v(_vm._s(factor.title))]), _vm._v(" "), _c('md-table-cell', {
	      key: 'value',
	      attrs: {
	        "md-numeric": false
	      }
	    }, [(factor.unit === 'frequency') ? _c('span', [_vm._v("Főként: " + _vm._s(_vm.$t(factor.value)))]) : _c('span', [_vm._v(_vm._s(_vm.$t(factor.value)) + " " + _vm._s(_vm.$t(factor.unit)))])]), _vm._v(" "), _c('md-table-cell', [_vm._v("~")])], 1)
	  }))], 1)], 1), _vm._v(" "), _c('md-card', [_c('md-card-header', [_c('div', {
	    staticClass: "md-title"
	  }, [_vm._v("Szöveges megjegyzések")])]), _vm._v(" "), _c('md-card-content', _vm._l((_vm.data.comments), function(comment) {
	    return _c('div', [_c('div', {
	      staticClass: "content"
	    }, [_c('h3', [_vm._v(_vm._s(_vm.toShortDate(comment.updatedAt)))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(comment.value))])])])
	  }))], 1)], 1), _vm._v(" "), _c('md-tab', {
	    attrs: {
	      "id": "daily",
	      "md-label": _vm.$t('admin.dailyReport')
	    }
	  }, [_c('vue-event-calendar', {
	    attrs: {
	      "events": _vm.measurementEvents
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(props) {
	        return _vm._l((props.showEvents), function(measurement, index) {
	          return _c('div', {
	            staticClass: "event-item"
	          }, [_c('b', [_vm._v("Type:")]), _vm._v(" " + _vm._s(_vm.$t(measurement.type))), _c('br'), _vm._v(" "), _c('b', [_vm._v("Value:")]), _vm._v(" " + _vm._s(_vm.$t(measurement.value))), _c('br'), _vm._v(" "), _c('b', [_vm._v("Time:")]), _vm._v(" " + _vm._s(_vm.timeFromDate(measurement.updatedAt)) + "\n\t\t\t\t\t\t")])
	        })
	      }
	    }])
	  })], 1)], 1)], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 411 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "info"
	  }, [_c('navbar'), _vm._v(" "), _c('section', {
	    staticClass: "content"
	  }, [_c('md-card', [_c('md-card-header', [_c('div', {
	    staticClass: "md-title"
	  }, [_vm._v(_vm._s(_vm.$t("peakflowmeter")))])]), _vm._v(" "), _c('md-card-content', [_c('p', [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.$t("peakflowmeterinfo"))), _c('br'), _c('br'), _vm._v("\n\n\t\t\t\t\t" + _vm._s(_vm.$t("peakflowmeterlink")) + " "), _c('a', {
	    attrs: {
	      "href": "http://www.webbeteg.hu/cikkek/asztma/289/hogyan-diagnosztizaljak-az-asztmat"
	    }
	  }, [_vm._v("http://www.webbeteg.hu/cikkek/asztma/289/hogyan-diagnosztizaljak-az-asztmat")])]), _vm._v(" "), _c('iframe', {
	    attrs: {
	      "width": "320",
	      "height": "200",
	      "src": "https://www.youtube.com/embed/2gwGmyBdq_o",
	      "frameborder": "0",
	      "allowfullscreen": ""
	    }
	  })])], 1)], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "home"
	  }, [_c('navbar'), _vm._v(" "), _c('section', {
	    staticClass: "head row md-whiteframe center-xs middle-xs",
	    attrs: {
	      "id": "head"
	    }
	  }, [_c('div', {
	    staticClass: "gradient"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "column main"
	  }, [_c('div', {
	    staticClass: "intro col-md-offset-1 col-md-10 row middle-xs"
	  }, [_c('div', {
	    staticClass: "col-md-7"
	  }, [_c('animated-logo', {
	    attrs: {
	      "primaryColor": "#ffffff",
	      "secondaryColor": "#2196f3"
	    }
	  }), _vm._v(" "), _c('p', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.$t('home.intro'))
	    }
	  })], 1), _vm._v(" "), (_vm.introLoaded) ? _c('div', {
	    staticClass: "col-md-5 col-xs-12"
	  }, [_c('iframe', {
	    attrs: {
	      "width": "560",
	      "height": "315",
	      "src": "https://www.youtube.com/embed/f_MiF80J04M?rel=0&showinfo=0",
	      "frameborder": "0",
	      "allow": "autoplay; encrypted-media",
	      "allowfullscreen": ""
	    }
	  })]) : _vm._e()])])]), _vm._v(" "), _c('section', {
	    staticClass: "row first col-md-offset-1 col-md-10 between-md"
	  }, [_c('md-card', [_c('md-card-content', [_c('store-links', {
	    attrs: {
	      "type": _vm.type
	    }
	  })], 1)], 1)], 1), _vm._v(" "), _c('section', {
	    staticClass: "row col-md-offset-1 col-md-10"
	  }, [_c('md-card', [_c('md-card-content', {
	    staticClass: "row features"
	  }, [_c('div', {
	    staticClass: "col-md-7 row"
	  }, [_c('div', {
	    staticClass: "col-sm-6 col-xs-12"
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(357)
	    }
	  }), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.$t("home.featuresecond")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("home.featureseconddesc")))])]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-6 col-xs-12"
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(355)
	    }
	  }), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.$t("home.featurethird")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("home.featurethirddesc")))])]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-6 col-xs-12"
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(354)
	    }
	  }), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.$t("home.featurefourth")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("home.featurefourthdesc")))])]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-6 col-xs-12"
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(356)
	    }
	  }), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.$t("home.featurefirst")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("home.featurefirstdesc")))])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-5 col-xs-12 row center-xs bottom-xs"
	  }, [_c('div', {
	    staticClass: "intro-mobile"
	  }, [_c('div', {
	    ref: "variableA",
	    staticClass: "variable",
	    staticStyle: {
	      "z-index": "3"
	    },
	    style: ({
	      'background-image': 'url(' + _vm.introImage(0) + ')'
	    })
	  }), _vm._v(" "), _c('div', {
	    ref: "variableB",
	    staticClass: "variable",
	    staticStyle: {
	      "z-index": "2"
	    },
	    style: ({
	      'background-image': 'url(' + _vm.introImage(1) + ')'
	    })
	  }), _vm._v(" "), _c('div', {
	    ref: "variableC",
	    staticClass: "variable",
	    staticStyle: {
	      "z-index": "1"
	    },
	    style: ({
	      'background-image': 'url(' + _vm.introImage(2) + ')'
	    })
	  }), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(214)
	    }
	  })])])])], 1)], 1), _vm._v(" "), _c('section', {
	    staticClass: "posts row col-md-offset-1 col-md-10 between-md"
	  }, [_c('feed-view')], 1), _vm._v(" "), _c('section', {
	    staticClass: "row col-md-offset-1 col-md-10"
	  }, [_c('md-card', [_c('md-card-header', [_c('div', {
	    staticClass: "md-title"
	  }, [_vm._v(_vm._s(_vm.$t("home.supportTitle")))])]), _vm._v(" "), _c('md-card-content', {
	    staticClass: "row support"
	  }, [_c('div', {
	    staticClass: "col-sm-3 col-xs-12"
	  }, [_c('a', {
	    attrs: {
	      "href": "http://www.elte.hu",
	      "target": "_blank"
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(368)
	    }
	  }), _c('br'), _vm._v("\n\t\t\t\t\t\tELTE\n\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-3 col-xs-12"
	  }, [_c('a', {
	    attrs: {
	      "href": "https://www.eitdigital.eu/eit-digital-academy/",
	      "target": "_blank"
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(367)
	    }
	  }), _c('br'), _vm._v("\n\t\t\t\t\t\tEIT Digital Academy\n\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-3 col-xs-12"
	  }, [_c('a', {
	    attrs: {
	      "href": "http://www.ujbuda.hu/",
	      "target": "_blank"
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(370)
	    }
	  }), _c('br'), _vm._v("\n\t\t\t\t\t\tÚjbudai Önkormányzat\n\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-3 col-xs-12"
	  }, [_c('a', {
	    attrs: {
	      "href": "http://www.szanthoandras.hu/",
	      "target": "_blank"
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(369)
	    }
	  }), _c('br'), _vm._v("\n\t\t\t\t\t\tSzánthó és Társa\n\t\t\t\t\t")])])])], 1)], 1), _vm._v(" "), _c('section', {
	    staticClass: "team row col-md-offset-1 col-md-10"
	  }, [_c('md-card', [_c('md-card-header', [_c('div', {
	    staticClass: "md-title"
	  }, [_vm._v(_vm._s(_vm.$t("contact_us")))]), _vm._v(" "), _c('div', {
	    staticClass: "md-subhead"
	  }, [_vm._v(_vm._s(_vm.$t("report_feedback")))])]), _vm._v(" "), _c('md-card-content', {
	    staticClass: "center-xs"
	  }, [_c('div', {
	    staticClass: "row center-xs"
	  }, _vm._l((_vm.team), function(member) {
	    return _c('span', {
	      staticClass: "member col-sm-2 col-xs-12"
	    }, [_c('a', {
	      attrs: {
	        "href": _vm.contactMail()
	      }
	    }, [_c('img', {
	      attrs: {
	        "src": _vm.teamImgUrl(member.image)
	      }
	    })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('b', [_vm._v(_vm._s(member.first))]), _c('br'), _vm._v(_vm._s(member.last)), _c('br'), _vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.$t(member.desc)) + "\n\t\t\t\t\t")])
	  })), _vm._v(" "), _c('br'), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.$t("home.specialThanks")))]), _vm._v(" "), _c('div', {
	    staticClass: "row center-xs"
	  }, _vm._l((_vm.thanksFor), function(person) {
	    return _c('span', {
	      staticClass: "col-sm-2 col-xs-12"
	    }, [_c('i', [_c('b', [_vm._v(_vm._s(person.first))]), _c('br'), _vm._v(_vm._s(person.last))])])
	  })), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
	    staticClass: "row center-xs directly"
	  }, [_c('md-button', {
	    staticClass: "md-primary md-raised",
	    attrs: {
	      "href": _vm.contactMail()
	    }
	  }, [_vm._v(_vm._s(_vm.$t("contact_us_directly")) + " hello@pulmoment.com")])], 1)])], 1)], 1), _vm._v(" "), _c('section', {
	    staticClass: "row col-md-offset-1 col-md-10 between-md"
	  }, [_c('md-card', [_c('md-card-content', [_c('store-links', {
	    attrs: {
	      "type": _vm.type
	    }
	  })], 1)], 1)], 1), _vm._v(" "), _c('md-dialog', {
	    ref: "videoDialog"
	  }, [_c('md-dialog-content', [_c('iframe', {
	    staticClass: "video",
	    attrs: {
	      "width": "853",
	      "height": "480",
	      "src": "https://www.youtube.com/embed/f_MiF80J04M?rel=0&showinfo=0",
	      "frameborder": "0",
	      "allowfullscreen": ""
	    }
	  })])], 1), _vm._v(" "), _c('section', {
	    staticClass: "footer row col-md-offset-1 col-md-10"
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(213)
	    }
	  }), _c('br'), _vm._v("\n\t\t" + _vm._s(new Date().getFullYear()) + " - Pulmoment - All rights reseverd"), _c('br'), _vm._v(" "), _vm._m(0)])], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', [_vm._v("Icons made by "), _c('a', {
	    attrs: {
	      "href": "http://www.freepik.com",
	      "title": "Freepik"
	    }
	  }, [_vm._v("Freepik")]), _vm._v(" from "), _c('a', {
	    attrs: {
	      "href": "http://www.flaticon.com",
	      "title": "Flaticon"
	    }
	  }, [_vm._v("www.flaticon.com")]), _vm._v(" is licensed by "), _c('a', {
	    attrs: {
	      "href": "http://creativecommons.org/licenses/by/3.0/",
	      "title": "Creative Commons BY 3.0"
	    }
	  }, [_vm._v("CC BY 3.0")])])
	}]}

/***/ }),
/* 413 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "reset"
	  }, [_c('navbar'), _vm._v(" "), _c('section', {
	    staticClass: "content"
	  }, [_c('md-card', [_c('md-card-header', [_c('div', {
	    staticClass: "md-title"
	  }, [_vm._v("Új jelszó igénylés")])]), _vm._v(" "), _c('md-card-content', [_vm._v("\n\t\t\t\tEzen a felületen új jelszót állíthat be a fiókjára. Ha mégsem szeretné megváltoztatni a jelszavát, hagyja figyelmen kívül."), _c('br'), _vm._v(" "), _c('b', [_vm._v("A jelszónak legalább 8 karakter hosszú szöveget kell megadni, legalább egy kis és nagybetű, valamint szám használatával!")]), _vm._v(" "), _c('md-input-container', {
	    staticClass: "col-md-6"
	  }, [_c('label', [_vm._v("Új jelszó")]), _vm._v(" "), _c('md-input', {
	    attrs: {
	      "type": "password"
	    },
	    model: {
	      value: (_vm.password),
	      callback: function($$v) {
	        _vm.password = $$v
	      },
	      expression: "password"
	    }
	  })], 1)], 1), _vm._v(" "), _c('md-card-actions', [_c('md-button', {
	    on: {
	      "click": _vm.reset
	    }
	  }, [_vm._v("Küldés")])], 1)], 1)], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 414 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "app"
	    }
	  }, [_c('router-view'), _vm._v(" "), _c('vue-toast', {
	    ref: "toast"
	  }), _vm._v(" "), _c('contact-dialog')], 1)
	},staticRenderFns: []}

/***/ }),
/* 415 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "dashboard"
	  }, [_c('md-card', [_c('md-card-content', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('h3', [_vm._v(_vm._s(_vm.$t("admin.current")))]), _vm._v(" "), _c('span', [_vm._v("Új funkció a rendszerben: napi bontás a páciensek adatlapján."), _c('br'), _vm._v(_vm._s(_vm.$t("admin.consultinghours")))])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('h3', [_vm._v(_vm._s(_vm.$t("admin.nextoverall")))]), _vm._v(" "), (_vm.globalInfo.hasNextConsulting) ? _c('span', [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.globalInfo.nextConsultingDate) + " (páciensek adatai alapján)\n\t\t\t\t")]) : _c('span', [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.$t("admin.novisit")) + "\n\t\t\t\t")])])])], 1), _vm._v(" "), _c('md-card', [_c('md-card-header', [_c('div', {
	    staticClass: "md-title"
	  }, [_vm._v(_vm._s(_vm.$t("admin.totalizedsymptoms")))]), _vm._v(" "), _c('div', {
	    staticClass: "md-subhead"
	  }, [_vm._v(_vm._s(_vm.$t("admin.allpatients")))])]), _vm._v(" "), _c('md-card-content', [_c('line-chart', {
	    attrs: {
	      "values": _vm.globalSymptoms
	    }
	  })], 1)], 1), _vm._v(" "), _c('md-card', [_c('md-card-header', [_c('div', {
	    staticClass: "md-title"
	  }, [_vm._v(_vm._s(_vm.$t("admin.filledinspector")))]), _vm._v(" "), _c('div', {
	    staticClass: "md-subhead"
	  }, [_vm._v(_vm._s(_vm.$t("admin.allpatients")))])]), _vm._v(" "), _c('md-card-content', [_c('md-progress', {
	    staticClass: "md-accent",
	    attrs: {
	      "md-progress": _vm.controlProgress()
	    }
	  }), _vm._v(" "), (_vm.globalInfo.filledControl > 0) ? _c('p', [_vm._v(_vm._s(_vm.globalInfo.patientCount) + " páciensből " + _vm._s(_vm.globalInfo.filledControl) + " töltötte ki az állapotfelmérőt")]) : _c('p', [_vm._v(_vm._s(_vm.$t("admin.noinspector")))])], 1), _vm._v(" "), _c('md-card-actions')], 1), _vm._v(" "), _c('md-table-card', [_c('md-toolbar', [_c('h1', {
	    staticClass: "md-title"
	  }, [_vm._v(_vm._s(_vm.$t("admin.newpatients")))])]), _vm._v(" "), _c('md-table', [_c('md-table-header', [_c('md-table-row', [_c('md-table-head', [_vm._v(_vm._s(_vm.$t("name")))]), _vm._v(" "), _c('md-table-head', [_vm._v(_vm._s(_vm.$t("email")))]), _vm._v(" "), _c('md-table-head', [_vm._v(_vm._s(_vm.$t("admin.numberofsymptoms")))]), _vm._v(" "), _c('md-table-head', [_vm._v(_vm._s(_vm.$t("admin.data")))])], 1)], 1), _vm._v(" "), _c('md-table-body', _vm._l((_vm.newPatients), function(patient, index) {
	    return _c('md-table-row', {
	      key: index,
	      attrs: {
	        "md-item": patient
	      }
	    }, [_c('md-table-cell', {
	      key: 'name',
	      attrs: {
	        "md-numeric": false
	      }
	    }, [_vm._v(_vm._s(patient.name ? patient.name : "Nincs név megadva"))]), _vm._v(" "), _c('md-table-cell', {
	      key: 'email',
	      attrs: {
	        "md-numeric": false
	      }
	    }, [_vm._v(_vm._s(patient.email))]), _vm._v(" "), _c('md-table-cell', [_vm._v(_vm._s(patient.symptomCount))]), _vm._v(" "), _c('md-table-cell', [_c('md-button', {
	      staticClass: "md-primary",
	      nativeOn: {
	        "click": function($event) {
	          _vm.showPatient(patient)
	        }
	      }
	    }, [_vm._v("Adatok")])], 1)], 1)
	  }))], 1)], 1), _vm._v(" "), _c('md-card', [_c('md-card-header', [_c('div', {
	    staticClass: "md-title"
	  }, [_vm._v("Levegő minőség jelentések")])]), _vm._v(" "), _c('md-card-content', [_vm._v("\n\t\t\tPollen:\n\t\t\t"), _c('a', {
	    staticClass: "md-padding",
	    attrs: {
	      "href": "http://oki.antsz.hu/files/jelentesek/aktualis.pdf",
	      "target": "_blank"
	    }
	  }, [_vm._v("ANTSZ")]), _vm._v(" "), _c('a', {
	    staticClass: "md-padding",
	    attrs: {
	      "href": "http://www.met.hu/idojaras/humanmeteorologia/pollenjelentes/",
	      "target": "_blank"
	    }
	  }, [_vm._v("MET")]), _vm._v(" "), _c('a', {
	    staticClass: "md-padding",
	    attrs: {
	      "href": "https://www.idokep.hu/pollen",
	      "target": "_blank"
	    }
	  }, [_vm._v("Időkép pollen")]), _vm._v("\n\t\t\tLégszennyezettség:\n\t\t\t"), _c('a', {
	    staticClass: "md-padding",
	    attrs: {
	      "href": "https://www.idokep.hu/szmog",
	      "target": "_blank"
	    }
	  }, [_vm._v("Időkép szmog")]), _vm._v(" "), _c('a', {
	    staticClass: "md-padding",
	    attrs: {
	      "href": "http://www.legszennyezes.hu",
	      "target": "_blank"
	    }
	  }, [_vm._v("Légszennyezés.hu")])])], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 416 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "registration"
	  }, [_c('navbar'), _vm._v(" "), _c('section', {
	    staticClass: "content"
	  }, [_c('md-card', [_c('md-card-header', [_c('div', {
	    staticClass: "md-title"
	  }, [_vm._v("Regisztráció")]), _vm._v(" "), _c('div', {
	    staticClass: "md-subhead"
	  }, [_vm._v("Profil készítése az orvosi felülethez")])]), _vm._v(" "), _c('md-card-content', [_vm._v("\n\t\t\t\tEz a felület orvosok számára van fenntartva.\n\t\t\t\tA páciensek számára készítetett alkalmazás elérhető a Google Play és Apple App Store alkalmazásboltban."), _c('br'), _c('br'), _vm._v(" "), _c('b', [_vm._v("Publikus adatok:")]), _vm._v(" A publikus adatokat a szoftverünket használó páciensek láthatják. Kizárólag a kék színnel jelzett mezők számítanak publikus információnak, minden más adatot kizárólag a regisztráció folyamatában használjuk a személyazonosság ellenőrzésére. A profil elfogadása utána további kapcsolati adatokat is megadhat a páciensei számára."), _c('br'), _vm._v(" "), _c('b', [_vm._v("Kötelező mezők:")]), _vm._v(" A csillaggal jelzett adatok megadása kötelező. Ezek alapján ellenőrizzük a személyazonosságát, és 24 órán belül elkészítjük a személyre szabott profilját."), _c('br'), _c('br'), _vm._v(" "), _c('form', {
	    on: {
	      "submit": function($event) {
	        $event.stopPropagation();
	        $event.preventDefault();
	        return _vm.registration($event)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('label', [_vm._v("Alap adatok")]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-6 col-xs-12"
	  }, [_c('md-input-container', [_c('label', {
	    staticClass: "public"
	  }, [_vm._v("Név (publikus)")]), _vm._v(" "), _c('md-input', {
	    attrs: {
	      "required": ""
	    },
	    model: {
	      value: (_vm.form.name),
	      callback: function($$v) {
	        _vm.$set(_vm.form, "name", $$v)
	      },
	      expression: "form.name"
	    }
	  })], 1)], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6 col-xs-12"
	  }, [_c('md-input-container', [_c('label', [_vm._v("E-mail cím")]), _vm._v(" "), _c('md-input', {
	    attrs: {
	      "required": ""
	    },
	    model: {
	      value: (_vm.form.email),
	      callback: function($$v) {
	        _vm.$set(_vm.form, "email", $$v)
	      },
	      expression: "form.email"
	    }
	  })], 1)], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-6 col-xs-12"
	  }, [_c('md-input-container', [_c('label', [_vm._v("Telefonszám")]), _vm._v(" "), _c('md-input', {
	    attrs: {
	      "required": ""
	    },
	    model: {
	      value: (_vm.form.doctorData.phone),
	      callback: function($$v) {
	        _vm.$set(_vm.form.doctorData, "phone", $$v)
	      },
	      expression: "form.doctorData.phone"
	    }
	  })], 1)], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6 col-xs-12"
	  }, [_c('md-input-container', [_c('label', [_vm._v("Egészségügyi nyilvántartási szám")]), _vm._v(" "), _c('md-input', {
	    attrs: {
	      "required": ""
	    },
	    model: {
	      value: (_vm.form.doctorData.healthcareId),
	      callback: function($$v) {
	        _vm.$set(_vm.form.doctorData, "healthcareId", $$v)
	      },
	      expression: "form.doctorData.healthcareId"
	    }
	  })], 1)], 1)])]), _vm._v(" "), _c('div', {
	    staticClass: "input-group"
	  }, [_c('label', [_vm._v("Szakvizsga / szakvizsgák*")]), _vm._v(" "), _vm._l((_vm.form.doctorData.specialities), function(speciality) {
	    return _c('div', {
	      staticClass: "row"
	    }, [_c('md-input-container', {
	      staticClass: "col-md"
	    }, [_c('label', [_vm._v("Szakvizsga megnevezése")]), _vm._v(" "), _c('md-input', {
	      model: {
	        value: (speciality.name),
	        callback: function($$v) {
	          _vm.$set(speciality, "name", $$v)
	        },
	        expression: "speciality.name"
	      }
	    })], 1), _vm._v(" "), _c('md-button', {
	      staticClass: "md-warn",
	      on: {
	        "click": function($event) {
	          _vm.deleteElement(_vm.form.doctorData.specialities, speciality)
	        }
	      }
	    }, [_vm._v("Törlés")])], 1)
	  }), _vm._v(" "), _c('div', {
	    staticClass: "row end-xs"
	  }, [_c('md-button', {
	    staticClass: "md-primary",
	    on: {
	      "click": function($event) {
	        _vm.form.doctorData.specialities.push({
	          name: ''
	        })
	      }
	    }
	  }, [_vm._v("\n\t\t\t\t\t\t\t\tTovábbi szakvizsga hozzáadása\n\t\t\t\t\t\t\t")])], 1)], 2), _vm._v(" "), _c('div', {
	    staticClass: "input-group"
	  }, [_c('label', {
	    staticClass: "public"
	  }, [_vm._v("Aktuális munkahely / munkahelyek (publikus)")]), _vm._v(" "), _vm._l((_vm.form.doctorData.workplaces), function(workplace) {
	    return _c('div', {
	      staticClass: "row"
	    }, [_c('md-input-container', {
	      staticClass: "col-md"
	    }, [_c('label', [_vm._v("Munkahely neve")]), _vm._v(" "), _c('md-input', {
	      model: {
	        value: (workplace.name),
	        callback: function($$v) {
	          _vm.$set(workplace, "name", $$v)
	        },
	        expression: "workplace.name"
	      }
	    })], 1), _vm._v(" "), _c('md-input-container', {
	      staticClass: "col-md"
	    }, [_c('label', [_vm._v("Osztály / szakrendelés")]), _vm._v(" "), _c('md-input', {
	      model: {
	        value: (workplace.department),
	        callback: function($$v) {
	          _vm.$set(workplace, "department", $$v)
	        },
	        expression: "workplace.department"
	      }
	    })], 1), _vm._v(" "), _c('md-input-container', {
	      staticClass: "col-md"
	    }, [_c('label', [_vm._v("Beosztás")]), _vm._v(" "), _c('md-input', {
	      model: {
	        value: (workplace.assignment),
	        callback: function($$v) {
	          _vm.$set(workplace, "assignment", $$v)
	        },
	        expression: "workplace.assignment"
	      }
	    })], 1), _vm._v(" "), _c('md-button', {
	      staticClass: "md-warn",
	      on: {
	        "click": function($event) {
	          _vm.deleteElement(_vm.form.doctorData.workplaces, workplace)
	        }
	      }
	    }, [_vm._v("Törlés")])], 1)
	  }), _vm._v(" "), _c('div', {
	    staticClass: "row end-xs"
	  }, [_c('md-button', {
	    staticClass: "md-primary",
	    on: {
	      "click": function($event) {
	        _vm.form.doctorData.workplaces.push({
	          name: '',
	          department: '',
	          assignment: ''
	        })
	      }
	    }
	  }, [_vm._v("\n\t\t\t\t\t\t\t\tTovábbi munkahely hozzáadása\n\t\t\t\t\t\t\t")])], 1)], 2), _vm._v(" "), _c('div', {
	    staticClass: "input-group"
	  }, [_c('label', {
	    staticClass: "public"
	  }, [_vm._v("Egyéb adatok (nem kötelező)")]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-4 col-xs-12"
	  }, [_c('md-input-container', [_c('label', {
	    staticClass: "public"
	  }, [_vm._v("Jelenlegi weboldal (publikus)")]), _vm._v(" "), _c('md-input', {
	    model: {
	      value: (_vm.form.doctorData.website),
	      callback: function($$v) {
	        _vm.$set(_vm.form.doctorData, "website", $$v)
	      },
	      expression: "form.doctorData.website"
	    }
	  })], 1)], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4 col-xs-12"
	  }, [_c('md-input-container', [_c('label', {
	    staticClass: "public"
	  }, [_vm._v("Facebook oldal (publikus)")]), _vm._v(" "), _c('md-input', {
	    model: {
	      value: (_vm.form.doctorData.facebookPageUrl),
	      callback: function($$v) {
	        _vm.$set(_vm.form.doctorData, "facebookPageUrl", $$v)
	      },
	      expression: "form.doctorData.facebookPageUrl"
	    }
	  })], 1)], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4 col-xs-12"
	  }, [_c('md-input-container', [_c('label', {
	    staticClass: "public"
	  }, [_vm._v("Foglalkozási kör (publikus)")]), _vm._v(" "), _c('md-input', {
	    model: {
	      value: (_vm.form.doctorData.speciality),
	      callback: function($$v) {
	        _vm.$set(_vm.form.doctorData, "speciality", $$v)
	      },
	      expression: "form.doctorData.speciality"
	    }
	  })], 1)], 1)])]), _vm._v(" "), _c('div', {
	    staticClass: "row end-xs middle-xs"
	  }, [_c('div', [_vm._v("\n\t\t\t\t\t\t\tA regisztrációval elfogadja az adatvédelmi nyilatkozatba foglalt feltételeinket:\n\t\t\t\t\t\t\t"), _c('a', {
	    attrs: {
	      "target": "_blank",
	      "href": "../static/legal.pdf"
	    }
	  }, [_vm._v("\n\t\t\t\t\t\t\tnyilatkozat megtekintése\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t\t\t\t\tSikertelen regisztráció vagy hiba esetén keressen fel minket e-mailben:\n\t\t\t\t\t\t\t"), _c('a', {
	    attrs: {
	      "target": "_blank",
	      "href": "mailto:hello@pulmoment.com?subject=Registration"
	    }
	  }, [_vm._v("\n\t\t\t\t\t\t\thello@pulmoment.com\n\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('md-button', {
	    staticClass: "md-raised md-accent",
	    attrs: {
	      "disabled": _vm.loading,
	      "type": "submit"
	    }
	  }, [_vm._v("Küldés")])], 1)])])], 1)], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 417 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "patients"
	  }, [_c('md-card', [_c('md-card-header', [_c('div', {
	    staticClass: "md-title"
	  }, [_vm._v(_vm._s(_vm.$t("admin.patients")))])]), _vm._v(" "), _c('md-card-content', {
	    staticClass: "row"
	  }, [_c('md-checkbox', {
	    model: {
	      value: (_vm.showHidden),
	      callback: function($$v) {
	        _vm.showHidden = $$v
	      },
	      expression: "showHidden"
	    }
	  }, [_vm._v("Rejtett felhasználók megjelenítése")])], 1)], 1), _vm._v(" "), _c('md-table-card', [_c('md-table', {
	    attrs: {
	      "md-sort": "name",
	      "md-sort-type": "asc"
	    },
	    on: {
	      "sort": _vm.onSort
	    }
	  }, [_c('md-table-header', [_c('md-table-row', [_c('md-table-head', [_vm._v(_vm._s(_vm.$t("admin.image")))]), _vm._v(" "), _c('md-table-head', {
	    attrs: {
	      "md-sort-by": "name"
	    }
	  }, [_vm._v(_vm._s(_vm.$t("name")))]), _vm._v(" "), _c('md-table-head', {
	    attrs: {
	      "md-sort-by": "email"
	    }
	  }, [_vm._v(_vm._s(_vm.$t("email")))]), _vm._v(" "), _c('md-table-head', [_vm._v(_vm._s(_vm.$t("admin.summary")) + " (" + _vm._s(_vm.$t("admin.lastFourWeek")) + ")")]), _vm._v(" "), _c('md-table-head', [_vm._v(_vm._s(_vm.$t("admin.data")))]), _vm._v(" "), _c('md-table-head', [_vm._v("Rejtve")])], 1)], 1), _vm._v(" "), _c('md-table-body', _vm._l((_vm.patientsPage), function(patient, index) {
	    return (_vm.showHidden ||  !patient.hidden) ? _c('md-table-row', {
	      key: index,
	      attrs: {
	        "md-item": patient
	      }
	    }, [_c('md-table-cell', [_c('md-avatar', {
	      staticClass: "avatar"
	    }, [_c('img', {
	      attrs: {
	        "src": patient.avatar
	      }
	    }), _vm._v(" "), _c('md-tooltip', {
	      attrs: {
	        "md-direction": "bottom"
	      }
	    }, [_c('img', {
	      staticClass: "large-avatar",
	      attrs: {
	        "src": patient.avatar
	      }
	    })])], 1)], 1), _vm._v(" "), _c('md-table-cell', {
	      key: 'name',
	      attrs: {
	        "md-numeric": false
	      }
	    }, [_c('span', {
	      class: {
	        'anonym': !patient.name
	      }
	    }, [_vm._v(_vm._s(patient.name ? patient.name : "Nincs név megadva"))])]), _vm._v(" "), _c('md-table-cell', {
	      key: 'email',
	      attrs: {
	        "md-numeric": false
	      }
	    }, [_vm._v(_vm._s(patient.email))]), _vm._v(" "), _c('md-table-cell', [_c('div', [_c('b', [_vm._v(_vm._s(patient.additionalFactors.symptomCount.value))]), _vm._v(" - " + _vm._s(_vm.$t("admin.numberofsymptoms"))), _c('br'), _vm._v(" "), _c('b', [_vm._v(_vm._s(patient.additionalFactors.rescueMedicationCount.value))]), _vm._v(" - " + _vm._s(_vm.$t("admin.rescueMedUsage")) + "\n\t\t\t\t\t")])]), _vm._v(" "), _c('md-table-cell', [_c('md-button', {
	      staticClass: "md-primary",
	      on: {
	        "click": function($event) {
	          _vm.showPatient(patient)
	        }
	      }
	    }, [_vm._v("Adatok")])], 1), _vm._v(" "), _c('md-table-cell', [_c('md-switch', {
	      staticClass: "md-primary",
	      model: {
	        value: (patient.hidden),
	        callback: function($$v) {
	          _vm.$set(patient, "hidden", $$v)
	        },
	        expression: "patient.hidden"
	      }
	    })], 1)], 1) : _vm._e()
	  }))], 1), _vm._v(" "), _c('md-table-pagination', {
	    attrs: {
	      "md-size": _vm.size,
	      "md-total": _vm.patients.length,
	      "md-page": "1",
	      "md-label": "Rows",
	      "md-separator": "of",
	      "md-page-options": [5, 10, 25, 50]
	    },
	    on: {
	      "pagination": _vm.onPagination
	    }
	  })], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 418 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "feed"
	  }, [_c('section', {
	    staticClass: "posts row"
	  }, _vm._l((_vm.posts), function(post) {
	    return _c('div', {
	      staticClass: "post col-md-4 col-xs-12 post-wrapper"
	    }, [_c('md-card', [_c('md-card-media', {
	      staticClass: "post-header",
	      style: ({
	        'background-image': 'url(' + post.image + ')'
	      })
	    }), _vm._v(" "), _c('md-card-header', [_c('div', {
	      staticClass: "md-title"
	    }, [_vm._v(_vm._s(post.title.rendered))])]), _vm._v(" "), _c('md-card-content', [_c('div', {
	      domProps: {
	        "innerHTML": _vm._s(post.excerpt.rendered)
	      }
	    })]), _vm._v(" "), _c('md-card-actions', [_c('a', {
	      attrs: {
	        "href": post.link
	      }
	    }, [_vm._v(_vm._s(_vm.$t("read_more")))])])], 1)], 1)
	  }))])
	},staticRenderFns: []}

/***/ }),
/* 419 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "public-doctor"
	  }, [_c('navbar'), _vm._v(" "), (_vm.status == 0) ? _c('div', [_c('md-progress', {
	    staticClass: "md-accent",
	    attrs: {
	      "md-indeterminate": ""
	    }
	  })], 1) : _vm._e(), _vm._v(" "), (_vm.status == 404) ? _c('div', [_vm._v("\n\t\tAz oldal nem található\n\t")]) : _vm._e(), _vm._v(" "), (_vm.status == 200) ? _c('div', [_c('div', {
	    staticClass: "hero"
	  }, [_c('div', {
	    staticClass: "row col-md-offset-3  col-md-6 between-md"
	  }, [_c('div', {
	    staticClass: "avatar",
	    style: ({
	      'background-image': 'url(' + _vm.profile.avatar + ')'
	    })
	  })])]), _vm._v(" "), _c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "row col-md-offset-3  col-md-6 between-md profile"
	  }, [_c('md-card', [_c('md-card-header', [_c('div', {
	    staticClass: "md-title"
	  }, [_vm._v(_vm._s(_vm.profile.name))])]), _vm._v(" "), _c('md-card-content', {
	    staticClass: "column"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('h3', {
	    staticClass: "col-xs-12"
	  }, [_vm._v("Adatok")]), _vm._v(" "), _c('p', {
	    staticClass: "row"
	  }), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('b', [_vm._v("Szakterület:")]), _vm._v(" " + _vm._s(_vm.profile.doctorData.speciality))]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('b', [_vm._v("Jellemzők:")]), _vm._v(" " + _vm._s(_vm.profile.doctorData.specification))]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('b', [_vm._v("Weboldal:")]), _vm._v(" " + _vm._s(_vm.profile.doctorData.website))]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('b', [_vm._v("Facebook oldal:")]), _vm._v(" " + _vm._s(_vm.profile.doctorData.facebookPageUrl))]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('h3', {
	    staticClass: "col-xs-12"
	  }, [_vm._v("Bemutatkozás")]), _vm._v(" "), _c('p', [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm.profile.doctorData.introduction) + "\n\t\t\t\t\t\t\t")])]), _vm._v(" "), (_vm.profile.doctorData.consultingConfig) ? _c('div', {
	    staticClass: "row"
	  }, [_c('h3', {
	    staticClass: "col-xs-12"
	  }, [_vm._v("Rendelési időpontok")]), _vm._v(" "), _c('p', [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm.profile.doctorData.consultingConfig) + "\n\t\t\t\t\t\t\t")])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "column"
	  }, [_c('h3', {
	    staticClass: "col-xs-12"
	  }, [_vm._v("Kapcsolati adatok")]), _vm._v(" "), (_vm.profile.doctorData.contact.length > 0) ? _c('div', _vm._l((_vm.profile.doctorData.contact), function(contact) {
	    return _c('p', [_vm._v(_vm._s(contact.name) + ": " + _vm._s(contact.value))])
	  })) : _c('div', [_vm._v("\n\t\t\t\t\t\t\t\tNincs megadva\n\t\t\t\t\t\t\t")])])])], 1)], 1)])]) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 420 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "hello"
	  }, [_c('canvas', {
	    attrs: {
	      "id": "animatedLogoCanvas",
	      "width": "240",
	      "height": "240"
	    }
	  })])
	}]}

/***/ }),
/* 421 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "legal"
	  }, [_c('navbar'), _vm._v(" "), _c('section', {
	    staticClass: "content"
	  }, [_c('md-card', [_c('md-card-header', [_c('div', {
	    staticClass: "md-title"
	  }, [_vm._v("Adatkezelési nyilatkozat")])]), _vm._v(" "), _c('md-card-content', [_vm._v("\n\t\t\t\t\tAz alkalmazás jelenleg pilot változatban elérhető, és kipróbálható. A folyamatban lévő fejlesztések és véglegesítések miatt a változások jogát fenntartjuk. Hamarosan frissítjük az adatvédelmi irányelveinket, erről mindenkinek értesítés fogunk küldeni. A pilot fázisban kizárólag saját felelősségére ossza meg az adatok a programban. Az egészségügyi adatokat kizárólag a beteg által kiválasztott orvossal osztjuk meg a rendszerünkön keresztül. Az adatokat kutatási célú felhasználásra csak a felhasználó előzetes beleegyezésével tesszük elérhetővé, amit a program felületén engedélyezhet.\n\t\t\t\t")])], 1), _vm._v(" "), _c('br'), _c('br')], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 422 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('navbar'), _vm._v(" "), _c('div', {
	    staticClass: "admin"
	  }, [(_vm.authorized === true) ? _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-1 col-xs-12"
	  }, [_c('md-whiteframe', {
	    staticClass: "navigation"
	  }, [_c('md-list', [_c('md-list-item', [_c('router-link', {
	    attrs: {
	      "to": "/admin/home"
	    }
	  }, [_c('div', {
	    staticClass: "item"
	  }, [_c('md-icon', [_vm._v("dashboard")]), _c('br'), _vm._v(_vm._s(_vm.$t("home_page")))], 1)])], 1), _vm._v(" "), _c('md-list-item', [_c('router-link', {
	    attrs: {
	      "to": "/admin/patients"
	    }
	  }, [_c('div', {
	    staticClass: "item"
	  }, [_c('md-icon', [_vm._v("accessibility")]), _c('br'), _vm._v(_vm._s(_vm.$t("patients")))], 1)])], 1), _vm._v(" "), (_vm.admin) ? _c('md-list-item', [_c('router-link', {
	    attrs: {
	      "to": "/admin/doctors"
	    }
	  }, [_c('div', {
	    staticClass: "item"
	  }, [_c('md-icon', [_vm._v("local_hospital")]), _c('br'), _vm._v(_vm._s(_vm.$t("admin.doctors")))], 1)])], 1) : _vm._e(), _vm._v(" "), _c('md-list-item', [_c('router-link', {
	    attrs: {
	      "to": "/admin/profile"
	    }
	  }, [_c('div', {
	    staticClass: "item"
	  }, [_c('md-icon', [_vm._v("person")]), _c('br'), _vm._v(" " + _vm._s(_vm.$t("profile")))], 1)])], 1), _vm._v(" "), _c('md-list-item', [_c('router-link', {
	    attrs: {
	      "to": "/admin/feed"
	    }
	  }, [_c('div', {
	    staticClass: "item"
	  }, [_c('md-icon', [_vm._v("public")]), _c('br'), _vm._v(_vm._s(_vm.$t("news")))], 1)])], 1), _vm._v(" "), _c('md-list-item', {
	    nativeOn: {
	      "click": function($event) {
	        _vm.openDialog()
	      }
	    }
	  }, [_c('div', {
	    staticClass: "item"
	  }, [_c('md-icon', [_vm._v("warning")]), _c('br'), _vm._v(_vm._s(_vm.$t("report_problem")))], 1)])], 1)], 1)], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-md col-xs-12"
	  }, [_c('router-view')], 1)]) : _c('div', [_vm._v("\n\t\t\t" + _vm._s(_vm.$t("admin.needsignin")) + "\n\t\t")]), _vm._v(" "), _c('div', {
	    staticClass: "admin-footer"
	  }, [_vm._v("\n\t\t\tPulmoment.com - Build: " + _vm._s(_vm.getHash()) + "\n\t\t")])])], 1)
	},staticRenderFns: []}

/***/ }),
/* 423 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "doctors"
	  }, [_c('md-card', [_c('md-card-header', [_c('div', {
	    staticClass: "md-title"
	  }, [_vm._v(_vm._s(_vm.$t("admin.doctors")))])])], 1), _vm._v(" "), _vm._l((_vm.doctors), function(doctor, index) {
	    return _c('md-card', [_c('md-card-header', [_c('div', {
	      staticClass: "md-title"
	    }, [_vm._v(_vm._s(doctor.name))]), _vm._v(" "), _c('div', {
	      staticClass: "md-subhead"
	    }, [_vm._v(_vm._s(doctor.doctorData.speciality))])]), _vm._v(" "), _c('md-card-content', {
	      staticClass: "row"
	    }, [_c('div', {
	      staticClass: "col-md-6 col-xs-12"
	    }, [_c('b', [_vm._v("Páciensek száma:")]), _vm._v(" " + _vm._s(doctor.patientCount) + "\n\t\t\t")]), _vm._v(" "), _c('div', {
	      staticClass: "col-md-6 col-xs-12"
	    }, [_c('b', [_vm._v("Bejelentkezési e-mail:")]), _vm._v(" " + _vm._s(doctor.email) + "\n\t\t\t")]), _vm._v(" "), _c('div', {
	      staticClass: "col-md-6 col-xs-12"
	    }, [_c('b', [_vm._v("Adatbázis azonosító:")]), _vm._v(" " + _vm._s(doctor._id) + "\n\t\t\t")]), _vm._v(" "), _c('div', {
	      staticClass: "col-xs-12"
	    }, [_c('b', [_vm._v("Bemutatkozás:")]), _c('br'), _vm._v("\n\t\t\t\t" + _vm._s(doctor.doctorData.introduction) + "\n\t\t\t")]), _vm._v(" "), _c('div', {
	      staticClass: "col-xs-12 contentWrapper"
	    }, [_c('h4', [_vm._v("Publikus kapcsolati adatok:")]), _vm._v(" "), _vm._l((doctor.doctorData.contact), function(contact) {
	      return _c('div', [_c('b', [_vm._v(_vm._s(contact.name) + ":")]), _vm._v(" " + _vm._s(contact.value) + "\n\t\t\t\t\t")])
	    })], 2), _vm._v(" "), _c('div', {
	      staticClass: "col-xs-12 contentWrapper"
	    }, [_c('h4', [_vm._v("Statisztikák:")]), _vm._v(" "), _vm._l((doctor.activity), function(activity) {
	      return _c('div', [(activity.type == 'INID.activity.globalViewed') ? _c('div', [_c('b', [_vm._v("Legutolsó belépés:")]), _vm._v(" " + _vm._s(_vm.simpleDate(activity.events[activity.events.length - 1])) + "\n\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (activity.type == 'INID.activity.patientsViewed') ? _c('div', [_c('b', [_vm._v("Páciens lista megtekintve:")]), _vm._v(" " + _vm._s(_vm.simpleDate(activity.events[activity.events.length - 1])) + "\n\t\t\t\t\t")]) : _vm._e()])
	    })], 2)])], 1)
	  })], 2)
	},staticRenderFns: []}

/***/ }),
/* 424 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "missin"
	  }, [_c('navbar'), _vm._v(" "), _c('section', {
	    staticClass: "content"
	  }, [_c('md-card', [_c('md-card-content', [_vm._v("\n\t\t\t\tSajnos a keresett oldal nem található\n\t\t\t")])], 1)], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 425 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "milestones"
	  }, _vm._l((_vm.milestones), function(milestone) {
	    return _c('div', {
	      staticClass: "row"
	    }, [_c('div', {
	      staticClass: "date-col highlight"
	    }, [_c('span', {
	      staticClass: "dot"
	    }), _vm._v(" "), _c('span', {
	      staticClass: "date-text"
	    }, [_vm._v(_vm._s(_vm.$t("milestones." + milestone + ".date")))]), _vm._v(" "), _c('p', {
	      staticClass: "desc"
	    }, [_c('b', [_vm._v(_vm._s(_vm.$t("milestones." + milestone + ".title")))]), _c('br'), _vm._v(_vm._s(_vm.$t("milestones." + milestone + ".desc")) + "\n\t\t\t")])])])
	  }))
	},staticRenderFns: []}

/***/ }),
/* 426 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "chart"
	    }
	  })
	},staticRenderFns: []}

/***/ }),
/* 427 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "patients"
	  }, [_c('md-card', [_c('md-card-header', [_c('div', {
	    staticClass: "md-title"
	  }, [_vm._v(_vm._s(_vm.$t("admin.edit_news")))]), _vm._v(" "), _c('div', {
	    staticClass: "md-subhead"
	  }, [_vm._v(_vm._s(_vm.$t("admin.editnews_note")))])]), _vm._v(" "), _c('md-card-content', [_c('form', {
	    attrs: {
	      "novalidate": ""
	    },
	    on: {
	      "submit": function($event) {
	        $event.stopPropagation();
	        $event.preventDefault();
	        return _vm.newStatus($event)
	      }
	    }
	  }, [_c('md-input-container', [_c('label', [_vm._v(_vm._s(_vm.$t("admin.title")))]), _vm._v(" "), _c('md-input', {
	    model: {
	      value: (_vm.editor.title),
	      callback: function($$v) {
	        _vm.$set(_vm.editor, "title", $$v)
	      },
	      expression: "editor.title"
	    }
	  })], 1), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v(_vm._s(_vm.$t("admin.content")))]), _vm._v(" "), _c('md-textarea', {
	    attrs: {
	      "maxlength": "1500"
	    },
	    model: {
	      value: (_vm.editor.text),
	      callback: function($$v) {
	        _vm.$set(_vm.editor, "text", $$v)
	      },
	      expression: "editor.text"
	    }
	  })], 1), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v(_vm._s(_vm.$t("admin.image")))]), _vm._v(" "), _c('md-file', {
	    attrs: {
	      "id": "fileInput"
	    },
	    model: {
	      value: (_vm.editor.image),
	      callback: function($$v) {
	        _vm.$set(_vm.editor, "image", $$v)
	      },
	      expression: "editor.image"
	    }
	  })], 1), _vm._v(" "), _c('div', [_c('md-radio', {
	    staticClass: "md-primary",
	    attrs: {
	      "md-value": "general"
	    },
	    model: {
	      value: (_vm.editor.type),
	      callback: function($$v) {
	        _vm.$set(_vm.editor, "type", $$v)
	      },
	      expression: "editor.type"
	    }
	  }, [_vm._v(_vm._s(_vm.$t("admin.general")))]), _vm._v(" "), _c('md-radio', {
	    staticClass: "md-primary",
	    attrs: {
	      "md-value": "consultingChange"
	    },
	    model: {
	      value: (_vm.editor.type),
	      callback: function($$v) {
	        _vm.$set(_vm.editor, "type", $$v)
	      },
	      expression: "editor.type"
	    }
	  }, [_vm._v(_vm._s(_vm.$t("admin.change_appointment")))]), _vm._v(" "), _c('md-radio', {
	    staticClass: "md-primary",
	    attrs: {
	      "md-value": "assistance"
	    },
	    model: {
	      value: (_vm.editor.type),
	      callback: function($$v) {
	        _vm.$set(_vm.editor, "type", $$v)
	      },
	      expression: "editor.type"
	    }
	  }, [_vm._v(_vm._s(_vm.$t("admin.substitution")))])], 1), _vm._v(" "), _c('md-switch', {
	    staticClass: "md-primary",
	    model: {
	      value: (_vm.editor.published),
	      callback: function($$v) {
	        _vm.$set(_vm.editor, "published", $$v)
	      },
	      expression: "editor.published"
	    }
	  }, [_vm._v(_vm._s(_vm.$t("admin.release")))]), _vm._v(" "), _c('md-button', {
	    staticClass: "md-raised md-accent",
	    attrs: {
	      "disabled": _vm.loading,
	      "type": "submit"
	    }
	  }, [_vm._v(_vm._s(_vm.$t("admin.save")))])], 1)])], 1), _vm._v(" "), _c('section', {
	    staticClass: "feed row"
	  }, _vm._l((_vm.$store.state.feed), function(status) {
	    return _c('div', {
	      staticClass: "status col-md-4 col-xs-12"
	    }, [_c('md-card', [_c('md-card-header', [_c('div', {
	      staticClass: "md-title"
	    }, [_vm._v(_vm._s(status.title))]), _vm._v(" "), _c('div', {
	      staticClass: "md-subhead"
	    }, [_vm._v(_vm._s(status.creator.name) + " - " + _vm._s(_vm._f("formatDate")(status.createdAt)))])]), _vm._v(" "), _c('md-card-content', [(status.image && status.image != 'null') ? _c('img', {
	      attrs: {
	        "src": status.image
	      }
	    }) : _vm._e(), _vm._v("\n\t\t\t\t\t" + _vm._s(status.text) + "\n\t\t\t\t")])], 1)], 1)
	  }))], 1)
	},staticRenderFns: []}

/***/ }),
/* 428 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "chart"
	    }
	  })
	},staticRenderFns: []}

/***/ }),
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./bg.jpg": 343,
		"./home-bg-doctor.jpg": 344,
		"./home-bg-patient.jpg": 345,
		"./home_bg_patient_white.jpg": 348,
		"./home_phone_cropped_1.jpg": 349,
		"./phone_en_0.jpg": 214,
		"./phone_en_1.jpg": 360,
		"./phone_en_2.jpg": 361,
		"./phone_hu_0.jpg": 362,
		"./phone_hu_1.jpg": 363,
		"./phone_hu_2.jpg": 364
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 435;


/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./bernathlevente.jpg": 371,
		"./bernathlevente_grad.jpg": 372,
		"./damiano_grad.jpg": 373,
		"./ekedaniel.jpg": 374,
		"./ekedaniel_grad.jpg": 375,
		"./rakosifanni_grad.jpg": 376,
		"./szanthoandras.jpg": 377,
		"./szanthoandras_grad.jpg": 378
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 436;


/***/ }),
/* 437 */
/***/ (function(module, exports) {

	/* (ignored) */

/***/ }),
/* 438 */
/***/ (function(module, exports) {

	/* (ignored) */

/***/ })
]);


// WEBPACK FOOTER //
// static/js/app.87ee1d462d231bae38d5.js